// get ag-Grid to create an Angular module and register the ag-Grid directive
agGrid.initialiseAgGridWithAngular1(angular);
(function () {
  'use strict';

  angular.module('musix', [
    'ngAnimate',
    'ngCookies',
    'ngTouch',
    'ngSanitize',
    'ngMessages',
    'ngAria',
    'ngResource',
    'ui.router',
    'ui.bootstrap',
    'cgNotify',
    'ngStorage',
    'angular-cache',
    'angular-loading-bar',
    'Common',
    'Login',
    'agGrid',
    'ui.select',
    'ngLodash',
    'ngFileUpload',
    'ngFileSaver',
    'mwl.confirm',
    'jcs-autoValidate',
    'ljungmann.fileMd5',
    'xeditable',
    'ja.qr',
  ]);
  //    'ui.tinymce',
})();

(function () {
  'use strict';

  angular.module('musix').service('userProfileService', ['userProfileResource', userProfileServiceFunction]);
  userProfileServiceFunction.$inject = ['userProfileResource'];
  /* @ngInject */
  function userProfileServiceFunction(userProfileResource) {
    return {
      updateUserProfile: updateUserProfile,
      GetUserDetailByUserName: GetUserDetailByUserName,
    };

    function GetUserDetailByUserName(data) {
      return userProfileResource.GetUserDetailByUserName(data);
    }

    function updateUserProfile(data) {
      return userProfileResource.updateUserProfile(data);
    }
  }
})();

(function () {
  'use strict';

  angular.module('musix').service('userProfileResource', ['DataService', userProfileResource]);
  userProfileResource.$inject = ['DataService'];
  /* @ngInject */
  function userProfileResource(DataService) {
    return {
      updateUserProfile: updateUserProfile,
      GetUserDetailByUserName: GetUserDetailByUserName,
    };

    function GetUserDetailByUserName(data) {
      var apiConfig = DataService.getDataApiConfig({
        parameter: data,
        showSpinner: true,
      });
      return DataService.get('/user/GetUserDetailByUserName/', apiConfig);
    }

    function updateUserProfile(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data });
      return DataService.post('/user/UpdateUserDetails', apiConfig);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('musix')
    .controller('userProfileCtrl', [
      '$scope',
      '$state',
      'StorageService',
      'Upload',
      'notify',
      'userProfileService',
      'Authorization',
      userProfileCtrl,
    ]);
  userProfileCtrl.inject = ['$scope', '$state', 'StorageService', 'Upload', 'notify', 'userProfileService', 'Authorization'];
  /* @ngInject */
  function userProfileCtrl($scope, $state, StorageService, Upload, notify, userProfileService, Authorization) {
    var vm = this;
    // $scope.$watch('vm.showProfilPic', function() {
    //   $scope.$apply();
    // });

    function init() {
      var UserName = StorageService.getCookie('UserName');
      userProfileService.GetUserDetailByUserName(UserName).then(function (data) {
        vm.formdata = data;
        $scope.showProfilPic = 'data:image/png;base64,' + vm.formdata.UserPhoto;
      });
    }
    init();

    vm.temp = function () {
      Upload.base64DataUrl(vm.newFile1).then(function (data) {
        vm.formdata.UserPhoto = data.split(',')[1];
        $scope.showProfilPic = 'data:image/png;base64,' + vm.formdata.UserPhoto;
      });
    };

    vm.submitRecord = function () {
      vm.formdata.lcode = StorageService.getCookie('UserName');
      vm.submitData = JSON.stringify(vm.formdata, null, 2);

      userProfileService.updateUserProfile(vm.submitData).then(function (data) {
        if (vm.formdata.UserName === data) {
          notify({
            message: 'Profile Updated Successfully.',
            classes: 'alert-success',
          });
          notify({
            message: 'LogIn Again For Updated Profile.',
            classes: 'alert-info',
          });
        }
      });
    };

    vm.cancelForm = function () {
      $state.reload();
    };
  }
})();

(function () {
  'use strict';

  angular.module('musix').service('invoiceService', ['$timeout', '$q', 'invoiceResource', Service]);
  Service.$inject = ['$timeout', '$q', 'invoiceResource'];
  /* @ngInject */
  function Service($timeout, $q, invoiceResource) {
    var InvoiceViewData = {};

    return {
      getInvoiceViewData: getInvoiceViewData,
      setInvoiceViewData: setInvoiceViewData,
      GetInvoiceDetails: GetInvoiceDetails,
      GetInvoiceRecords: GetInvoiceRecords,
      GetIrnForInvoice: GetIrnForInvoice,
      CancelInvoice: CancelInvoice,
      PrintEnvoiceByIrn: PrintEnvoiceByIrn,
      GetInvoiceFromErp: GetInvoiceFromErp,
      ImportSelectedInvoiceFromErpToEnvoice: ImportSelectedInvoiceFromErpToEnvoice,
    };
    function getInvoiceViewData() {
      var deferral = $q.defer();
      $timeout(function () {
        /*
         *  object sent but ag-grid requires array,
         *  either ctrl or service should convert it
         */
        deferral.resolve(InvoiceViewData);
      }, 0);
      return deferral.promise;
    }
    function setInvoiceViewData(value) {
      InvoiceViewData = value;
    }

    function ImportSelectedInvoiceFromErpToEnvoice(data) {
      return invoiceResource.ImportSelectedInvoiceFromErpToEnvoice(data);
    }

    function GetInvoiceFromErp() {
      return invoiceResource.GetInvoiceFromErp();
    }

    function GetInvoiceDetails(data) {
      return invoiceResource.GetInvoiceDetails(data);
    }
    function GetInvoiceRecords(data) {
      return invoiceResource.GetInvoiceRecords(data);
    }
    function GetIrnForInvoice(data) {
      return invoiceResource.GetIrnForInvoice(data);
    }
    function CancelInvoice(data) {
      return invoiceResource.CancelInvoice(data);
    }
    function PrintEnvoiceByIrn(data) {
      return invoiceResource.PrintEnvoiceByIrn(data);
    }
  }
})();

(function () {
  'use strict';

  angular.module('musix').service('invoiceResource', ['DataService', Resource]);
  Resource.$inject = ['DataService'];
  /* @ngInject */
  function Resource(DataService) {
    return {
      GetInvoiceRecords: GetInvoiceRecords,
      GetIrnForInvoice: GetIrnForInvoice,
      CancelInvoice: CancelInvoice,
      PrintEnvoiceByIrn: PrintEnvoiceByIrn,
      GetInvoiceDetails: GetInvoiceDetails,
      GetInvoiceFromErp: GetInvoiceFromErp,
      ImportSelectedInvoiceFromErpToEnvoice: ImportSelectedInvoiceFromErpToEnvoice,
    };
    function GetInvoiceFromErp() {
      var apiConfig = DataService.getDataApiConfig({ showSpinner: true });
      return DataService.get('/envoice/GetInvoiceFromErp', apiConfig);
    }
    function ImportSelectedInvoiceFromErpToEnvoice(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showToaster: true });
      return DataService.post('/envoice/ImportSelectedInvoiceFromErpToEnvoice', apiConfig);
    }
    function GetInvoiceDetails(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showSpinner: true });
      return DataService.post('/envoice/GetInvoiceDetails', apiConfig);
    }
    function GetInvoiceRecords(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showSpinner: true });
      return DataService.post('/envoice/GetInvoiceRecords', apiConfig);
    }
    function GetIrnForInvoice(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showSpinner: true });
      return DataService.post('/gsp/GetIrnForInvoice', apiConfig);
    }
    function CancelInvoice(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showToaster: true });
      return DataService.post('/gsp/CancelEInvoice', apiConfig);
    }
    function PrintEnvoiceByIrn(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showSpinner: true });
      return DataService.post('/gsp/PrintEnvoiceByIrn', apiConfig);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('musix')
    .controller('invoiceCtrl', [
      '$window',
      '$uibModal',
      '$log',
      '$scope',
      '$rootScope',
      '$location',
      '$state',
      'lodash',
      'notify',
      'FileSaver',
      'Blob',
      'dashboardService',
      'invoiceService',
      Controller,
    ]);

  Controller.$inject = [
    '$window',
    '$uibModal',
    '$log',
    '$scope',
    '$rootScope',
    '$location',
    '$state',
    'lodash',
    'notify',
    'FileSaver',
    'Blob',
    'dashboardService',
    'invoiceService',
  ];
  /* @ngInject */
  function Controller(
    $window,
    $uibModal,
    $log,
    $scope,
    $rootScope,
    $location,
    $state,
    lodash,
    notify,
    FileSaver,
    Blob,
    dashboardService,
    invoiceService
  ) {
    var vm = this;
    vm.Title = '';
    vm.CurrentPageNumber = 1;
    vm.formdata = {};
    vm.showErrorList = 0;
    if ($location.path().split('/')[2] === 'einvoice') vm.Section = $location.path().split('/')[4];

    var invoiceimportcolumnDefs = [
      { headerName: 'Supply Type', field: 'TranDtls_SupTyp', maxWidth: 100, checkboxSelection: true },
      { headerName: 'Tax Scheme', field: 'TranDtls_TaxSch', maxWidth: 100 },
      { headerName: 'Doc Type', field: 'DocDtls_Typ', maxWidth: 100 },
      { headerName: 'Doc No', field: 'DocDtls_No' },
      { headerName: 'Doc Date', field: 'DocDtls_Dt' },
      { headerName: 'Buyer', field: 'BuyerDtls_LglNm' },
      // { headerName: 'Ship To', field: 'ShipDtls_LglNm' }
    ];
    var invoiceRecordscolumnDefs = [
      { headerName: 'Supply Type', field: 'TranDtls.SupTyp', maxWidth: 100, checkboxSelection: true },
      { headerName: 'TaxSch', field: 'TranDtls.TaxSch', maxWidth: 100 },
      { headerName: 'Doc Type', field: 'DocDtls.Typ', maxWidth: 100 },
      { headerName: 'Doc No', field: 'DocDtls.No' },
      { headerName: 'Doc Date', field: 'DocDtls.Dt' },
      { headerName: 'Buyer', field: 'BuyerDtls.LglNm' },
      { headerName: 'IRN', field: 'Irn', maxWidth: 100 },
      { headerName: 'AckDate', field: 'AckDate', maxWidth: 200, valueFormatter: dashboardService.datetimeFormatter },
    ];

    var invoiceCancelcolumnDefs = [
      { headerName: 'Supply Type', field: 'TranDtls.SupTyp', maxWidth: 100, checkboxSelection: true },
      { headerName: 'TaxSch', field: 'TranDtls.TaxSch', maxWidth: 100 },
      { headerName: 'Doc Type', field: 'DocDtls.Typ', maxWidth: 100 },
      { headerName: 'Doc No', field: 'DocDtls.No' },
      { headerName: 'Doc Date', field: 'DocDtls.Dt' },
      { headerName: 'Buyer', field: 'BuyerDtls.LglNm' },
      { headerName: 'Cancel Remark', field: 'CnlRem' },
      { headerName: 'Cancel Date', field: 'CancelDate', valueFormatter: dashboardService.datetimeFormatter },
    ];
    //Import Invoice Data From ERP

    vm.ImportSelectedInvoiceFromErpToEnvoice = function () {
      vm.selectedRowData = vm.gridOptions.api.getSelectedRows();
      if (vm.selectedRowData) {
        invoiceService.ImportSelectedInvoiceFromErpToEnvoice(vm.selectedRowData).then(function (data) {
          if (lodash.isObject(data)) {
            // show error list
            vm.formdata.ErrorList = data;
            vm.showErrorList = Object.keys(vm.formdata.ErrorList).length;
            $window.scrollTo(0, 0);
          } else {
            $state.go('app.dashboard');
          }
        });
      }
    };

    vm.SearchRecords = function () {
      vm.CurrentPageNumber = 1;
      vm.gridOptions.api.showLoadingOverlay();
      vm.GetInvoiceRecords(vm.gridOptions.api.getFilterModel(), vm.CurrentPageNumber, vm.gridOptions.api.getFilterInstance('DocDtls.No').filterText);
    };
    vm.PreviousRecordsPage = function () {
      vm.CurrentPageNumber = vm.CurrentPageNumber - 1;
      vm.gridOptions.api.showLoadingOverlay();
      if (vm.CurrentPageNumber === 0) {
        vm.CurrentPageNumber = 1;
        vm.GetInvoiceRecords(
          vm.gridOptions.api.getFilterModel(),
          vm.CurrentPageNumber,
          vm.gridOptions.api.getFilterInstance('DocDtls.No').filterText
        );
      } else {
        vm.GetInvoiceRecords(
          vm.gridOptions.api.getFilterModel(),
          vm.CurrentPageNumber,
          vm.gridOptions.api.getFilterInstance('DocDtls.No').filterText
        );
      }
    };
    vm.NextRecordsPage = function () {
      vm.CurrentPageNumber = vm.CurrentPageNumber + 1;
      vm.gridOptions.api.showLoadingOverlay();
      vm.GetInvoiceRecords(vm.gridOptions.api.getFilterModel(), vm.CurrentPageNumber, vm.gridOptions.api.getFilterInstance('DocDtls.No').filterText);
    };

    vm.GetInvoiceRecords = function (savedFilterModel, PN, DocNo) {
      vm.sendata = {
        PageNumber: PN,
        FuncToCall: vm.Section,
        DocDtls_No: DocNo,
      };
      invoiceService.GetInvoiceRecords(vm.sendata).then(function (data) {
        if (data) {
          if (vm.Section === 'cancelled') {
            vm.gridOptions.api.setColumnDefs(invoiceCancelcolumnDefs);
          }
          vm.gridOptions.api.setRowData(data);
          vm.gridOptions.api.setFilterModel(savedFilterModel);
          vm.gridOptions.columnApi.autoSizeAllColumns();
          invoiceService.setInvoiceViewData({});
        } else vm.gridOptions.api.setRowData([]);
      });
    };
    vm.PrintEnvoicePdf = function () {
      var pdfField = vm.formdata.PdfPrint;
      if (pdfField !== undefined && pdfField !== null && Object.keys(pdfField).length !== 0) {
        var binaryString = atob(pdfField);
        var ab = new ArrayBuffer(binaryString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < binaryString.length; i++) {
          ia[i] = binaryString.charCodeAt(i);
        }
        var data = new Blob([ab], { type: 'application/pdf' });
        FileSaver.saveAs(data, 'EINV-' + vm.formdata.DocDtls.Typ + '-' + vm.formdata.DocDtls.No + '.pdf');
      } else {
        notify({ message: 'Get Print Data from GSP.', classes: 'alert-warning' });
      }
    };

    vm.PrintEnvoiceByIrn = function () {
      if (vm.formdata) {
        invoiceService.PrintEnvoiceByIrn(vm.formdata).then(function (data) {
          if (Object.keys(data).length !== 0) {
            vm.formdata = data;
          } else {
            notify({ message: 'NO data recieved.', classes: 'alert-danger' });
          }
        });
      } else {
        notify({ message: 'Please Select a Record.', classes: 'alert-warning' });
      }
    };

    vm.viewRecord = function () {
      vm.selectedRowData = vm.gridOptions.api.getSelectedRows();
      if (vm.selectedRowData.length === 1) {
        vm.formdata = vm.selectedRowData[0];
        invoiceService.setInvoiceViewData(vm.formdata);
        $state.go('app.einvoice.invoice.view');
      } else {
        notify({ message: 'Select A Record To View', classes: 'alert-warning' });
      }
    };

    vm.init = function () {
      //Get InvoiceDetail Data
      if (vm.Section === 'view') {
        invoiceService.getInvoiceViewData().then(function (data) {
          if (Object.keys(data).length !== 0) {
            vm.formdata = data;
            vm.sendata = {
              DocDtls_No: vm.formdata.DocDtls.No,
            };
            invoiceService.GetInvoiceDetails(vm.sendata).then(function (data) {
              if (Object.keys(data.ItemList).length !== 0) {
                vm.formdata.ItemList = data.ItemList;
                vm.formdata.RefDtls.PrecDocDtls = data.RefDtls_PrecDocDtls;
                vm.formdata.RefDtls.ContrDtls = data.RefDtls_ContrDtls;
                vm.formdata.AddlDocDtls = data.AddlDocDtls;
                vm.formdata.ErrorList = data.ErrorList;
                vm.showErrorList = Object.keys(vm.formdata.ErrorList).length;
              } else notify({ message: 'No Record Data Found. Please select another record.', classes: 'alert-danger' });
            });
          } else {
            notify({ message: 'No Record Selected.', classes: 'alert-danger' });
          }
        });
      } else if (vm.Section === 'import') {
        vm.Title = 'Invoice From ERP';
        invoiceService.GetInvoiceFromErp().then(function (data) {
          if (data) {
            vm.gridOptions.api.setColumnDefs(invoiceimportcolumnDefs);
            vm.gridOptions.api.setRowData(data);
            vm.gridOptions.columnApi.autoSizeAllColumns();
          } else vm.gridOptions.api.setRowData([]);
        });
      } else {
        //  vm.gridOptions.api.setColumnDefs(invoiceRecordscolumnDefs);
        if (vm.Section === 'forirn') {
          vm.Title = 'Get IRN for Invoice';
        }
        if (vm.Section === 'withirn') {
          vm.Title = 'Invoice Records';
        }
        if (vm.Section === 'cancelled') {
          vm.Title = 'Cancelled Invoice Records';
        }
        vm.GetInvoiceRecords(null, vm.CurrentPageNumber, null);
      }
    };
    vm.init();

    vm.GetIrnForInvoice = function () {
      if (vm.formdata) {
        invoiceService.GetIrnForInvoice(JSON.stringify(vm.formdata)).then(function (data) {
          if (data !== null) {
            if (data.hasOwnProperty('InvoiceId') && data.hasOwnProperty('Irn')) {
              vm.formdata = data;
              $window.scrollTo(0, 0);
              notify({ message: 'Irn : ' + data.Irn, classes: 'alert-info' });
            } else {
              vm.formdata.ErrorList = data;
              vm.showErrorList = Object.keys(vm.formdata.ErrorList).length;
              $window.scrollTo(0, 0);
            }
          }
        });
      } else {
        notify({ message: 'Please Select a Record.', classes: 'alert-warning' });
      }
    };

    //If Invoice Cancellation confirmed. Send data to Portal.
    vm.CancelInvoiceConfirm = function () {
      if (vm.formdata) {
        invoiceService.CancelInvoice(JSON.stringify(vm.formdata)).then(function (data) {
          if (data !== null) {
            //$state.reload();
            $state.go('app.einvoice.invoice.withirn', {}, { reload: true });
          }
        });
      } else {
        notify({ message: 'Please Select a Record.', classes: 'alert-warning' });
      }
    };
    //If Invoice Cancellation not confirmed/cancelled. Take to home screen.
    vm.CancelInvoiceCancelled = function () {
      //  vm.gridOptions.api.deselectAll();
      notify({ message: 'Invoice Cancellation Stopped.', classes: 'alert-info' });
      $state.go('app.dashboard');
    };

    /**
     * @ngDoc function
     * @name gridOptions
     * @description for initializing grid
     * @param  none
     * @returns none
     */
    vm.gridOptions = {
      columnDefs: invoiceRecordscolumnDefs,
      //suppressMenuHide: true,
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      suppressDragLeaveHidesColumns: true,
      floatingFilter: true,
      rowSelection: 'multiple',
      rowDeselection: true,
      animateRows: true,
      angularCompileRows: true,
      // getRowStyle: function (params) {
      //   if (params.data.CnlRsn) {
      //     return { 'background-color': 'lightcoral' };
      //   }
      //   return null;
      // },
    };
  }
})();

(function () {
  'use strict';

  angular.module('musix').service('ewayInvoiceService', ['$timeout', '$q', 'ewayInvoiceResource', Service]);
  Service.$inject = ['$timeout', '$q', 'ewayInvoiceResource'];
  /* @ngInject */
  function Service($timeout, $q, ewayInvoiceResource) {
    var InvoiceViewData = {};

    return {
      getInvoiceViewData: getInvoiceViewData,
      setInvoiceViewData: setInvoiceViewData,
      GetInvoiceRecords: GetInvoiceRecords,
      GetEwbForInvoice: GetEwbForInvoice,
      CancelInvoice: CancelInvoice,
      CloseInvoice: CloseInvoice,
      PrintEwayFromWebtel: PrintEwayFromWebtel,
      GetInvoiceFromErp: GetInvoiceFromErp,
      ImportSelectedInvoiceFromErp: ImportSelectedInvoiceFromErp,
    };
    function getInvoiceViewData() {
      var deferral = $q.defer();
      $timeout(function () {
        /*
         *  object sent but ag-grid requires array,
         *  either ctrl or service should convert it
         */
        deferral.resolve(InvoiceViewData);
      }, 0);
      return deferral.promise;
    }
    function setInvoiceViewData(value) {
      InvoiceViewData = value;
    }

    function ImportSelectedInvoiceFromErp(data) {
      return ewayInvoiceResource.ImportSelectedInvoiceFromErp(data);
    }

    function GetInvoiceFromErp() {
      return ewayInvoiceResource.GetInvoiceFromErp();
    }
    function GetInvoiceRecords(data) {
      return ewayInvoiceResource.GetInvoiceRecords(data);
    }
    function GetEwbForInvoice(data) {
      return ewayInvoiceResource.GetEwbForInvoice(data);
    }
    function CancelInvoice(data) {
      return ewayInvoiceResource.CancelInvoice(data);
    }
    function CloseInvoice(data) {
      return ewayInvoiceResource.CloseInvoice(data);
    }
    

    function PrintEwayFromWebtel(data) {
      return ewayInvoiceResource.PrintEwayFromWebtel(data);
    }
  }
})();

(function () {
  'use strict';

  angular.module('musix').service('ewayInvoiceResource', ['DataService', Resource]);
  Resource.$inject = ['DataService'];
  /* @ngInject */
  function Resource(DataService) {
    return {
      GetInvoiceRecords: GetInvoiceRecords,
      GetEwbForInvoice: GetEwbForInvoice,
      CancelInvoice: CancelInvoice,
      CloseInvoice:CloseInvoice,
      PrintEwayFromWebtel: PrintEwayFromWebtel,
      GetInvoiceFromErp: GetInvoiceFromErp,
      ImportSelectedInvoiceFromErp: ImportSelectedInvoiceFromErp,
    };
    function GetInvoiceFromErp() {
      var apiConfig = DataService.getDataApiConfig({ showSpinner: true, showToaster: true });
      return DataService.get('/eway/GetInvoiceFromErp', apiConfig);
    }
    function ImportSelectedInvoiceFromErp(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showToaster: true });
      return DataService.post('/eway/ImportSelectedInvoiceFromErp', apiConfig);
    }
    function GetInvoiceRecords(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showSpinner: true });
      return DataService.post('/eway/GetInvoiceRecords', apiConfig);
    }
    function GetEwbForInvoice(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showSpinner: true });
      return DataService.post('/gsp/GetEwbForInvoice', apiConfig);
    }
    function CloseInvoice(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showToaster: true, showSpinner: true });
      return DataService.post('/gsp/CloseEwayBill', apiConfig);
    }
    function CancelInvoice(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showToaster: true, showSpinner: true });
      return DataService.post('/gsp/CancelInvoice', apiConfig);
    }
    function PrintEwayFromWebtel(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showSpinner: true });
      return DataService.post('/gsp/PrintEwayFromWebtel', apiConfig);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('musix')
    .controller('ewayInvoiceCtrl', [
      '$window',
      '$uibModal',
      '$timeout',
      '$scope',
      '$rootScope',
      '$location',
      '$state',
      'lodash',
      'notify',
      'FileSaver',
      'Blob',
      'dashboardService',
      'ewayInvoiceService',
      Controller,
    ]);

  Controller.$inject = [
    '$window',
    '$uibModal',
    '$timeout',
    '$scope',
    '$rootScope',
    '$location',
    '$state',
    'lodash',
    'notify',
    'FileSaver',
    'Blob',
    'dashboardService',
    'ewayInvoiceService',
  ];
  /* @ngInject */
  function Controller(
    $window,
    $uibModal,
    $timeout,
    $scope,
    $rootScope,
    $location,
    $state,
    lodash,
    notify,
    FileSaver,
    Blob,
    dashboardService,
    ewayInvoiceService
  ) {
    var vm = this;
    vm.Title = '';
    vm.CurrentPageNumber = 1;
    vm.formdata = {};
    vm.showErrorList = 0;
    vm.minCloseDate = null;
    if ($location.path().split('/')[2] === 'eway') vm.Section = $location.path().split('/')[4];

    vm.isAfterCutoffDate = function (dateStr) {
      if (!dateStr) return false;
      var cutoffDate = new Date(2026, 4, 15); // June 15, 2026

      if (dateStr.indexOf('T') !== -1 || dateStr.indexOf('-') !== -1) {
        return new Date(dateStr) > cutoffDate;
      }

      // Parse DD/MM/YYYY into a JavaScript Date object
      var parts = dateStr.split('/');
      if (parts.length !== 3) return false;

      // Note: JS months are 0-indexed (5 = June)
      var billDate = new Date(parts[2], parts[1] - 1, parts[0]);
      console.log(billDate);
      console.log(cutoffDate);
      return billDate > cutoffDate;
    };

    var invoiceimportcolumnDefs = [
      { headerName: 'Doc Type', field: 'docType', checkboxSelection: true },
      { headerName: 'Doc No', field: 'docNo' },
      { headerName: 'Doc Date', field: 'docDate' },
      { headerName: 'Supply Type', field: 'supplyType' },
      { headerName: 'Sub Supply', field: 'subSupplyType' },
      { headerName: 'Buyer', field: 'toTrdName', maxWidth: 150 },
      // { headerName: 'Ship To', field: 'ShipDtls_LglNm' }
    ];
    var invoiceRecordscolumnDefs = [
      { headerName: 'Doc Type', field: 'docType', checkboxSelection: true },
      { headerName: 'Doc No', field: 'docNo' },
      { headerName: 'Doc Date', field: 'docDate' },
      { headerName: 'Supply Type', field: 'supplyType' },
      { headerName: 'Sub Supply', field: 'subSupplyType' },
      { headerName: 'Buyer', field: 'toTrdName', maxWidth: 150 },
      { headerName: 'EWB No', field: 'ewayBillNo' },
      { headerName: 'EWB Date', field: 'ewayBillDate', valueFormatter: dashboardService.datetimeFormatter },
    ];
    var invoiceCancelcolumnDefs = [
      { headerName: 'Doc Type', field: 'docType', checkboxSelection: true },
      { headerName: 'Doc No', field: 'docNo' },
      { headerName: 'Doc Date', field: 'docDate' },
      { headerName: 'Supply Type', field: 'supplyType' },
      { headerName: 'Sub Supply', field: 'subSupplyType' },
      { headerName: 'Buyer', field: 'toTrdName', maxWidth: 150 },
      { headerName: 'Cancel Remark', field: 'CancelRemark' },
      { headerName: 'Cancel Date', field: 'CancelDate', valueFormatter: dashboardService.datetimeFormatter },
    ];

    //Import Invoice Data From ERP

    vm.ImportSelectedInvoiceFromErp = function () {
      vm.selectedRowData = vm.gridOptions.api.getSelectedRows();
      if (vm.selectedRowData) {
        ewayInvoiceService.ImportSelectedInvoiceFromErp(vm.selectedRowData).then(function (data) {
          if (typeof data === 'object' && !Array.isArray(data) && data !== null) {
            vm.formdata.ErrorList = data;
            vm.showErrorList = Object.keys(vm.formdata.ErrorList).length;
            $window.scrollTo(0, 0);
          } else {
            $state.go('app.dashboard', {}, { reload: true });
          }
        });
      }
    };

    vm.SearchRecords = function () {
      vm.CurrentPageNumber = 1;
      vm.gridOptions.api.showLoadingOverlay();
      vm.GetInvoiceRecords(vm.gridOptions.api.getFilterModel(), vm.CurrentPageNumber, vm.gridOptions.api.getFilterInstance('docNo').filterText);
    };
    vm.PreviousRecordsPage = function () {
      vm.CurrentPageNumber = vm.CurrentPageNumber - 1;
      vm.gridOptions.api.showLoadingOverlay();
      if (vm.CurrentPageNumber === 0) {
        vm.CurrentPageNumber = 1;
        vm.GetInvoiceRecords(vm.gridOptions.api.getFilterModel(), vm.CurrentPageNumber, vm.gridOptions.api.getFilterInstance('docNo').filterText);
      } else {
        vm.GetInvoiceRecords(vm.gridOptions.api.getFilterModel(), vm.CurrentPageNumber, vm.gridOptions.api.getFilterInstance('docNo').filterText);
      }
    };
    vm.NextRecordsPage = function () {
      vm.CurrentPageNumber = vm.CurrentPageNumber + 1;
      vm.gridOptions.api.showLoadingOverlay();
      vm.GetInvoiceRecords(vm.gridOptions.api.getFilterModel(), vm.CurrentPageNumber, vm.gridOptions.api.getFilterInstance('docNo').filterText);
    };

    vm.GetInvoiceRecords = function (savedFilterModel, PN, DocNo) {
      vm.sendata = {
        PageNumber: PN,
        FuncToCall: vm.Section,
        docNo: DocNo,
      };

      ewayInvoiceService.GetInvoiceRecords(vm.sendata).then(function (data) {
        if (data) {
          if (vm.Section === 'cancelled') {
            vm.gridOptions.api.setColumnDefs(invoiceCancelcolumnDefs);
          }
          vm.gridOptions.api.setRowData(data);
          vm.gridOptions.columnApi.autoSizeAllColumns();
          vm.gridOptions.api.setFilterModel(savedFilterModel);
          ewayInvoiceService.setInvoiceViewData({});
        } else vm.gridOptions.api.setRowData([]);
      });
    };

    vm.PrintEwayPdf = function (pdfType) {
      // vm.selectedRowData = vm.gridOptions.api.getSelectedRows();
      // vm.formdata = vm.selectedRowData[0];
      var pdfField = vm.formdata.PdfPrintSummary;
      if (pdfType === 'Detail') pdfField = vm.formdata.PdfPrintDetail;

      if (pdfField !== undefined && pdfField !== null && Object.keys(pdfField).length !== 0) {
        var binaryString = atob(pdfField);
        var ab = new ArrayBuffer(binaryString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < binaryString.length; i++) {
          ia[i] = binaryString.charCodeAt(i);
        }
        var data = new Blob([ab], { type: 'application/pdf' });
        if (pdfType === 'Summary') FileSaver.saveAs(data, 'EWAY-' + vm.formdata.docType + '-' + vm.formdata.docNo + '-S.pdf');
        else FileSaver.saveAs(data, 'EWAY-' + vm.formdata.docType + '-' + vm.formdata.docNo + '-D.pdf');
      } else {
        notify({ message: 'Get Print Data from GSP.', classes: 'alert-warning' });
      }
    };

    vm.PrintEwayFromWebtel = function () {
      if (vm.formdata) {
        ewayInvoiceService.PrintEwayFromWebtel(vm.formdata).then(function (data) {
          if (Object.keys(data).length !== 0) {
            vm.formdata = data;
          } else {
            notify({ message: 'NO data recieved.', classes: 'alert-danger' });
          }
        });
      } else {
        notify({ message: 'Please Select a Record.', classes: 'alert-warning' });
      }
    };

    vm.viewRecord = function () {
      vm.selectedRowData = vm.gridOptions.api.getSelectedRows();
      if (vm.selectedRowData.length === 1) {
        vm.formdata = vm.selectedRowData[0];
        ewayInvoiceService.setInvoiceViewData(vm.formdata);
        $state.go('app.eway.invoice.view');
      } else {
        notify({ message: 'Select A Record To View', classes: 'alert-warning' });
      }
    };

    vm.init = function () {
      //Get InvoiceDetail Data
      if (vm.Section === 'view') {
        ewayInvoiceService.getInvoiceViewData().then(function (data) {
          if (Object.keys(data).length !== 0) {
            vm.formdata = data;
            if (vm.formdata.ewayBillDate) {
              if (vm.formdata.ewayBillDate.indexOf('T') !== -1 || vm.formdata.ewayBillDate.indexOf('-') !== -1) {
                vm.minCloseDate = new Date(vm.formdata.ewayBillDate);
              } else {
                var parts = vm.formdata.ewayBillDate.split('/');
                console.log(parts);
                if (parts.length === 3) {
                  vm.minCloseDate = new Date(parts[2], parts[1] - 1, parts[0]);
                  console.log(vm.minCloseDate);
                }
              }
              if (vm.minCloseDate) {
                vm.minCloseDate.setDate(vm.minCloseDate.getDate() + 1);
              }
            }
          } else {
            notify({ message: 'No Record Selected.', classes: 'alert-danger' });
          }
        });
      } else if (vm.Section === 'import') {
        vm.Title = 'Invoice From ERP';
        ewayInvoiceService.GetInvoiceFromErp().then(function (data) {
          if (data) {
            vm.gridOptions.api.setColumnDefs(invoiceimportcolumnDefs);
            vm.gridOptions.api.setRowData(data);
            vm.gridOptions.columnApi.autoSizeAllColumns();
          } else vm.gridOptions.api.setRowData([]);
        });
      } else {
        //  vm.gridOptions.api.setColumnDefs(invoiceRecordscolumnDefs);
        if (vm.Section === 'forewb') {
          vm.Title = 'Get EWB for Invoice';
        }
        if (vm.Section === 'withewb') {
          vm.Title = 'Invoice Records with EWB';
        }
        if (vm.Section === 'cancelled') {
          vm.Title = 'Cancelled Invoice Records';
        }
        if (vm.Section === 'forclose') {
          vm.Title = 'EwayBill For Closing';
        }
        vm.GetInvoiceRecords(null, vm.CurrentPageNumber, null);
      }
    };
    vm.init();

    vm.GetEwbForInvoice = function () {
      if (vm.formdata) {
        ewayInvoiceService.GetEwbForInvoice(JSON.stringify(vm.formdata)).then(function (data) {
          if (data !== null) {
            vm.formdata = data;
            notify({ message: 'Ewaybill No : ' + vm.formdata.ewayBillNo, classes: 'alert-success' });
            notify({ message: 'Get Print Data From GSP.', classes: 'alert-info' });
            $window.scrollTo(0, 0);
          }
        });
      } else {
        notify({ message: 'Please Select a Record.', classes: 'alert-warning' });
      }
    };

    //If Invoice Cancellation confirmed. Send data to Portal.
    vm.CancelInvoiceConfirm = function () {
      if (vm.formdata) {
        ewayInvoiceService.CancelInvoice(JSON.stringify(vm.formdata)).then(function (data) {
          notify({ message: data, classes: 'alert-info' });
          if (data !== null) {
            //$state.reload();
            $state.go('app.dashboard', {}, { reload: true });
          }
        });
      } else {
        notify({ message: 'Please Select a Record.', classes: 'alert-warning' });
      }
    };
    //If Invoice Cancellation not confirmed/cancelled. Take to home screen.
    vm.CancelInvoiceCancelled = function () {
      //  vm.gridOptions.api.deselectAll();
      notify({ message: 'Invoice Cancellation Stopped.', classes: 'alert-info' });
      $state.go('app.dashboard');
    };

    //If EwayBill Closing confirmed. Send data to Portal.
    vm.CloseInvoiceConfirm = function () {
      if (vm.formdata) {
        ewayInvoiceService.CloseInvoice(JSON.stringify(vm.formdata)).then(function (data) {
          notify({ message: data, classes: 'alert-info' });
          if (data !== null) {
            //$state.reload();
            $state.go('app.dashboard', {}, { reload: true });
          }
        });
      } else {
        notify({ message: 'Please Select a Record.', classes: 'alert-warning' });
      }
    };
    //If Invoice Cancellation not confirmed/cancelled. Take to home screen.
    vm.CloseInvoiceCancelled = function () {
      //  vm.gridOptions.api.deselectAll();
      notify({ message: 'EwayBill Closing Stopped.', classes: 'alert-info' });
      $state.go('app.dashboard');
    };

    /**
     * @ngDoc function
     * @name gridOptions
     * @description for initializing grid
     * @param  none
     * @returns none
     */
    vm.gridOptions = {
      columnDefs: invoiceRecordscolumnDefs,
      //suppressMenuHide: true,
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      suppressDragLeaveHidesColumns: true,
      floatingFilter: true,
      rowSelection: 'multiple',
      rowDeselection: true,
      animateRows: true,
      angularCompileRows: true,
      onGridReady: function () {
        vm.gridOptions.api.sizeColumnsToFit();
      },
      getRowStyle: function (params) {
        // if (params.data.CancelRemark) {
        //   return { 'background-color': 'lightcoral' };
        // }
        // if (params.data.ewayBillNo && params.data.PdfPrintSummary === null) {
        //   return { 'background-color': 'LightYellow' };
        // }
        // if (params.data.ewayBillNo && params.data.PdfPrintDetail === null) {
        //   return { 'background-color': 'LightYellow' };
        // }
        return null;
      },
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('musix')
    .service('envoicemasterService', ['envoicemasterResource', Service]);
  Service.$inject = ['envoicemasterResource'];
  /* @ngInject */
  function Service(envoicemasterResource) {
    return {
      GetAllMasters: GetAllMasters
    };

    function GetAllMasters(data) {
      return envoicemasterResource.GetAllMasters(data);
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('musix')
    .service('envoicemasterResource', ['DataService', Resource]);
  Resource.$inject = ['DataService'];
  /* @ngInject */
  function Resource(DataService) {
    return {
      GetAllMasters: GetAllMasters,
    };

    function GetAllMasters(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showToaster: true });
      return DataService.get("/envoice/GetAllMasters/", apiConfig);

    }
  }
})();

(function () {
  'use strict';

  angular.module('musix').controller('envoicemasterCtrl', ['lodash', 'notify', '$location', 'envoicemasterService', Controller]);

  Controller.$inject = ['lodash', 'notify', '$location', 'envoicemasterService'];
  /* @ngInject */
  function Controller(lodash, notify, $location, envoicemasterService) {
    var vm = this;
    vm.MasterName = '';
    var columnDefs = [];
    var Section = $location.path().split('/');

    if (Section[4] === 'cancellationreason') {
      vm.MasterName = 'Cancellation Reason';

      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Description' },
      ];
    }
    if (Section[4] === 'country') {
      vm.MasterName = 'Country';

      columnDefs = [
        { headerName: 'Country Code', field: 'Country Code', width: 50 },
        { headerName: 'Country Name', field: 'Country Name' },
      ];
    }
    if (Section[4] === 'currency') {
      vm.MasterName = 'Currency';

      columnDefs = [
        { headerName: 'Currency Code', field: 'Currency Code', width: 50 },
        { headerName: 'Currency Name', field: 'Currency Name' },
      ];
    }
    if (Section[4] === 'documenttype') {
      vm.MasterName = 'Document Type';

      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Description' },
      ];
    }
    if (Section[4] === 'errorlist') {
      vm.MasterName = 'Error List';

      columnDefs = [
        { headerName: 'ErrorCode', field: 'ErrorCode' },
        { headerName: 'ErrorType', field: 'ErrorType' },
        { headerName: 'ErrorMessage', field: 'ErrorMessage' },
        { headerName: 'ReasonForError', field: 'ReasonForError' },
        { headerName: 'Resolution', field: 'Resolution' },
      ];
    }
    if (Section[4] === 'ewaybilltransportmode') {
      vm.MasterName = 'EwayBill Transport Mode';

      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Description' },
      ];
    }
    if (Section[4] === 'ewaybillvehicletype') {
      vm.MasterName = 'Ewaybill Vehicle Type';

      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Description' },
      ];
    }
    if (Section[4] === 'gsttaxrate') {
      vm.MasterName = 'GST Tax Rate';

      columnDefs = [{ headerName: 'GST Tax Rates', field: 'GST Tax Rates', width: 50 }];
    }
    if (Section[4] === 'port') {
      vm.MasterName = 'Port';

      columnDefs = [
        { headerName: 'PortCode', field: 'PortCode', width: 50 },
        { headerName: 'PortName', field: 'PortName' },
      ];
    }
    if (Section[4] === 'state') {
      vm.MasterName = 'State';

      columnDefs = [
        { headerName: 'State Code', field: 'State Code', width: 50 },
        { headerName: 'State Name', field: 'State Name' },
      ];
    }
    if (Section[4] === 'typeoftransaction') {
      vm.MasterName = 'Type Of Transaction';

      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Description' },
      ];
    }
    if (Section[4] === 'unit') {
      vm.MasterName = 'Unit';

      columnDefs = [
        { headerName: 'Unit Code', field: 'Unit Code', width: 50 },
        { headerName: 'Unit Description', field: 'Unit Description' },
      ];
    }

    envoicemasterService.GetAllMasters(Section[4]).then(function (data) {
      if (data) {
        vm.gridOptions.api.setRowData(data);
        vm.gridOptions.columnApi.autoSizeAllColumns();
      } else vm.gridOptions.api.setRowData([]);
    });

    /**
     * @ngDoc function
     * @name gridOptions
     * @description for initializing grid
     * @param  none
     * @returns none
     */
    vm.gridOptions = {
      columnDefs: columnDefs,
      angularCompileRows: true,
      //suppressMenuHide: true,
      enableColResize: true,
      suppressDragLeaveHidesColumns: true,
      enableSorting: true,
      enableFilter: true,
      floatingFilter: true,
      rowSelection: 'single',
      rowDeselection: true,
      // rowHeight: 48,
      animateRows: true,
      onGridReady: function () {
        vm.gridOptions.api.sizeColumnsToFit();
      },
    };
  }
})();

(function () {
  'use strict';

  angular.module('musix').service('ewayMasterService', ['ewayMasterResource', Service]);
  Service.$inject = ['ewayMasterResource'];
  /* @ngInject */
  function Service(ewayMasterResource) {
    return {
      GetAllMasters: GetAllMasters,
    };

    function GetAllMasters(data) {
      return ewayMasterResource.GetAllMasters(data);
    }
  }
})();

(function () {
  'use strict';

  angular.module('musix').service('ewayMasterResource', ['DataService', Resource]);
  Resource.$inject = ['DataService'];
  /* @ngInject */
  function Resource(DataService) {
    return {
      GetAllMasters: GetAllMasters,
    };

    function GetAllMasters(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showToaster: true });
      return DataService.get('/eway/GetAllMasters/', apiConfig);
    }
  }
})();

(function () {
  'use strict';

  angular.module('musix').controller('ewayMasterCtrl', ['lodash', 'notify', '$location', 'ewayMasterService', Controller]);

  Controller.$inject = ['lodash', 'notify', '$location', 'ewayMasterService'];
  /* @ngInject */
  function Controller(lodash, notify, $location, ewayMasterService) {
    var vm = this;
    vm.MasterName = '';
    var columnDefs = [];
    vm.Section = $location.path().split('/');

    if (vm.Section[4] === 'errorlist') {
      vm.MasterName = 'Error List';

      columnDefs = [
        { headerName: 'ErrorCode', field: 'ErrorCode' },
        { headerName: 'ErrorType', field: 'ErrorType' },
        { headerName: 'ErrorMessage', field: 'ErrorMessage' },
        { headerName: 'ReasonForError', field: 'ReasonForError' },
        { headerName: 'Resolution', field: 'Resolution' },
      ];
    }
    if (vm.Section[4] === 'BillStatus') {
      vm.MasterName = 'BillStatus';
      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Desc', width: 100 },
      ];
    }
    if (vm.Section[4] === 'CancelReason') {
      vm.MasterName = 'CancelReason';
      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Desc', width: 100 },
      ];
    }
    if (vm.Section[4] === 'ConsignStatus') {
      vm.MasterName = 'ConsignStatus';
      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Desc', width: 100 },
      ];
    }
    if (vm.Section[4] === 'DocType') {
      vm.MasterName = 'DocType';
      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Desc', width: 100 },
      ];
    }
    if (vm.Section[4] === 'ErrorCode') {
      vm.MasterName = 'ErrorCode';
      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Desc', width: 100 },
      ];
    }
    if (vm.Section[4] === 'GenMode') {
      vm.MasterName = 'GenMode';
      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Desc', width: 100 },
      ];
    }
    if (vm.Section[4] === 'StateCode') {
      vm.MasterName = 'StateCode';
      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Desc', width: 100 },
      ];
    }
    if (vm.Section[4] === 'SubSupplyType') {
      vm.MasterName = 'SubSupplyType';
      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Desc', width: 100 },
      ];
    }
    if (vm.Section[4] === 'SupplyType') {
      vm.MasterName = 'SupplyType';
      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Desc', width: 100 },
      ];
    }
    if (vm.Section[4] === 'TransMode') {
      vm.MasterName = 'TransMode';
      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Desc', width: 100 },
      ];
    }
    if (vm.Section[4] === 'TransType') {
      vm.MasterName = 'TransType';
      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Desc', width: 100 },
      ];
    }
    if (vm.Section[4] === 'Unit') {
      vm.MasterName = 'Unit';
      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Desc', width: 100 },
      ];
    }
    if (vm.Section[4] === 'ValExtReason') {
      vm.MasterName = 'ValExtReason';
      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Desc', width: 100 },
      ];
    }
    if (vm.Section[4] === 'VehicleType') {
      vm.MasterName = 'VehicleType';
      columnDefs = [
        { headerName: 'Code', field: 'Code', width: 50 },
        { headerName: 'Description', field: 'Desc', width: 100 },
      ];
    }

    if (vm.Section[4] !== 'ValidVehicleNumber' || vm.Section[4] !== 'TaxRates' || vm.Section[4] !== 'SupplyDocType') {
      ewayMasterService.GetAllMasters(vm.Section[4]).then(function (data) {
        if (data) {
          vm.gridOptions.api.setRowData(data);
          vm.gridOptions.columnApi.autoSizeAllColumns();
        } else vm.gridOptions.api.setRowData([]);
      });
    }

    /**
     * @ngDoc function
     * @name gridOptions
     * @description for initializing grid
     * @param  none
     * @returns none
     */
    vm.gridOptions = {
      columnDefs: columnDefs,
      angularCompileRows: true,
      //suppressMenuHide: true,
      enableColResize: true,
      suppressDragLeaveHidesColumns: true,
      enableSorting: true,
      enableFilter: true,
      floatingFilter: true,
      rowSelection: 'single',
      rowDeselection: true,
      // rowHeight: 48,
      animateRows: true,
      onGridReady: function () {
        vm.gridOptions.api.sizeColumnsToFit();
      },
    };
  }
})();

/* eslint-disable */

/*! Copyright (c) 2011 Piotr Rochala (http://rocha.la)
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 *
 * Version: 1.3.6
 *
 */
(function (e) {
  e.fn.extend({
    slimScroll: function (g) {
      var a = e.extend(
        {
          width: 'auto',
          height: '250px',
          size: '7px',
          color: '#000',
          position: 'right',
          distance: '1px',
          start: 'top',
          opacity: 0.4,
          alwaysVisible: !1,
          disableFadeOut: !1,
          railVisible: !1,
          railColor: '#333',
          railOpacity: 0.2,
          railDraggable: !0,
          railClass: 'slimScrollRail',
          barClass: 'slimScrollBar',
          wrapperClass: 'slimScrollDiv',
          allowPageScroll: !1,
          wheelStep: 20,
          touchScrollStep: 200,
          borderRadius: '7px',
          railBorderRadius: '7px',
        },
        g
      );
      this.each(function () {
        function v(d) {
          if (r) {
            d = d || window.event;
            var c = 0;
            d.wheelDelta && (c = -d.wheelDelta / 120);
            d.detail && (c = d.detail / 3);
            e(d.target || d.srcTarget || d.srcElement)
              .closest('.' + a.wrapperClass)
              .is(b.parent()) && m(c, !0);
            d.preventDefault && !k && d.preventDefault();
            k || (d.returnValue = !1);
          }
        }
        function m(d, e, g) {
          k = !1;
          var f = d,
            h = b.outerHeight() - c.outerHeight();
          e &&
            ((f = parseInt(c.css('top')) + ((d * parseInt(a.wheelStep)) / 100) * c.outerHeight()),
            (f = Math.min(Math.max(f, 0), h)),
            (f = 0 < d ? Math.ceil(f) : Math.floor(f)),
            c.css({ top: f + 'px' }));
          l = parseInt(c.css('top')) / (b.outerHeight() - c.outerHeight());
          f = l * (b[0].scrollHeight - b.outerHeight());
          g && ((f = d), (d = (f / b[0].scrollHeight) * b.outerHeight()), (d = Math.min(Math.max(d, 0), h)), c.css({ top: d + 'px' }));
          b.scrollTop(f);
          b.trigger('slimscrolling', ~~f);
          w();
          p();
        }
        function x() {
          u = Math.max((b.outerHeight() / b[0].scrollHeight) * b.outerHeight(), 30);
          c.css({ height: u + 'px' });
          var a = u == b.outerHeight() ? 'none' : 'block';
          c.css({ display: a });
        }
        function w() {
          x();
          clearTimeout(B);
          l == ~~l ? ((k = a.allowPageScroll), C != l && b.trigger('slimscroll', 0 == ~~l ? 'top' : 'bottom')) : (k = !1);
          C = l;
          u >= b.outerHeight() ? (k = !0) : (c.stop(!0, !0).fadeIn('fast'), a.railVisible && h.stop(!0, !0).fadeIn('fast'));
        }
        function p() {
          a.alwaysVisible ||
            (B = setTimeout(function () {
              (a.disableFadeOut && r) || y || z || (c.fadeOut('slow'), h.fadeOut('slow'));
            }, 1e3));
        }
        var r,
          y,
          z,
          B,
          A,
          u,
          l,
          C,
          k = !1,
          b = e(this);
        if (b.parent().hasClass(a.wrapperClass)) {
          var n = b.scrollTop(),
            c = b.closest('.' + a.barClass),
            h = b.closest('.' + a.railClass);
          x();
          if (e.isPlainObject(g)) {
            if ('height' in g && 'auto' == g.height) {
              b.parent().css('height', 'auto');
              b.css('height', 'auto');
              var q = b.parent().parent().height();
              b.parent().css('height', q);
              b.css('height', q);
            }
            if ('scrollTo' in g) n = parseInt(a.scrollTo);
            else if ('scrollBy' in g) n += parseInt(a.scrollBy);
            else if ('destroy' in g) {
              c.remove();
              h.remove();
              b.unwrap();
              return;
            }
            m(n, !1, !0);
          }
        } else if (!(e.isPlainObject(g) && 'destroy' in g)) {
          a.height = 'auto' == a.height ? b.parent().height() : a.height;
          n = e('<div></div>').addClass(a.wrapperClass).css({ position: 'relative', overflow: 'hidden', width: a.width, height: a.height });
          b.css({ overflow: 'hidden', width: a.width, height: a.height });
          var h = e('<div></div>')
              .addClass(a.railClass)
              .css({
                width: a.size,
                height: '100%',
                position: 'absolute',
                top: 0,
                display: a.alwaysVisible && a.railVisible ? 'block' : 'none',
                'border-radius': a.railBorderRadius,
                background: a.railColor,
                opacity: a.railOpacity,
                zIndex: 90,
              }),
            c = e('<div></div>')
              .addClass(a.barClass)
              .css({
                background: a.color,
                width: a.size,
                position: 'absolute',
                top: 0,
                opacity: a.opacity,
                display: a.alwaysVisible ? 'block' : 'none',
                'border-radius': a.borderRadius,
                BorderRadius: a.borderRadius,
                MozBorderRadius: a.borderRadius,
                WebkitBorderRadius: a.borderRadius,
                zIndex: 99,
              }),
            q = 'right' == a.position ? { right: a.distance } : { left: a.distance };
          h.css(q);
          c.css(q);
          b.wrap(n);
          b.parent().append(c);
          b.parent().append(h);
          a.railDraggable &&
            c
              .bind('mousedown', function (a) {
                var b = e(document);
                z = !0;
                t = parseFloat(c.css('top'));
                pageY = a.pageY;
                b.bind('mousemove.slimscroll', function (a) {
                  currTop = t + a.pageY - pageY;
                  c.css('top', currTop);
                  m(0, c.position().top, !1);
                });
                b.bind('mouseup.slimscroll', function (a) {
                  z = !1;
                  p();
                  b.unbind('.slimscroll');
                });
                return !1;
              })
              .bind('selectstart.slimscroll', function (a) {
                a.stopPropagation();
                a.preventDefault();
                return !1;
              });
          h.hover(
            function () {
              w();
            },
            function () {
              p();
            }
          );
          c.hover(
            function () {
              y = !0;
            },
            function () {
              y = !1;
            }
          );
          b.hover(
            function () {
              r = !0;
              w();
              p();
            },
            function () {
              r = !1;
              p();
            }
          );
          b.bind('touchstart', function (a, b) {
            a.originalEvent.touches.length && (A = a.originalEvent.touches[0].pageY);
          });
          b.bind('touchmove', function (b) {
            k || b.originalEvent.preventDefault();
            b.originalEvent.touches.length &&
              (m((A - b.originalEvent.touches[0].pageY) / a.touchScrollStep, !0), (A = b.originalEvent.touches[0].pageY));
          });
          x();
          'bottom' === a.start
            ? (c.css({ top: b.outerHeight() - c.outerHeight() }), m(0, !0))
            : 'top' !== a.start && (m(e(a.start).position().top, null, !0), a.alwaysVisible || c.hide());
          window.addEventListener
            ? (this.addEventListener('DOMMouseScroll', v, !1), this.addEventListener('mousewheel', v, !1))
            : document.attachEvent('onmousewheel', v);
        }
      });
      return this;
    },
  });
  e.fn.extend({ slimscroll: e.fn.slimScroll });
})(jQuery);

/* eslint-disable */
/*
 * angular-auto-validate - v1.19.6 - 2016-06-17
 * https://github.com/jonsamwell/angular-auto-validate
 * Copyright (c) 2016 Jon Samwell (http://www.jonsamwell.com)
 */

(function (String, angular) {
  'use strict';

  angular.module('jcs-autoValidate', []);

  function ValidatorFn() {
    var elementStateModifiers = {};
    var enableValidElementStyling = true;
    var enableInvalidElementStyling = true;
    var enableFirstInvalidElementScrollingOnSubmit = false;
    var validationEnabled = true;
    var enableFocusInputError = true;

    var toBoolean = function (value) {
      var v;
      if (value && value.length !== 0) {
        v = value.toLowerCase();
        value = !(v === 'f' || v === '0' || v === 'false');
      } else {
        value = false;
      }

      return value;
    };

    var getAttributeValue = function (el, attrName) {
      var val;

      if (el !== undefined) {
        val = el.attr(attrName) || el.attr('data-' + attrName);
      }

      return val;
    };

    var attributeExists = function (el, attrName) {
      var exists;

      if (el !== undefined) {
        exists = el.attr(attrName) !== undefined || el.attr('data-' + attrName) !== undefined;
      }

      return exists;
    };

    var getBooleanAttributeValue = function (el, attrName) {
      return toBoolean(getAttributeValue(el, attrName));
    };

    var validElementStylingEnabled = function (el) {
      return enableValidElementStyling && !getBooleanAttributeValue(el, 'disable-valid-styling');
    };

    var autoValidateEnabledOnControl = function (el) {
      return !getBooleanAttributeValue(el, 'disable-auto-validate');
    };

    var invalidElementStylingEnabled = function (el) {
      return enableInvalidElementStyling && !getBooleanAttributeValue(el, 'disable-invalid-styling');
    };

    /**
     * @ngdoc function
     * @name validator#enable
     * @methodOf validator
     *
     * @description
     * By default auto validate will validate all forms and elements with an ngModel directive on.  By
     * setting enabled to false you will explicitly have to opt in to enable validation on forms and child
     * elements.
     *
     * Note: this can be overridden by add the 'auto-validate-enabled="true/false' attribute to a form.
     *
     * Example:
     * <pre>
     *  app.config(function (validator) {
     *    validator.enable(false);
     *  });
     * </pre>
     *
     * @param {Boolean} isEnabled true to enable, false to disable.
     */
    this.enable = function (isEnabled) {
      validationEnabled = isEnabled;
    };

    /**
     * @ngdoc function
     * @name validator#isEnabled
     * @methodOf validator
     *
     * @description
     * Returns true if the library is enabeld.
     *
     * @return {Boolean} true if enabled, otherwise false.
     */
    this.isEnabled = function () {
      return validationEnabled;
    };

    /**
     * @ngdoc function
     * @name validator#setDefaultElementModifier
     * @methodOf validator
     *
     * @description
     * Sets the default element modifier that will be used by the validator
     * to change an elements UI state.  Please ensure the modifier has been registered
     * before setting it as default.
     *
     * Note: this can be changed by setting the
     * element modifier attribute on the input element 'data-element-modifier="myCustomModifier"'
     *
     * Example:
     * <pre>
     *  app.config(function (validator) {
     *    validator.setDefaultElementModifier('myCustomModifier');
     *  });
     * </pre>
     *
     * @param {string} key The key name of the modifier.
     */
    this.setDefaultElementModifier = function (key) {
      if (elementStateModifiers[key] === undefined) {
        throw new Error('Element modifier not registered: ' + key);
      }

      this.defaultElementModifier = key;
    };

    /**
     * @ngdoc function
     * @name validator#registerDomModifier
     * @methodOf validator
     *
     * @description
     * Registers an object that adheres to the elementModifier interface and is
     * able to modifier an elements dom so that appears valid / invalid for a specific
     * scenario i.e. the Twitter Bootstrap css framework, Foundation CSS framework etc.
     *
     * Example:
     * <pre>
     *  app.config(function (validator) {
     *    validator.registerDomModifier('customDomModifier', {
     *      makeValid: function (el) {
     *          el.removeClass(el, 'invalid');
     *          el.addClass(el, 'valid');
     *      },
     *      makeInvalid: function (el, err, domManipulator) {
     *          el.removeClass(el, 'valid');
     *          el.addClass(el, 'invalid');
     *      }
     *    });
     *  });
     * </pre>
     *
     * @param {string} key The key name of the modifier
     * @param {object} modifier An object which implements the elementModifier interface
     */
    this.registerDomModifier = function (key, modifier) {
      elementStateModifiers[key] = modifier;
    };

    /**
     * @ngdoc function
     * @name validator#setErrorMessageResolver
     * @methodOf validator
     *
     * @description
     * Registers an object that adheres to the elementModifier interface and is
     * able to modifier an elements dom so that appears valid / invalid for a specific
     * scenario i.e. the Twitter Bootstrap css framework, Foundation CSS framework etc.
     *
     * Example:
     * <pre>
     *  app.config(function (validator) {
     *    validator.setErrorMessageResolver(function (errorKey, el) {
     *      var defer = $q.defer();
     *      // resolve the correct error from the given key and resolve the returned promise.
     *      return defer.promise();
     *    });
     *  });
     * </pre>
     *
     * @param {function} resolver A method that returns a promise with the resolved error message in.
     */
    this.setErrorMessageResolver = function (resolver) {
      this.errorMessageResolver = resolver;
    };

    /**
     * @ngdoc function
     * @name validator#getErrorMessage
     * @methodOf validator
     *
     * @description
     * Resolves the error message for the given error type.
     *
     * @param {String} errorKey The error type.
     * @param {Element} el The UI element that is the focus of the error.
     * It is provided as the error message may need information from the element i.e. ng-min (the min allowed value).
     */
    this.getErrorMessage = function (errorKey, el) {
      var defer;
      if (this.errorMessageResolver === undefined) {
        throw new Error(
          'Please set an error message resolver via the setErrorMessageResolver function before attempting to resolve an error message.'
        );
      }

      if (attributeExists(el, 'disable-validation-message')) {
        defer = angular.injector(['ng']).get('$q').defer();
        defer.resolve('');
        return defer.promise;
      }
      return this.errorMessageResolver(errorKey, el);
    };

    /**
     * @ngdoc function
     * @name validator#setValidElementStyling
     * @methodOf validator
     *
     * @description
     * Globally enables valid element visual styling.  This is enabled by default.
     *
     * @param {Boolean} enabled True to enable style otherwise false.
     */
    this.setValidElementStyling = function (enabled) {
      enableValidElementStyling = enabled;
    };

    /**
     * @ngdoc function
     * @name validator#setInvalidElementStyling
     * @methodOf validator
     *
     * @description
     * Globally enables invalid element visual styling.  This is enabled by default.
     *
     * @param {Boolean} enabled True to enable style otherwise false.
     */
    this.setInvalidElementStyling = function (enabled) {
      enableInvalidElementStyling = enabled;
    };

    /**
     * @ngdoc function
     * @name validator#setFirstInvalidElementScrollingOnSubmit
     * @methodOf validator
     *
     * @description
     * Globally enables first invalid element scrolling on form submit. This is disabled by default.
     *
     * @param enabled {Boolean} enabled True to enable scrolling otherwise false.
     */
    this.setFirstInvalidElementScrollingOnSubmit = function (enabled) {
      enableFirstInvalidElementScrollingOnSubmit = enabled;
    };

    this.firstInvalidElementScrollingOnSubmitEnabled = function () {
      return enableFirstInvalidElementScrollingOnSubmit;
    };

    /**
     * @ngdoc function
     * @name validator#setFocusInputError
     * @methodOf validator
     *
     * @description
     * Globally enables focused input error. This is enabled by default.
     *
     * @param enabled {Boolean} enabled false to disabled focus otherwise false.
     */

    this.setFocusInputError = function (enabled) {
      enableFocusInputError = enabled;
    };

    this.enableFocusInputError = function () {
      return enableFocusInputError;
    };

    this.getDomModifier = function (el) {
      var modifierKey =
        (el !== undefined ? el.attr('element-modifier') : this.defaultElementModifier) ||
        (el !== undefined ? el.attr('data-element-modifier') : this.defaultElementModifier) ||
        this.defaultElementModifier;

      if (modifierKey === undefined) {
        throw new Error('Please set a default dom modifier via the setDefaultElementModifier method on the validator class.');
      }

      return elementStateModifiers[modifierKey];
    };

    this.makeValid = function (el) {
      if (autoValidateEnabledOnControl(el)) {
        if (validElementStylingEnabled(el)) {
          this.getDomModifier(el).makeValid(el);
        } else {
          this.makeDefault(el);
        }
      }
    };

    this.makeInvalid = function (el, errorMsg) {
      if (autoValidateEnabledOnControl(el)) {
        if (invalidElementStylingEnabled(el)) {
          this.getDomModifier(el).makeInvalid(el, errorMsg);
        } else {
          this.makeDefault(el);
        }
      }
    };

    this.makeDefault = function (el) {
      if (autoValidateEnabledOnControl(el)) {
        var dm = this.getDomModifier(el);
        if (dm.makeDefault) {
          dm.makeDefault(el);
        }
      }
    };

    this.waitForAsyncValidators = function (el) {
      if (autoValidateEnabledOnControl(el)) {
        var dm = this.getDomModifier(el);
        if (dm.waitForAsyncValidators) {
          dm.waitForAsyncValidators(el);
        }
      }
    };

    this.defaultFormValidationOptions = {
      forceValidation: false,
      disabled: false,
      validateNonVisibleControls: false,
      removeExternalValidationErrorsOnSubmit: true,
      validateOnFormSubmit: false,
      waitForAsyncValidators: true,
    };

    this.$get = [
      function () {
        return this;
      },
    ];
  }

  angular.module('jcs-autoValidate').provider('validator', ValidatorFn);

  function Bootstrap3ElementModifierFn($log) {
    var addedCustomCss = false;
    var customCss = [
      '<style>' +
        '.glyphicon-spin-jcs {' +
        '-webkit-animation: spin 1000ms infinite linear;' +
        'animation: spin 1000ms infinite linear;' +
        '}' +
        '@-webkit-keyframes spin {' +
        '0% {' +
        '-webkit-transform: rotate(0deg);' +
        'transform: rotate(0deg);' +
        '}' +
        '100% {' +
        '-webkit-transform: rotate(359deg);' +
        'transform: rotate(359deg);' +
        '}' +
        '}' +
        '@keyframes spin {' +
        '0% {' +
        '-webkit-transform: rotate(0deg);' +
        'transform: rotate(0deg);' +
        '}' +
        '100% {' +
        '-webkit-transform: rotate(359deg);' +
        'transform: rotate(359deg);' +
        '}' +
        '}' +
        '</style>',
    ].join('');

    var reset = function (el) {
      if (addedCustomCss === false) {
        angular.element(document.body).append(angular.element(customCss));
        addedCustomCss = true;
      }

      angular.forEach(el.find('span'), function (spanEl) {
        spanEl = angular.element(spanEl);
        if (spanEl.hasClass('error-msg') || spanEl.hasClass('form-control-feedback') || spanEl.hasClass('control-feedback')) {
          spanEl.remove();
        }
      });

      el.removeClass('has-success has-error has-feedback');
    };
    var findWithClassElementAsc = function (el, klass) {
      var returnEl;
      var parent = el;
      for (var i = 0; i <= 10; i += 1) {
        if (parent !== undefined && parent.hasClass(klass)) {
          returnEl = parent;
          break;
        } else if (parent !== undefined) {
          parent = parent.parent();
        }
      }

      return returnEl;
    };

    var findWithClassElementDesc = function (el, klass) {
      var child;
      for (var i = 0; i < el.children.length; i += 1) {
        child = el.children[i];
        if (child !== undefined && angular.element(child).hasClass(klass)) {
          break;
        } else if (child.children !== undefined) {
          child = findWithClassElementDesc(child, klass);
          if (child.length > 0) {
            break;
          }
        }
      }

      return angular.element(child);
    };

    var findFormGroupElement = function (el) {
      return findWithClassElementAsc(el, 'form-group');
    };

    var findInputGroupElement = function (el) {
      return findWithClassElementDesc(el, 'input-group');
    };

    var insertAfter = function (referenceNode, newNode) {
      referenceNode[0].parentNode.insertBefore(newNode[0], referenceNode[0].nextSibling);
    };

    /**
     * @ngdoc property
     * @name bootstrap3ElementModifier#addValidationStateIcons
     * @propertyOf bootstrap3ElementModifier
     * @returns {bool} True if an state icon will be added to the element in the valid and invalid control
     * states.  The default is false.
     */
    var addValidationStateIcons = false;

    /**
     * @ngdoc function
     * @name bootstrap3ElementModifier#enableValidationStateIcons
     * @methodOf bootstrap3ElementModifier
     *
     * @description
     * Makes an element appear invalid by apply an icon to the input element.
     *
     * @param {bool} enable - True to enable the icon otherwise false.
     */
    var enableValidationStateIcons = function (enable) {
      addValidationStateIcons = enable;
    };

    /**
     * @ngdoc function
     * @name bootstrap3ElementModifier#makeValid
     * @methodOf bootstrap3ElementModifier
     *
     * @description
     * Makes an element appear valid by apply bootstrap 3 specific styles and child elements. If the service
     * property 'addValidationStateIcons' is true it will also append validation glyphicon to the element.
     * See: http://getbootstrap.com/css/#forms-control-validation
     *
     * @param {Element} el - The input control element that is the target of the validation.
     */
    var makeValid = function (el) {
      var frmGroupEl = findFormGroupElement(el);
      var inputGroupEl;

      if (frmGroupEl) {
        reset(frmGroupEl);
        inputGroupEl = findInputGroupElement(frmGroupEl[0]);
        frmGroupEl.addClass('has-success ' + (inputGroupEl.length > 0 || addValidationStateIcons === false ? '' : 'has-feedback'));
        if (addValidationStateIcons) {
          var iconElText = '<span class="glyphicon glyphicon-ok form-control-feedback"></span>';
          if (inputGroupEl.length > 0) {
            iconElText = iconElText.replace('form-', '');
            iconElText = '<span class="input-group-addon control-feedback">' + iconElText + '</span>';
          }

          insertAfter(el, angular.element(iconElText));
        }
      } else {
        $log.error('Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group class');
      }
    };

    /**
     * @ngdoc function
     * @name bootstrap3ElementModifier#makeInvalid
     * @methodOf bootstrap3ElementModifier
     *
     * @description
     * Makes an element appear invalid by apply bootstrap 3 specific styles and child elements. If the service
     * property 'addValidationStateIcons' is true it will also append validation glyphicon to the element.
     * See: http://getbootstrap.com/css/#forms-control-validation
     *
     * @param {Element} el - The input control element that is the target of the validation.
     */
    var makeInvalid = function (el, errorMsg) {
      var frmGroupEl = findFormGroupElement(el);
      var helpTextEl = angular.element('<span class="help-block has-error error-msg">' + errorMsg + '</span>');
      var inputGroupEl;

      if (frmGroupEl) {
        reset(frmGroupEl);
        inputGroupEl = findInputGroupElement(frmGroupEl[0]);
        frmGroupEl.addClass('has-error ' + (inputGroupEl.length > 0 || addValidationStateIcons === false ? '' : 'has-feedback'));
        insertAfter(inputGroupEl.length > 0 ? inputGroupEl : getCorrectElementToPlaceErrorElementAfter(el), helpTextEl);
        if (addValidationStateIcons) {
          var iconElText = '<span class="glyphicon glyphicon-remove form-control-feedback"></span>';
          if (inputGroupEl.length > 0) {
            iconElText = iconElText.replace('form-', '');
            iconElText = '<span class="input-group-addon control-feedback">' + iconElText + '</span>';
          }

          insertAfter(getCorrectElementToPlaceErrorElementAfter(el), angular.element(iconElText));
        }
      } else {
        $log.error('Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group class');
      }
    };

    var getCorrectElementToPlaceErrorElementAfter = function (el) {
      var correctEl = el;
      var elType = el[0].type ? el[0].type.toLowerCase() : '';

      if ((elType === 'checkbox' || elType === 'radio') && el.parent()[0].nodeName.toLowerCase() === 'label') {
        correctEl = el.parent();
      }

      return correctEl;
    };

    /**
     * @ngdoc function
     * @name bootstrap3ElementModifier#makeDefault
     * @methodOf bootstrap3ElementModifier
     *
     * @description
     * Makes an element appear in its default visual state by apply bootstrap 3 specific styles and child elements.
     *
     * @param {Element} el - The input control element that is the target of the validation.
     */
    var makeDefault = function (el) {
      var frmGroupEl = findFormGroupElement(el);
      if (frmGroupEl) {
        reset(frmGroupEl);
      } else {
        $log.error('Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group class');
      }
    };

    var waitForAsyncValidators = function (el) {
      var frmGroupEl = findFormGroupElement(el);
      var inputGroupEl;

      if (frmGroupEl) {
        reset(frmGroupEl);
        inputGroupEl = findInputGroupElement(frmGroupEl[0]);
        frmGroupEl.addClass('has-feedback ' + (inputGroupEl.length > 0 || addValidationStateIcons === false ? '' : 'has-feedback'));
        if (addValidationStateIcons) {
          var iconElText = '<span class="glyphicon glyphicon-repeat glyphicon-spin-jcs form-control-feedback"></span>';
          if (inputGroupEl.length > 0) {
            iconElText = iconElText.replace('form-', '');
            iconElText = '<span class="input-group-addon control-feedback">' + iconElText + '</span>';
          }

          insertAfter(el, angular.element(iconElText));
        }
      } else {
        $log.error('Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group class');
      }
    };

    return {
      makeValid: makeValid,
      makeInvalid: makeInvalid,
      makeDefault: makeDefault,
      waitForAsyncValidators: waitForAsyncValidators,
      enableValidationStateIcons: enableValidationStateIcons,
      key: 'bs3',
    };
  }

  Bootstrap3ElementModifierFn.$inject = ['$log'];

  angular.module('jcs-autoValidate').factory('bootstrap3ElementModifier', Bootstrap3ElementModifierFn);

  /*
   * Taken from https://github.com/angular/angular.js/issues/2690#issue-14462164 (with added tests of course!)
   */
  function JCSDebounceFn($timeout) {
    var debounce = function (func, wait, immediate) {
      var timeout;
      return function () {
        var context = this;
        var args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) {
            func.apply(context, args);
          }
        };

        var callNow = immediate && !timeout;
        $timeout.cancel(timeout);
        timeout = $timeout(later, wait, false);
        if (callNow) {
          func.apply(context, args);
        }
      };
    };

    return {
      debounce: debounce,
    };
  }

  JCSDebounceFn.$inject = ['$timeout'];

  angular.module('jcs-autoValidate').factory('jcs-debounce', JCSDebounceFn);

  /**
   * Replaces string placeholders with corresponding template string
   */
  function formatString(string, params) {
    return string.replace(/{(\d+)}/g, function (match, number) {
      return typeof params[number] !== undefined ? params[number] : match;
    });
  }

  angular.autoValidate = angular.autoValidate || {
    errorMessages: {},
  };

  angular.autoValidate.errorMessages.default = {
    defaultMsg: 'Please add error message for {0}',
    email: 'Please enter a valid email address',
    minlength: 'Please enter at least {0} characters',
    maxlength: 'You have entered more than the maximum {0} characters',
    min: 'Please enter the minimum number of {0}',
    max: 'Please enter the maximum number of {0}',
    required: 'This field is required',
    date: 'Please enter a valid date',
    pattern: 'Please ensure the entered information adheres to this pattern {0}',
    number: 'Please enter a valid number',
    url: 'Please enter a valid URL in the format of http(s)://www.google.com',
  };

  function DefaultErrorMessageResolverFn($q, $http) {
    var currentCulture = 'default';

    var i18nFileRootPath = 'js/angular-auto-validate/dist/lang';

    var cultureRetrievalPromise;

    var loadRemoteCulture = function (culture) {
      cultureRetrievalPromise = $http.get(formatString('{0}/jcs-auto-validate_{1}.json', [i18nFileRootPath, culture.toLowerCase()]));
      return cultureRetrievalPromise;
    };

    /**
     * @ngdoc function
     * @name defaultErrorMessageResolver#setI18nFileRootPath
     * @methodOf defaultErrorMessageResolver
     *
     * @description
     * Set the root path to the il8n files on the server
     *
     * @param {String} rootPath - The root path on the server to the il8n file - this defaults
     * to 'js/angular-auto-validate/lang/'
     */
    var setI18nFileRootPath = function (rootPath) {
      i18nFileRootPath = rootPath;
    };

    /**
     * @ngdoc function
     * @name defaultErrorMessageResolver#setCulture
     * @methodOf defaultErrorMessageResolver
     *
     * @description
     * Set the culture for the error messages by loading an the correct culture resource file.
     *
     * @param {String} culture - The new culture in the format of 'en-gb' etc.
     * @param {Function} cultureLoadingFn - A optional function to load the culture resolve which should
     * return a promise which is resolved with the culture errorMessage object.  If a function is not specified
     * the culture file is loaded from the **i18nFileRootPath**.
     * @returns {Promise} - A promise which is resolved with the loaded culture error messages object.
     */
    var setCulture = function (culture, cultureLoadingFn) {
      var defer = $q.defer();
      cultureLoadingFn = cultureLoadingFn || loadRemoteCulture;
      currentCulture = culture.toLowerCase();
      if (angular.autoValidate.errorMessages[currentCulture] === undefined) {
        cultureRetrievalPromise = cultureLoadingFn(culture);
        cultureRetrievalPromise.then(
          function (response) {
            cultureRetrievalPromise = undefined;
            angular.autoValidate.errorMessages[currentCulture] = response.data;
            defer.resolve(angular.autoValidate.errorMessages[currentCulture]);
          },
          function (err) {
            angular.autoValidate.errorMessages[currentCulture] = {
              defaultMsg: 'Loading culture failed!',
            };
            cultureRetrievalPromise = null;
            defer.reject(err);
          }
        );
      } else {
        defer.resolve(angular.autoValidate.errorMessages[currentCulture]);
      }

      return defer.promise;
    };

    var getErrorMessages = function (culture) {
      var defer = $q.defer();
      culture = culture === undefined ? currentCulture : culture.toLowerCase();
      if (cultureRetrievalPromise !== undefined) {
        cultureRetrievalPromise.then(
          function () {
            defer.resolve(angular.autoValidate.errorMessages[culture]);
          },
          function (err) {
            defer.reject(err);
          }
        );
      } else {
        defer.resolve(angular.autoValidate.errorMessages[culture]);
      }
      return defer.promise;
    };

    var getMessageTypeOverride = function (errorType, el) {
      var overrideKey;

      if (el) {
        // try and find an attribute which overrides the given error type in the form of errorType-err-type="someMsgKey"
        errorType += '-err-type';

        overrideKey = el.attr('ng-' + errorType);
        if (overrideKey === undefined) {
          overrideKey = el.attr('data-ng-' + errorType) || el.attr(errorType);
        }

        if (overrideKey) {
          overrideKey = overrideKey.replace(/[\W]/g, '');
        }
      }

      return overrideKey;
    };

    /**
     * @ngdoc function
     * @name defaultErrorMessageResolver#resolve
     * @methodOf defaultErrorMessageResolver
     *
     * @description
     * Resolves a validate error type into a user validation error message
     *
     * @param {String} errorType - The type of validation error that has occurred.
     * @param {Element} el - The input element that is the source of the validation error.
     * @returns {Promise} A promise that is resolved when the validation message has been produced.
     */
    var resolve = function (errorType, el) {
      var defer = $q.defer();
      var errMsg;
      var parameters = [];
      var parameter;
      var messageTypeOverride;

      if (cultureRetrievalPromise !== undefined) {
        cultureRetrievalPromise.then(function () {
          resolve(errorType, el).then(function (msg) {
            defer.resolve(msg);
          });
        });
      } else {
        errMsg = angular.autoValidate.errorMessages[currentCulture][errorType];
        messageTypeOverride = getMessageTypeOverride(errorType, el);
        if (messageTypeOverride) {
          errMsg = angular.autoValidate.errorMessages[currentCulture][messageTypeOverride];
        }

        if (errMsg === undefined && messageTypeOverride !== undefined) {
          errMsg = formatString(angular.autoValidate.errorMessages[currentCulture].defaultMsg, [messageTypeOverride]);
        } else if (errMsg === undefined) {
          errMsg = formatString(angular.autoValidate.errorMessages[currentCulture].defaultMsg, [errorType]);
        }

        if (el && el.attr) {
          try {
            parameter = el.attr('ng-' + errorType);
            if (parameter === undefined) {
              parameter = el.attr('data-ng-' + errorType) || el.attr(errorType);
            }

            parameters.push(parameter || '');

            errMsg = formatString(errMsg, parameters);
          } catch (e) {}
        }

        defer.resolve(errMsg);
      }

      return defer.promise;
    };

    return {
      setI18nFileRootPath: setI18nFileRootPath,
      setCulture: setCulture,
      getErrorMessages: getErrorMessages,
      resolve: resolve,
    };
  }

  DefaultErrorMessageResolverFn.$inject = ['$q', '$http'];

  angular.module('jcs-autoValidate').factory('defaultErrorMessageResolver', DefaultErrorMessageResolverFn);

  function Foundation5ElementModifierFn() {
    var reset = function (el, inputEl) {
      angular.forEach(el.find('small'), function (smallEl) {
        if (angular.element(smallEl).hasClass('error')) {
          angular.element(smallEl).remove();
        }
      });

      inputEl.removeClass('error');
    };
    var findParentColumn = function (el) {
      var parent = el;
      for (var i = 0; i <= 3; i += 1) {
        if (parent !== undefined && (parent.hasClass('columns') || parent.hasClass('column'))) {
          break;
        } else if (parent !== undefined) {
          parent = parent.parent();
        }
      }

      return parent;
    };

    /**
     * @ngdoc function
     * @name foundation5ElementModifier#makeValid
     * @methodOf foundation5ElementModifier
     *
     * @description
     * Makes an element appear valid by apply Foundation 5 specific styles and child elements.
     * See: http://foundation.zurb.com/docs/components/forms.html
     *
     * @param {Element} el - The input control element that is the target of the validation.
     */
    var makeValid = function (el) {
      var parentColumn = findParentColumn(el);
      reset(parentColumn && parentColumn.length > 0 ? parentColumn : el, el);
    };

    /**
     * @ngdoc function
     * @name foundation5ElementModifier#makeInvalid
     * @methodOf foundation5ElementModifier
     *
     * @description
     * Makes an element appear invalid by apply Foundation 5 specific styles and child elements.
     * See: http://foundation.zurb.com/docs/components/forms.html
     *
     * @param {Element} el - The input control element that is the target of the validation.
     */
    var makeInvalid = function (el, errorMsg) {
      var parentColumn = findParentColumn(el);
      var helpTextEl;
      reset(parentColumn || el, el);
      el.addClass('error');
      if (parentColumn) {
        helpTextEl = angular.element('<small class="error">' + errorMsg + '</small>');
        parentColumn.append(helpTextEl);
      }
    };

    /**
     * @ngdoc function
     * @name foundation5ElementModifier#makeDefault
     * @methodOf foundation5ElementModifier
     *
     * @description
     * Makes an element appear in its default visual state by apply foundation 5 specific styles and child elements.
     *
     * @param {Element} el - The input control element that is the target of the validation.
     */
    var makeDefault = function (el) {
      makeValid(el);
    };

    return {
      makeValid: makeValid,
      makeInvalid: makeInvalid,
      makeDefault: makeDefault,
      key: 'foundation5',
    };
  }

  angular.module('jcs-autoValidate').factory('foundation5ElementModifier', Foundation5ElementModifierFn);

  function foundation6ElementModifierFn() {
    var reset = function (el, inputEl) {
      angular.forEach(el.find('small'), function (smallEl) {
        if (angular.element(smallEl).hasClass('form-error is-visible')) {
          angular.element(smallEl).remove();
        }
      });

      inputEl.removeClass('alert callout');
    };
    var findParentColumn = function (el) {
      var parent = el;
      for (var i = 0; i <= 3; i += 1) {
        if (parent !== undefined && (parent.hasClass('columns') || parent.hasClass('column'))) {
          break;
        } else if (parent !== undefined) {
          parent = parent.parent();
        }
      }

      return parent;
    };

    /**
     * @ngdoc function
     * @name foundation6ElementModifier#makeValid
     * @methodOf foundation6ElementModifier
     *
     * @description
     * Makes an element appear valid by apply Foundation 6 specific styles and child elements.
     * See: http://foundation.zurb.com/sites/docs/forms.html
     *
     * @param {Element} el - The input control element that is the target of the validation.
     */
    var makeValid = function (el) {
      var parentColumn = findParentColumn(el);
      reset(parentColumn && parentColumn.length > 0 ? parentColumn : el, el);
    };

    /**
     * @ngdoc function
     * @name foundation6ElementModifier#makeInvalid
     * @methodOf foundation6ElementModifier
     *
     * @description
     * Makes an element appear invalid by apply Foundation 6 specific styles and child elements.
     * See: http://foundation.zurb.com/sites/docs/forms.html
     *
     * @param {Element} el - The input control element that is the target of the validation.
     */
    var makeInvalid = function (el, errorMsg) {
      var parentColumn = findParentColumn(el);
      var helpTextEl;
      reset(parentColumn || el, el);
      el.addClass('alert callout');
      if (parentColumn) {
        helpTextEl = angular.element('<small class="form-error is-visible">' + errorMsg + '</small>');
        parentColumn.append(helpTextEl);
      }
    };

    /**
     * @ngdoc function
     * @name foundation6ElementModifier#makeDefault
     * @methodOf foundation6ElementModifier
     *
     * @description
     * Makes an element appear in its default visual state by apply Foundation 6 specific styles and child elements.
     *
     * @param {Element} el - The input control element that is the target of the validation.
     */
    var makeDefault = function (el) {
      makeValid(el);
    };

    return {
      makeValid: makeValid,
      makeInvalid: makeInvalid,
      makeDefault: makeDefault,
      key: 'foundation6',
    };
  }

  angular.module('jcs-autoValidate').factory('foundation6ElementModifier', foundation6ElementModifierFn);

  function ElementUtilsFn() {
    var isElementVisible = function (el) {
      return el[0].offsetWidth > 0 && el[0].offsetHeight > 0;
    };

    return {
      isElementVisible: isElementVisible,
    };
  }

  function ValidationManagerFn(validator, elementUtils, $anchorScroll) {
    var elementTypesToValidate = ['input', 'textarea', 'select', 'form'];

    var elementIsVisible = function (el) {
      return elementUtils.isElementVisible(el);
    };

    var getFormOptions = function (el) {
      var frmCtrl = angular.element(el).controller('form');
      var options;

      if (frmCtrl !== undefined && frmCtrl !== null) {
        options = frmCtrl.autoValidateFormOptions;
      } else {
        options = validator.defaultFormValidationOptions;
      }

      return options;
    };

    /**
     * Only validate if the element is present, it is visible, if it is not a comment,
     * it is either a valid user input control (input, select, textare, form) or
     * it is a custom control register by the developer.
     * @param el
     * @param formOptions The validation options of the parent form
     * @returns {boolean} true to indicate it should be validated
     */
    var shouldValidateElement = function (el, formOptions, formSubmitted) {
      var elementExists = el && el.length > 0;
      var isElementAComment = elementExists && el[0].nodeName.toLowerCase() === '#comment';
      var correctVisibilityToValidate;
      var correctTypeToValidate;
      var correctPhaseToValidate;

      if (elementExists && isElementAComment === false) {
        correctVisibilityToValidate = elementIsVisible(el) || formOptions.validateNonVisibleControls;
        correctTypeToValidate =
          elementTypesToValidate.indexOf(el[0].nodeName.toLowerCase()) > -1 || el[0].hasAttribute('register-custom-form-control');
        correctPhaseToValidate = formOptions.validateOnFormSubmit === false || (formOptions.validateOnFormSubmit === true && formSubmitted === true);
      }
      return elementExists && !isElementAComment && correctVisibilityToValidate && correctTypeToValidate && correctPhaseToValidate;
    };

    /**
     * @ngdoc validateElement
     * @name validation#validateElement
     * @param {object} modelCtrl holds the information about the element e.g. $invalid, $valid
     * @param {options}
     *  - forceValidation if set to true forces the validation even if the element is pristine
     *  - disabled if set to true forces the validation is disabled and will return true
     *  - validateNonVisibleControls if set to true forces the validation of non visible element i.e. display:block
     * @description
     * Validate the form element and make invalid/valid element model status.
     *
     * As of v1.17.22:
     * BREAKING CHANGE to validateElement on the validationManger.  The third parameter is now the parent form's
     * autoValidateFormOptions object on the form controller.  This can be left blank and will be found by the
     * validationManager.
     */
    var validateElement = function (modelCtrl, el, options) {
      var isValid = true;
      var frmOptions = options || getFormOptions(el);
      var needsValidation = modelCtrl.$pristine === false || frmOptions.forceValidation;
      var errorType;
      var findErrorType = function ($errors) {
        var keepGoing = true;
        var errorTypeToReturn;
        angular.forEach($errors, function (status, errortype) {
          if (keepGoing && status) {
            keepGoing = false;
            errorTypeToReturn = errortype;
          }
        });

        return errorTypeToReturn;
      };
      if (frmOptions.disabled === false) {
        if (
          frmOptions.forceValidation ||
          (shouldValidateElement(el, frmOptions, frmOptions.getFormController().$submitted) && modelCtrl && needsValidation)
        ) {
          isValid = !modelCtrl.$invalid;

          if (frmOptions.removeExternalValidationErrorsOnSubmit && modelCtrl.removeAllExternalValidation) {
            modelCtrl.removeAllExternalValidation();
          }

          if (modelCtrl.$pending !== undefined && options.waitForAsyncValidators === true) {
            // we have pending async validators
            validator.waitForAsyncValidators(el);
          } else if (isValid) {
            validator.makeValid(el);
          } else {
            errorType = findErrorType(modelCtrl.$errors || modelCtrl.$error);
            if (errorType === undefined) {
              // we have a weird situation some users are encountering where a custom control
              // is valid but the ngModel is report it isn't and thus no valid error type can be found
              isValid = true;
            } else {
              validator.getErrorMessage(errorType, el).then(function (errorMsg) {
                validator.makeInvalid(el, errorMsg);
              });
            }
          }
        }
      }

      return isValid;
    };

    var resetElement = function (element) {
      validator.makeDefault(element);
    };

    var resetForm = function (frmElement) {
      angular.forEach(frmElement[0].all || frmElement[0].elements || frmElement[0], function (element) {
        var controller;
        var ctrlElement = angular.element(element);
        controller = ctrlElement.controller('ngModel');

        if (controller !== undefined) {
          if (ctrlElement[0].nodeName.toLowerCase() === 'form') {
            // we probably have a sub form
            resetForm(ctrlElement);
          } else {
            controller.$setPristine();
          }
        }
      });
    };

    var validateForm = function (frmElement) {
      var frmValid = true;
      var firstElementError = null;
      var frmCtrl = frmElement ? angular.element(frmElement).controller('form') : undefined;
      var processElement = function (ctrlElement, force, formOptions) {
        var controller;
        var isValid;
        var ctrlFormOptions;
        var originalForceValue;

        ctrlElement = angular.element(ctrlElement);
        controller = ctrlElement.controller('ngModel');

        if (controller !== undefined && (force || shouldValidateElement(ctrlElement, formOptions, frmCtrl.$submitted))) {
          if (ctrlElement[0].nodeName.toLowerCase() === 'form') {
            // we probably have a sub form
            validateForm(ctrlElement);
          } else {
            // we need to get the options for the element rather than use the passed in as the
            // element could be an ng-form and have different options to the parent form.
            ctrlFormOptions = getFormOptions(ctrlElement);
            originalForceValue = ctrlFormOptions.forceValidation;
            ctrlFormOptions.forceValidation = force;
            try {
              isValid = validateElement(controller, ctrlElement, ctrlFormOptions);
              if (validator.enableFocusInputError() && !isValid && frmValid) {
                if (!firstElementError) {
                  firstElementError = ctrlElement[0];
                  firstElementError.focus();
                }
              }
              if (validator.firstInvalidElementScrollingOnSubmitEnabled() && !isValid && frmValid) {
                var ctrlElementId = ctrlElement.attr('id');
                if (ctrlElementId) {
                  $anchorScroll(ctrlElementId);
                }
              }
              frmValid = frmValid && isValid;
            } finally {
              ctrlFormOptions.forceValidation = originalForceValue;
            }
          }
        }
      };
      var clonedOptions;

      if (frmElement === undefined || (frmCtrl !== undefined && frmCtrl.autoValidateFormOptions.disabled)) {
        return frmElement !== undefined;
      }

      // force the validation of controls
      clonedOptions = angular.copy(frmCtrl.autoValidateFormOptions);
      clonedOptions.forceValidation = true;

      // IE8 holds the child controls collection in the all property
      // Firefox in the elements and chrome as a child iterator
      angular.forEach(frmElement[0].elements || frmElement[0].all || frmElement[0], function (ctrlElement) {
        processElement(ctrlElement, true, clonedOptions);
      });

      // If you have a custom form control that should be validated i.e.
      // <my-custom-element>...</my-custom-element> it will not be part of the forms
      // HTMLFormControlsCollection and thus won't be included in the above element iteration although
      // it will be on the Angular FormController (if it has a name attribute).  So adding the directive
      // register-custom-form-control="" to the control root and autoValidate will include it in this
      // iteration.
      if (frmElement[0].customHTMLFormControlsCollection) {
        angular.forEach(frmElement[0].customHTMLFormControlsCollection, function (ctrlElement) {
          // need to force the validation as the element might not be a known form input type
          // so the normal validation process will ignore it.
          processElement(ctrlElement, true, clonedOptions);
        });
      }

      return frmValid;
    };

    var validateNgForm = function (frmElement) {
      // //console.log(frmElement)
      // //console.log(angular.element(frmElement).controller('form'))
      // //console.log(angular.element("[name='enquiryPartsForm']").controller("form"))
      // //console.log(angular.element("[name='enquiryPartsForm']")[0].getElementsByTagName("*"))

      var frmValid = true;
      var firstElementError = null;
      var frmCtrl = frmElement ? angular.element(frmElement).controller('form') : undefined;
      var processElement = function (ctrlElement, force, formOptions) {
        var controller;
        var isValid;
        var ctrlFormOptions;
        var originalForceValue;

        ctrlElement = angular.element(ctrlElement);
        controller = ctrlElement.controller('ngModel');

        // //console.log(controller)

        if (controller !== undefined && (force || shouldValidateElement(ctrlElement, formOptions, frmCtrl.$submitted))) {
          // //console.log('inside first if in processElement')
          if (ctrlElement[0].nodeName.toLowerCase() === 'form') {
            // we probably have a sub form
            validateNgForm(ctrlElement);
          } else {
            // we need to get the options for the element rather than use the passed in as the
            // element could be an ng-form and have different options to the parent form.
            ctrlFormOptions = getFormOptions(ctrlElement);
            originalForceValue = ctrlFormOptions.forceValidation;
            ctrlFormOptions.forceValidation = force;
            try {
              isValid = validateElement(controller, ctrlElement, ctrlFormOptions);
              if (validator.enableFocusInputError() && !isValid && frmValid) {
                if (!firstElementError) {
                  firstElementError = ctrlElement[0];
                  firstElementError.focus();
                }
              }
              if (validator.firstInvalidElementScrollingOnSubmitEnabled() && !isValid && frmValid) {
                var ctrlElementId = ctrlElement.attr('id');
                if (ctrlElementId) {
                  $anchorScroll(ctrlElementId);
                }
              }
              frmValid = frmValid && isValid;
            } finally {
              ctrlFormOptions.forceValidation = originalForceValue;
            }
          }
        }
      };
      var clonedOptions;

      if (angular.element(frmElement) === undefined || (frmCtrl !== undefined && frmCtrl.autoValidateFormOptions.disabled)) {
        return frmElement !== undefined;
      }

      // force the validation of controls
      clonedOptions = angular.copy(frmCtrl.autoValidateFormOptions);
      clonedOptions.forceValidation = true;

      // IE8 holds the child controls collection in the all property
      // Firefox in the elements and chrome as a child iterator
      // angular.forEach((frmElement[0].elements || frmElement[0].all) || frmElement[0], function (ctrlElement) {
      // //console.log(frmElement[0].elements)
      // //console.log(ctrlElement)
      // processElement(ctrlElement, true, clonedOptions);
      // });

      angular.forEach(angular.element(frmElement)[0].getElementsByTagName('*'), function (ctrlElement) {
        processElement(ctrlElement, true, clonedOptions);
      });
      // If you have a custom form control that should be validated i.e.
      // <my-custom-element>...</my-custom-element> it will not be part of the forms
      // HTMLFormControlsCollection and thus won't be included in the above element iteration although
      // it will be on the Angular FormController (if it has a name attribute).  So adding the directive
      // register-custom-form-control="" to the control root and autoValidate will include it in this
      // iteration.
      if (angular.element(frmElement)[0].customHTMLFormControlsCollection) {
        angular.forEach(angular.element(frmElement)[0].customHTMLFormControlsCollection, function (ctrlElement) {
          // need to force the validation as the element might not be a known form input type
          // so the normal validation process will ignore it.
          processElement(ctrlElement, true, clonedOptions);
        });
      }

      return frmValid;
    };
    var setElementValidationError = function (element, errorMsgKey, errorMsg) {
      if (errorMsg) {
        validator.makeInvalid(element, errorMsg);
      } else {
        validator.getErrorMessage(errorMsgKey, element).then(function (msg) {
          validator.makeInvalid(element, msg);
        });
      }
    };

    return {
      setElementValidationError: setElementValidationError,
      validateElement: validateElement,
      validateForm: validateForm,
      validateNgForm: validateNgForm,
      resetElement: resetElement,
      resetForm: resetForm,
    };
  }

  ValidationManagerFn.$inject = ['validator', 'jcs-elementUtils', '$anchorScroll'];

  angular.module('jcs-autoValidate').factory('jcs-elementUtils', ElementUtilsFn);
  angular.module('jcs-autoValidate').factory('validationManager', ValidationManagerFn);

  function parseBooleanAttributeValue(val, defaultValue) {
    if ((val === undefined || val === null) && defaultValue !== undefined) {
      return defaultValue;
    }
    return val !== 'false';
  }

  function parseOptions(ctrl, validator, attrs) {
    var opts = (ctrl.autoValidateFormOptions = ctrl.autoValidateFormOptions || angular.copy(validator.defaultFormValidationOptions));

    // needed to stop circular ref in json serialisation
    opts.getFormController = function () {
      return ctrl;
    };
    opts.waitForAsyncValidators = parseBooleanAttributeValue(attrs.waitForAsyncValidators, opts.waitForAsyncValidators);
    opts.forceValidation = false;
    opts.disabled = !validator.isEnabled() || parseBooleanAttributeValue(attrs.disableDynamicValidation, opts.disabled);
    opts.validateNonVisibleControls = parseBooleanAttributeValue(attrs.validateNonVisibleControls, opts.validateNonVisibleControls);
    opts.validateOnFormSubmit = parseBooleanAttributeValue(attrs.validateOnFormSubmit, opts.validateOnFormSubmit);
    opts.removeExternalValidationErrorsOnSubmit =
      attrs.removeExternalValidationErrorsOnSubmit === undefined
        ? opts.removeExternalValidationErrorsOnSubmit
        : parseBooleanAttributeValue(attrs.removeExternalValidationErrorsOnSubmit, opts.removeExternalValidationErrorsOnSubmit);

    // the library might be globally disabled but enabled on a particular form so check the
    // disableDynamicValidation attribute is on the form
    if (validator.isEnabled() === false && attrs.disableDynamicValidation === 'false') {
      opts.disabled = false;
    }
  }

  angular.module('jcs-autoValidate').directive('form', [
    'validator',
    function (validator) {
      return {
        restrict: 'E',
        require: 'form',
        compile: function () {
          return {
            pre: function (scope, element, attrs, ctrl) {
              parseOptions(ctrl, validator, attrs);
            },
          };
        },
      };
    },
  ]);

  angular.module('jcs-autoValidate').directive('ngForm', [
    'validator',
    function (validator) {
      return {
        restrict: 'EA',
        require: 'form',
        priority: 9999,
        compile: function () {
          return {
            pre: function (scope, element, attrs, ctrl) {
              parseOptions(ctrl, validator, attrs);
            },
          };
        },
      };
    },
  ]);

  /* eslint-disable */
  function FormResetDirectiveFn(validationManager) {
    return {
      restrict: 'E',
      link: function (scope, el) {
        var formController = el.controller('form');

        function resetFn() {
          validationManager.resetForm(el);
          if (formController.$setPristine) {
            formController.$setPristine();
          }

          if (formController.$setUntouched) {
            formController.$setUntouched();
          }
        }

        if (formController !== undefined && formController.autoValidateFormOptions && formController.autoValidateFormOptions.disabled === false) {
          el.on('reset', resetFn);

          scope.$on('$destroy', function () {
            el.off('reset', resetFn);
          });
        }
      },
    };
  }

  FormResetDirectiveFn.$inject = ['validationManager'];

  angular.module('jcs-autoValidate').directive('form', FormResetDirectiveFn);

  function RegisterCustomFormControlFn() {
    var findParentForm = function (el) {
      var parent = el;
      for (var i = 0; i <= 50; i += 1) {
        if (parent !== undefined && parent.nodeName.toLowerCase() === 'form') {
          break;
        } else if (parent !== undefined) {
          parent = angular.element(parent).parent()[0];
        }
      }

      return parent;
    };

    return {
      restrict: 'A',
      link: function (scope, element) {
        var frmEl = findParentForm(element.parent()[0]);
        if (frmEl) {
          frmEl.customHTMLFormControlsCollection = frmEl.customHTMLFormControlsCollection || [];
          frmEl.customHTMLFormControlsCollection.push(element[0]);
        }
      },
    };
  }

  angular.module('jcs-autoValidate').directive('registerCustomFormControl', RegisterCustomFormControlFn);

  function SubmitDecorator($delegate, $parse, validationManager) {
    $delegate[0].compile = function ($element, attrs) {
      var fn = $parse(attrs.ngSubmit);
      var force = attrs.ngSubmitForce === 'true';

      return function (scope, element) {
        var formController = element.controller('form');
        var resetListenerOffFn;

        function handlerFn(event) {
          scope.$apply(function () {
            if (
              formController !== undefined &&
              formController !== null &&
              formController.autoValidateFormOptions &&
              formController.autoValidateFormOptions.disabled === true
            ) {
              fn(scope, {
                $event: event,
              });
            } else {
              if (formController.$setSubmitted === undefined) {
                // we probably have angular <= 1.2
                formController.$submitted = true;
              }

              if (validationManager.validateForm(element) || force === true) {
                fn(scope, {
                  $event: event,
                });
              }
            }
          });
        }

        function resetFormFn() {
          if (element[0].reset) {
            element[0].reset();
          } else {
            validationManager.resetForm(element);
          }
        }

        if (formController && formController.autoValidateFormOptions) {
          // allow the form to be reset programatically or via raising the event
          // form:formName:reset
          formController.autoValidateFormOptions.resetForm = resetFormFn;
          if (formController.$name !== undefined && formController.$name !== '') {
            resetListenerOffFn = scope.$on('form:' + formController.$name + ':reset', resetFormFn);
          }
        }

        element.on('submit', handlerFn);
        scope.$on('$destroy', function () {
          element.off('submit', handlerFn);
          if (resetListenerOffFn) {
            resetListenerOffFn();
          }
        });
      };
    };

    return $delegate;
  }

  SubmitDecorator.$inject = ['$delegate', '$parse', 'validationManager'];

  function ProviderFn($provide) {
    $provide.decorator('ngSubmitDirective', SubmitDecorator);
  }

  ProviderFn.$inject = ['$provide'];

  angular.module('jcs-autoValidate').config(ProviderFn);

  angular.module('jcs-autoValidate').config([
    '$provide',
    function ($provide) {
      $provide.decorator('ngModelDirective', [
        '$timeout',
        '$delegate',
        'validationManager',
        'jcs-debounce',
        function ($timeout, $delegate, validationManager, debounce) {
          var directive = $delegate[0];
          var link = directive.link || directive.compile;

          directive.compile = function (el) {
            var supportsNgModelOptions = angular.version.major >= 1 && angular.version.minor >= 3;
            var originalLink = link;

            // in the RC of 1.3 there is no directive.link only the directive.compile which
            // needs to be invoked to get at the link functions.
            if (supportsNgModelOptions && angular.isFunction(link)) {
              originalLink = link(el);
            }

            return {
              pre: function (scope, element, attrs, ctrls) {
                var ngModelCtrl = ctrls[0];
                var frmCtrl = ctrls[1];
                var ngModelOptions = attrs.ngModelOptions === undefined ? undefined : scope.$eval(attrs.ngModelOptions);
                var setValidity = ngModelCtrl.$setValidity;
                var setPristine = ngModelCtrl.$setPristine;
                var setValidationState = debounce.debounce(function () {
                  var validateOptions = frmCtrl !== undefined && frmCtrl !== null ? frmCtrl.autoValidateFormOptions : undefined;
                  validationManager.validateElement(ngModelCtrl, element, validateOptions);
                }, 100);

                if (
                  attrs.formnovalidate === undefined &&
                  frmCtrl !== undefined &&
                  frmCtrl !== null &&
                  frmCtrl.autoValidateFormOptions &&
                  frmCtrl.autoValidateFormOptions.disabled === false
                ) {
                  // if the version of angular supports ng-model-options let angular handle the element.on bit
                  // fixes issue with async validators
                  if (
                    supportsNgModelOptions ||
                    !supportsNgModelOptions ||
                    ngModelOptions === undefined ||
                    ngModelOptions.updateOn === undefined ||
                    ngModelOptions.updateOn === ''
                  ) {
                    ngModelCtrl.$setValidity = function (validationErrorKey, isValid) {
                      setValidity.call(ngModelCtrl, validationErrorKey, isValid);
                      setValidationState();
                    };
                  } else {
                    element.on(ngModelOptions.updateOn, function () {
                      setValidationState();
                    });

                    scope.$on('$destroy', function () {
                      element.off(ngModelOptions.updateOn);
                    });
                  }

                  // We override this so we can reset the element state when it is called.
                  ngModelCtrl.$setPristine = function () {
                    setPristine.call(ngModelCtrl);
                    validationManager.resetElement(element);
                  };

                  ngModelCtrl.autoValidated = true;
                }

                ngModelCtrl.setExternalValidation = function (errorMsgKey, errorMessage, addToModelErrors) {
                  if (addToModelErrors) {
                    ngModelCtrl.$setValidity(errorMsgKey, false);
                  }

                  ngModelCtrl.externalErrors = ngModelCtrl.externalErrors || {};
                  ngModelCtrl.externalErrors[errorMsgKey] = false;
                  validationManager.setElementValidationError(element, errorMsgKey, errorMessage);
                };

                ngModelCtrl.removeExternalValidation = function (errorMsgKey, addToModelErrors) {
                  if (addToModelErrors) {
                    ngModelCtrl.$setValidity(errorMsgKey, true);
                    var collection = ngModelCtrl.$error || ngModelCtrl.$errors;
                    delete collection[errorMsgKey];
                  }

                  if (ngModelCtrl.externalErrors) {
                    delete ngModelCtrl.externalErrors[errorMsgKey];
                  }

                  validationManager.resetElement(element);
                };

                ngModelCtrl.removeAllExternalValidation = function () {
                  if (ngModelCtrl.externalErrors) {
                    var errorCollection = ngModelCtrl.$error || ngModelCtrl.$errors;
                    angular.forEach(ngModelCtrl.externalErrors, function (value, key) {
                      ngModelCtrl.$setValidity(key, true);
                      delete errorCollection[key];
                    });

                    ngModelCtrl.externalErrors = {};
                    validationManager.resetElement(element);
                  }
                };

                if (frmCtrl) {
                  frmCtrl.setExternalValidation = function (modelProperty, errorMsgKey, errorMessageOverride, addToModelErrors) {
                    var success = false;
                    if (frmCtrl[modelProperty]) {
                      frmCtrl[modelProperty].setExternalValidation(errorMsgKey, errorMessageOverride, addToModelErrors);
                      success = true;
                    }

                    return success;
                  };

                  frmCtrl.removeExternalValidation = function (modelProperty, errorMsgKey, errorMessageOverride, addToModelErrors) {
                    var success = false;
                    if (frmCtrl[modelProperty]) {
                      frmCtrl[modelProperty].removeExternalValidation(errorMsgKey, addToModelErrors);
                      success = true;
                    }

                    return success;
                  };
                }

                return originalLink.pre ? originalLink.pre.apply(this, arguments) : this;
              },
              post: function (scope, element, attrs, ctrls) {
                return originalLink.post ? originalLink.post.apply(this, arguments) : originalLink.apply(this, arguments);
              },
            };
          };

          return $delegate;
        },
      ]);
    },
  ]);

  function AutoValidateRunFn(
    validator,
    defaultErrorMessageResolver,
    bootstrap3ElementModifier,
    foundation5ElementModifier,
    foundation6ElementModifier
  ) {
    validator.setErrorMessageResolver(defaultErrorMessageResolver.resolve);
    validator.registerDomModifier(bootstrap3ElementModifier.key, bootstrap3ElementModifier);
    validator.registerDomModifier(foundation5ElementModifier.key, foundation5ElementModifier);
    validator.registerDomModifier(foundation6ElementModifier.key, foundation6ElementModifier);
    validator.setDefaultElementModifier(bootstrap3ElementModifier.key);
  }

  AutoValidateRunFn.$inject = [
    'validator',
    'defaultErrorMessageResolver',
    'bootstrap3ElementModifier',
    'foundation5ElementModifier',
    'foundation6ElementModifier',
  ];
  angular.module('jcs-autoValidate').run(AutoValidateRunFn);
})(String, angular);

(function () {
  'use strict';
  angular.module('musix').filter('propsFilter', [filterFunction]);
  filterFunction.$inject = ['$scope'];
  /* @ngInject */
  function filterFunction() {
    return function (items, props) {
      var out = [];
      if (angular.isArray(items)) {
        // console.log('Items : ');
        // console.log(items);

        items.forEach(function (item) {
          var itemMatches = false;

          // console.log('Single Item : ');
          // console.log(item);

          var keys = Object.keys(props);
          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            //console.log(prop);
            if (item[prop] !== null && item[prop] !== undefined) {
              //console.log(item[prop]);
              if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                itemMatches = true;
                break;
              }
            }
          }
          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }
      return out;
    };
  }
})();

(function () {
  'use strict';
  angular.module('musix').filter('ObjTotal', [filterFunction]);
  filterFunction.$inject = ['$scope'];
  /* @ngInject */
  function filterFunction() {
    return function (items, props) {
      var out = [];
      if (angular.isArray(items)) {
        // //console.log("Items : ");
        // //console.log(items);
        var total = 0;
        items.forEach(function (value) {
          total += parseFloat(value[props]);
        });
        return Math.round(total * 100) / 100;
      } else {
        // Let the output be the input untouched
        out = items;
      }
      return out;
    };
  }
})();

(function () {
  'use strict';
  angular.module('musix').filter('ObjProp', [filterFunction]);
  filterFunction.$inject = ['$scope'];
  /* @ngInject */
  function filterFunction() {
    return function (items, props) {
      var out = [];
      if (angular.isArray(items)) {
        var keys = Object.keys(props);
        var prop = keys[0];
        var text = props[prop];

        out = items.filter(function (el) {
          return el[prop] === text;
        });
      }
      return out;
    };
  }
})();

angular.module('musix').directive('scrollOnClick', function () {
  return {
    restrict: 'A',
    scope: {
      scrollTo: '@',
    },
    link: function (scope, $elm, attrs) {
      //var idToScroll = attrs.href;
      $elm.on('click', function () {
        $('html,body').animate({ scrollTop: $(scope.scrollTo).offset().top }, 'slow');
      });
    },
  };
});

angular.module('musix').directive('disableRightClick', function () {
  return {
    restrict: 'A',
    link: function (scope, element, attr) {
      element.bind('contextmenu', function (e) {
        e.preventDefault();
      });
    },
  };
});

// (function() {
// 'use strict';

//     angular
//         .module('Module')
//         .service('Service', Service);

//     Service.$inject = ['dependency1'];
//     function Service(dependency1) {
//         this.exposedFn = exposedFn;

//         ////////////////

//         function exposedFn() { }
//         }
// })();

(function () {
  /**
   * @name storage service
   * @requires $analyticsProvider
   *
   * @description
   *
   */
  angular.module('Common.StorageService', []);
  var storage = null;
  angular
    .module('Common.StorageService')
    .config(['$provide', config])
    .factory('StorageService', ['$cookies', '$localStorage', '$rootScope', 'CacheFactory', '$injector', 'config', StorageService]);

  StorageService.$inject = ['$cookies', '$localStorage', '$rootScope', 'CacheFactory', '$injector', 'config'];
  /* @ngInject */
  function StorageService($cookies, $localStorage, $rootScope, CacheFactory, $injector, config) {
    return {
      getItem: getItem,
      setItem: setItem,
      isExist: isExist,
      setCookie: setCookie,
      getCookie: getCookie,
      removeCookie: removeCookie,
      getFromStorage: getFromStorage,
      setToStorage: setToStorage,
      deleteAllCookies: deleteAllCookies,
      readCookieUsingLegacy: readCookieUsingLegacy,
      deleteCookie: deleteCookie,
      getBooleanCookie: getBooleanCookie,
      clearAllData: clearAllData,
      getCache: getCache,
      updateLocalStorage: updateLocalStorage,
    };

    function parseJSON(data) {
      var jsonObject = null;
      if (data) {
        try {
          jsonObject = JSON.parse(data);
        } catch (e) {
          throw new Error(e);
        }
      }
      return jsonObject;
    }
    function getItem(key) {
      if (isExist(key)) {
        return parseJSON(storage.getItem(key));
      }
    }
    function setItem(key, value) {
      if (isExist(key)) {
        storage.removeItem(key);
      }
      storage.setItem(key, JSON.stringify(value));
    }

    function isExist(key) {
      return storage.getItem(key) !== null;
    }

    function setCookie(key, value) {
      if ($rootScope.isBrowser) {
        var cookies = [];

        if ($rootScope.cookies === undefined) {
          $rootScope.cookies = [];
        } else {
          cookies = $rootScope.cookies;
        }

        if (
          cookies !== undefined &&
          cookies.filter(function (v) {
            return v.name === key;
          })[0] !== undefined
        ) {
          cookies.filter(function (v) {
            return v.name === key;
          })[0].value = value;
        } else {
          cookies.push({
            name: key,
            value: value,
          });
        }
        $rootScope.cookies = cookies;
      } else {
        storage.setItem(key, value);
      }
    }

    function getCookie(key) {
      if ($rootScope.isBrowser) {
        if (
          $rootScope.cookies !== undefined &&
          $rootScope.cookies.filter(function (v) {
            return v.name === key;
          })[0] !== undefined
        ) {
          var currentCookie = $rootScope.cookies.filter(function (v) {
            return v.name === key;
          })[0];
          return currentCookie.value;
        }
        var currentKeyValue = $cookies.get(key);
        setCookie(key, currentKeyValue);
        return currentKeyValue;
      }
      return storage.getItem(key);
    }

    function getBooleanCookie(key) {
      if ($rootScope.isBrowser) {
        return parseJSON($cookies.get(key));
      }
      return parseJSON(storage.getItem(key));
    }

    function removeCookie(key) {
      if ($rootScope.isBrowser) {
        return $cookies.remove(key);
      }
      return storage.removeItem(key);
    }
    function setToStorage(key, value) {
      if ($rootScope.isBrowser) {
        $localStorage[key] = JSON.stringify(value);
      } else {
        storage.setItem(key, JSON.stringify(value));
      }
    }
    function getFromStorage(key) {
      if ($rootScope.isBrowser) {
        return parseJSON($localStorage[key]);
      }
      return parseJSON(storage.getItem(key));
    }
    function updateLocalStorage(key, value) {
      if ($rootScope.isBrowser) {
        $localStorage[key] = value;
      } else {
        storage.setItem(key, value);
      }
    }

    function readCookieUsingLegacy(name) {
      if ($rootScope.isBrowser) {
        var ca = document.cookie.split(';');
        var nameEQ = name + '=';
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') c = c.substring(1, c.length); // delete spaces
          if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
      }
      return null;
    }

    function deleteCookie(name) {
      if ($rootScope.isBrowser) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      }
    }

    function deleteAllCookies() {
      if ($rootScope.isBrowser) {
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i];
          var eqPos = cookie.indexOf('=');
          var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          name = name.replace(' ', '');
          deleteCookie(name);
        }
      }
    }

    function clearAllData() {
      localStorage.clear();
      deleteAllCookies();
      $rootScope.cookies = [];
    }

    function getCache() {
      var cache;
      if (!CacheFactory.get('uss')) {
        cache = CacheFactory.createCache('uss', {
          deleteOnExpire: 'aggressive',
          maxAge: 900000,
          onExpire: function (key, value) {
            var options = getFromStorage(key);
            var $http = $injector.get('$http');
            if (options.param) {
              var _this = this;
              var apiurl = config.remoteServiceName + options.url;
              $http.post(apiurl, options.param).success(function (data) {
                _this.put(key, data);
              });
            } else {
              var _this = this;
              var apiurl = config.remoteServiceName + options.url;
              $http.get(apiurl).success(function (data) {
                _this.put(key, data);
              });
            }
          },
        });
      } else {
        cache = CacheFactory.get('uss');
      }
      return cache;
    }
  }
  function config($provide) {
    if (window.cordova) {
      // app is running on device
      storage = window.localStorage;
    } else {
      storage = localStorage;
    }
  }
})();

(function () {
  'use strict';

  /* @ngdoc object
   * @name common.service
   * @requires $stateProvider
   *
   * @description: factory
   *
   */
  angular.module('Common.DataService', []);

  // TODO: Renaming variables.

  angular.module('Common.DataService').config(['$provide', config]);

  angular
    .module('Common.DataService')
    .service('DataService', [
      '$q',
      'FileSaver',
      'Blob',
      'config',
      '$window',
      '$http',
      '$state',
      'notify',
      'StorageService',
      '$rootScope',
      'lodash',
      DataService,
    ]);

  DataService.$inject = ['$q', 'FileSaver', 'Blob', 'config', '$window', '$http', '$state', 'notify', 'StorageService', '$rootScope', 'lodash'];
  /* @ngInject */
  function DataService($q, FileSaver, Blob, config, $window, $http, $state, notify, StorageService, $rootScope, lodash) {
    return {
      getDataApiConfig: getDataApiConfig,
      get: get,
      post: post,
      put: put,
      deleteRequest: deleteRequest,
      updateLocalStorage: updateLocalStorage,
      clearLocalStorage: clearLocalStorage,
      getJsonData: getJsonData,
    };

    function ApiConfig(opt) {
      var defaultOpt = {
        parameter: undefined,
        showToaster: undefined,
        showSpinner: false,
        isLocalStorage: undefined,
        responseType: undefined,
        age: 900000,
      };
      this.options = opt || defaultOpt;
      if (opt !== undefined) {
        if (opt.parameter === undefined) {
          this.options.parameter = defaultOpt.parameter;
        }
        if (opt.showToaster === undefined) {
          this.options.showToaster = defaultOpt.showToaster;
        }
        if (opt.showSpinner === undefined) {
          this.options.showSpinner = defaultOpt.showSpinner;
        }
        if (opt.isLocalStorage === undefined) {
          this.options.isLocalStorage = defaultOpt.isLocalStorage;
        }
        if (opt.age === undefined) {
          this.options.age = defaultOpt.age;
        }
        if (opt.responseType === undefined) {
          this.options.responseType = defaultOpt.responseType;
        }
      }
    }

    function getDataApiConfig(options) {
      if (options instanceof ApiConfig) {
        return options;
      }
      return new ApiConfig(options);
    }

    function get(resource, apiConfig) {
      var deferred = $q.defer();
      var apiUrl = resource;
      var emAPIToken = StorageService.getCookie('ussAPIToken');
      if (emAPIToken !== undefined) {
        $http.defaults.headers.common.Authorization = 'Bearer ' + emAPIToken;
      }

      var uss = StorageService.getCache();

      if (apiConfig.options.isLocalStorage === undefined || uss.keys().indexOf(apiConfig.options.isLocalStorage) === -1) {
        if (apiConfig.options.parameter !== undefined) {
          if (angular.isObject(apiConfig.options.parameter)) {
            var getParams = apiConfig.options.parameter;
          } else {
            apiUrl = apiUrl + apiConfig.options.parameter;
            var getParams = null;
          }
        }
        if (apiConfig.options.showSpinner === true) {
          $rootScope.startSpinner();
        }
        $http
          .get(config.apiURL + apiUrl, { params: getParams })
          .then(function (response) {
            var data = response.data;
            var status = response.status;
            var statusText = response.statusText;
            var headers = response.headers;
            var config = response.config;

            if (apiConfig.options.showSpinner) {
              $rootScope.stopSpinner();
            }
            if (data === null && status !== 200) {
              notify({ message: status, classes: 'alert-danger' });
              deferred.reject(status);
            } else if (data === undefined) {
              if (apiConfig.options.isLocalStorage) {
                var options = {
                  url: apiUrl,
                  param: undefined,
                };
                StorageService.setToStorage(apiConfig.options.isLocalStorage, options);
                uss.put(apiConfig.options.isLocalStorage, data);
              }
              deferred.resolve(data);
            } else {
              if (apiConfig.options.isLocalStorage) {
                var options = {
                  url: apiUrl,
                  param: undefined,
                };
                StorageService.setToStorage(apiConfig.options.isLocalStorage, options);
                uss.put(apiConfig.options.isLocalStorage, data);
              }
              deferred.resolve(data);
            }
          })
          .catch(function (response) {
            var data = response.data;
            var status = response.status;
            var statusText = response.statusText;
            var headers = response.headers;
            var config = response.config;
            if (apiConfig.options.showSpinner) {
              $rootScope.stopSpinner();
            }
            if (status === 401) {
              $state.go('app.401');
            } else if (status === 404) {
              if (apiConfig.options.showToaster === true) {
                notify({
                  message: 'Operation unsuccessfull : ' + data,
                  classes: 'alert-danger',
                });
              } else {
                notify({
                  message: 'Operation unsuccessfull : ' + status,
                  classes: 'alert-danger',
                });
              }
            } else {
              notify({
                message: 'Operation unsuccessfull : ' + status,
                classes: 'alert-danger',
              });
            }
            deferred.reject(status);
          });
      } else {
        deferred.resolve(uss.get(apiConfig.options.isLocalStorage));
        if (apiConfig.options.showSpinner === true) {
          $rootScope.stopSpinner();
        }
      }
      return deferred.promise;
    }

    function post(resource, apiConfig) {
      var deferred = $q.defer();
      var url = '';

      var uss = StorageService.getCache();

      if (apiConfig.options.isLocalStorage === undefined || uss.keys().indexOf(apiConfig.options.isLocalStorage) === -1) {
        if (apiConfig.options.showSpinner === true) {
          $rootScope.startSpinner();
        }

        if (resource === 'login') {
          url = config.authURL;
        } else {
          url = config.apiURL + resource;
        }

        if (apiConfig.options.responseType === 'arraybuffer') {
          $http.post(url, apiConfig.options.parameter, { responseType: 'arraybuffer' }, { ignoreLoadingBar: true }).then(function (response) {
            var data = response.data;
            var status = response.status;
            var statusText = response.statusText;
            var headers = response.headers;
            var config = response.config;

            var headCheck = headers('Content-Type');

            var contentDispositionHeader = headers('Content-Disposition');
            console.log(response);
            console.log(contentDispositionHeader);
            var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
            var filename = result.replace(/"/g, '');

            if (headCheck === 'application/pdf') {
              var file = new Blob([data], { type: 'application/pdf' });
              var fileURL = URL.createObjectURL(file);
              $window.open(fileURL);
              //FileSaver.saveAs(file, filename);
            } else {
              var file = new Blob([data], {
                type: headCheck,
              });
              FileSaver.saveAs(file, filename);
            }

            $rootScope.stopSpinner();
          });
        } else {
          $http
            .post(url, apiConfig.options.parameter, { ignoreLoadingBar: true })
            .then(function (response) {
              var data = response.data;
              var status = response.status;
              var statusText = response.statusText;
              var headers = response.headers;
              var config = response.config;

              $rootScope.stopSpinner();
              if (data === null && status !== 200) {
                notify({
                  message: 'Operation Unsuccessfull',
                  classes: 'alert-danger',
                });

                deferred.reject(status);
              } else if (data === undefined) {
                if (apiConfig.options.isLocalStorage) {
                  var options = {
                    url: resource,
                    param: apiConfig.options.parameter,
                  };
                  StorageService.setToStorage(apiConfig.options.isLocalStorage, options);
                  uss.put(apiConfig.options.isLocalStorage, data);
                }
                deferred.resolve(data);
              } else {
                if (apiConfig.options.showToaster !== undefined && apiConfig.options.showToaster !== true) {
                  notify({
                    message: apiConfig.options.shownotify,
                    classes: 'alert-success',
                  });
                } else if (apiConfig.options.showToaster === true) {
                  notify({
                    message: 'Operation Successfull : ' + data,
                    classes: 'alert-success',
                  });
                }
                if (apiConfig.options.isLocalStorage) {
                  var options = {
                    url: resource,
                    param: apiConfig.options.parameter,
                  };
                  StorageService.setToStorage(apiConfig.options.isLocalStorage, options);
                  uss.put(apiConfig.options.isLocalStorage, data);
                }
                deferred.resolve(data);
              }
            })
            .catch(function (response) {
              var data = response.data;
              var status = response.status;
              var statusText = response.statusText;
              var headers = response.headers;
              var config = response.config;

              $rootScope.stopSpinner();
              if (status === 401) {
                $state.go('app.401');
              } else {
                if (data !== null || data !== undefined) {
                  console.log(lodash.isObject(data));
                  if (lodash.isObject(data)) {
                    //manually control error list
                    $rootScope.stopSpinner();
                    deferred.resolve(data);
                  } else {
                    notify({
                      message: 'Error : ' + data,
                      classes: 'alert-danger',
                    });
                  }
                } else {
                  notify({
                    message: 'Operation unsuccessfull : ' + status,
                    classes: 'alert-danger',
                  });
                }
              }
              $rootScope.stopSpinner();
              deferred.reject(status);
            });
        }
      } else {
        deferred.resolve(uss.get(apiConfig.options.isLocalStorage));
        if (apiConfig.options.showSpinner === true) {
          $rootScope.stopSpinner();
        }
      }
      return deferred.promise;
    }

    function put(resource, apiConfig) {
      var deferred = $q.defer();

      $http
        .put(config.apiURL + resource, apiConfig.options.parameter)
        .success(function (data, status, headers, config) {
          if (data !== undefined && data === null) {
            notify({
              message: 'Operation unsuccessfull',
              classes: 'alert-danger',
            });
            deferred.reject(status);
          } else {
            if (apiConfig.options.showToaster !== undefined && apiConfig.options.showToaster !== true) {
              notify({
                message: apiConfig.options.shownotify,
                classes: 'alert-success',
              });
            } else if (apiConfig.options.showToaster === true) {
              notify({
                message: 'Operation Successfull',
                classes: 'alert-success',
              });
            }
            if (data === undefined) {
              deferred.resolve(data);
            }
            deferred.resolve(data);
          }
        })
        .error(function (data, status, headers, config) {
          if (status) {
            notify({
              message: 'Operation Unsuccessfull',
              classes: 'alert-danger',
            });
          }
          deferred.reject(status);
        });

      return deferred.promise;
    }

    function deleteRequest(resource, apiConfig) {
      var deferred = $q.defer();
      var apiUrl = resource;

      if (apiConfig.options.parameter !== undefined) {
        apiUrl = apiUrl + apiConfig.options.parameter;
      }

      $http
        .delete(config.apiURL + apiUrl)
        .success(function (data, status, headers, config) {
          if (data !== undefined && data === null) {
            if (apiConfig.options.showToaster) {
              notify({
                message: 'Operation Unsuccessfull',
                classes: 'alert-danger',
              });
            }
            deferred.reject(status);
          } else {
            if (apiConfig.options.showToaster !== undefined && apiConfig.options.showToaster !== true) {
              notify({
                message: apiConfig.options.shownotify,
                classes: 'alert-success',
              });
            } else if (apiConfig.options.showToaster === true) {
              notify({
                message: 'Operation Successfull',
                classes: 'alert-success',
              });
            }
            if (data === undefined) {
              deferred.resolve(data);
            }
            deferred.resolve(data);
          }
        })
        .error(function (data, status, headers, config) {
          if (status) {
            notify({
              message: 'Operation Unsuccessfull' + status,
              classes: 'alert-danger',
            });
          }
          deferred.reject(status);
        });

      return deferred.promise;
    }

    function clearLocalStorage(key) {
      StorageService.removeCookie(key);
    }
    function updateLocalStorage(key, value) {
      StorageService.updateLocalStorage(key, value);
    }

    function getJsonData(fileName) {
      var defer = $.Deferred();
      // $rootScope.startSpinner();
      $.getJSON(config.remoteServiceHost + fileName, function (data) {
        // $rootScope.stopSpinner();

        if (data !== null && data !== undefined) {
          defer.resolve(data);
        }
      });
      return defer.promise();
    }
  }

  function config($provide) {}
})();

// (function (String, angular) {
//   'use strict';

//   angular.module('autoValidate', []);

//   function ValidatorFn() {
//     var elementStateModifiers = {},
//       enableValidElementStyling = true,
//       enableInvalidElementStyling = true,
//       enableFirstInvalidElementScrollingOnSubmit = false,
//       validationEnabled = true,

//       toBoolean = function (value) {
//         var v;
//         if (value && value.length !== 0) {
//           v = value.toLowerCase();
//           value = !(v === 'f' || v === '0' || v === 'false');
//         } else {
//           value = false;
//         }

//         return value;
//       },

//       getAttributeValue = function (el, attrName) {
//         var val;

//         if (el !== undefined) {
//           val = el.attr(attrName) || el.attr('data-' + attrName);
//         }

//         return val;
//       },

//       attributeExists = function (el, attrName) {
//         var exists;

//         if (el !== undefined) {
//           exists = el.attr(attrName) !== undefined || el.attr('data-' + attrName) !== undefined;
//         }

//         return exists;
//       },

//       getBooleanAttributeValue = function (el, attrName) {
//         return toBoolean(getAttributeValue(el, attrName));
//       },

//       validElementStylingEnabled = function (el) {
//         return enableValidElementStyling && !getBooleanAttributeValue(el, 'disable-valid-styling');
//       },

//       autoValidateEnabledOnControl = function (el) {
//         return !getBooleanAttributeValue(el, 'disable-auto-validate');
//       },

//       invalidElementStylingEnabled = function (el) {
//         return enableInvalidElementStyling && !getBooleanAttributeValue(el, 'disable-invalid-styling');
//       };

//     /**
//      * @ngdoc function
//      * @name validator#enable
//      * @methodOf validator
//      *
//      * @description
//      * By default auto validate will validate all forms and elements with an ngModel directive on.  By
//      * setting enabled to false you will explicitly have to opt in to enable validation on forms and child
//      * elements.
//      *
//      * Note: this can be overridden by add the 'auto-validate-enabled="true/false' attribute to a form.
//      *
//      * Example:
//      * <pre>
//      *  app.config(function (validator) {
//      *    validator.enable(false);
//      *  });
//      * </pre>
//      *
//      * @param {Boolean} isEnabled true to enable, false to disable.
//      */
//     this.enable = function (isEnabled) {
//       validationEnabled = isEnabled;
//     };

//     /**
//      * @ngdoc function
//      * @name validator#isEnabled
//      * @methodOf validator
//      *
//      * @description
//      * Returns true if the library is enabeld.
//      *
//      * @return {Boolean} true if enabled, otherwise false.
//      */
//     this.isEnabled = function () {
//       return validationEnabled;
//     };

//     /**
//      * @ngdoc function
//      * @name validator#setDefaultElementModifier
//      * @methodOf validator
//      *
//      * @description
//      * Sets the default element modifier that will be used by the validator
//      * to change an elements UI state.  Please ensure the modifier has been registered
//      * before setting it as default.
//      *
//      * Note: this can be changed by setting the
//      * element modifier attribute on the input element 'data-element-modifier="myCustomModifier"'
//      *
//      * Example:
//      * <pre>
//      *  app.config(function (validator) {
//      *    validator.setDefaultElementModifier('myCustomModifier');
//      *  });
//      * </pre>
//      *
//      * @param {string} key The key name of the modifier.
//      */
//     this.setDefaultElementModifier = function (key) {
//       if (elementStateModifiers[key] === undefined) {
//         throw new Error('Element modifier not registered: ' + key);
//       }

//       this.defaultElementModifier = key;
//     };

//     /**
//      * @ngdoc function
//      * @name validator#registerDomModifier
//      * @methodOf validator
//      *
//      * @description
//      * Registers an object that adheres to the elementModifier interface and is
//      * able to modifier an elements dom so that appears valid / invalid for a specific
//      * scenario i.e. the Twitter Bootstrap css framework, Foundation CSS framework etc.
//      *
//      * Example:
//      * <pre>
//      *  app.config(function (validator) {
//      *    validator.registerDomModifier('customDomModifier', {
//      *      makeValid: function (el) {
//      *          el.removeClass(el, 'invalid');
//      *          el.addClass(el, 'valid');
//      *      },
//      *      makeInvalid: function (el, err, domManipulator) {
//      *          el.removeClass(el, 'valid');
//      *          el.addClass(el, 'invalid');
//      *      }
//      *    });
//      *  });
//      * </pre>
//      *
//      * @param {string} key The key name of the modifier
//      * @param {object} modifier An object which implements the elementModifier interface
//      */
//     this.registerDomModifier = function (key, modifier) {
//       elementStateModifiers[key] = modifier;
//     };

//     /**
//      * @ngdoc function
//      * @name validator#setErrorMessageResolver
//      * @methodOf validator
//      *
//      * @description
//      * Registers an object that adheres to the elementModifier interface and is
//      * able to modifier an elements dom so that appears valid / invalid for a specific
//      * scenario i.e. the Twitter Bootstrap css framework, Foundation CSS framework etc.
//      *
//      * Example:
//      * <pre>
//      *  app.config(function (validator) {
//      *    validator.setErrorMessageResolver(function (errorKey, el) {
//      *      var defer = $q.defer();
//      *      // resolve the correct error from the given key and resolve the returned promise.
//      *      return defer.promise();
//      *    });
//      *  });
//      * </pre>
//      *
//      * @param {function} resolver A method that returns a promise with the resolved error message in.
//      */
//     this.setErrorMessageResolver = function (resolver) {
//       this.errorMessageResolver = resolver;
//     };

//     /**
//      * @ngdoc function
//      * @name validator#getErrorMessage
//      * @methodOf validator
//      *
//      * @description
//      * Resolves the error message for the given error type.
//      *
//      * @param {String} errorKey The error type.
//      * @param {Element} el The UI element that is the focus of the error.
//      * It is provided as the error message may need information from the element i.e. ng-min (the min allowed value).
//      */
//     this.getErrorMessage = function (errorKey, el) {
//       var defer;
//       if (this.errorMessageResolver === undefined) {
//         throw new Error('Please set an error message resolver via the setErrorMessageResolver function before attempting to resolve an error message.');
//       }

//       if (attributeExists(el, 'disable-validation-message')) {
//         defer = angular.injector(['ng']).get('$q').defer();
//         defer.resolve('');
//         return defer.promise;
//       } else {
//         return this.errorMessageResolver(errorKey, el);
//       }
//     };

//     /**
//      * @ngdoc function
//      * @name validator#setValidElementStyling
//      * @methodOf validator
//      *
//      * @description
//      * Globally enables valid element visual styling.  This is enabled by default.
//      *
//      * @param {Boolean} enabled True to enable style otherwise false.
//      */
//     this.setValidElementStyling = function (enabled) {
//       enableValidElementStyling = enabled;
//     };

//     /**
//      * @ngdoc function
//      * @name validator#setInvalidElementStyling
//      * @methodOf validator
//      *
//      * @description
//      * Globally enables invalid element visual styling.  This is enabled by default.
//      *
//      * @param {Boolean} enabled True to enable style otherwise false.
//      */
//     this.setInvalidElementStyling = function (enabled) {
//       enableInvalidElementStyling = enabled;
//     };

//     /**
//      * @ngdoc function
//      * @name validator#setFirstInvalidElementScrollingOnSubmit
//      * @methodOf validator
//      *
//      * @description
//      * Globally enables first invalid element scrolling on form submit. This is disabled by default.
//      *
//      * @param enabled {Boolean} enabled True to enable scrolling otherwise false.
//      */
//     this.setFirstInvalidElementScrollingOnSubmit = function (enabled) {
//       enableFirstInvalidElementScrollingOnSubmit = enabled;
//     };

//     this.firstInvalidElementScrollingOnSubmitEnabled = function () {
//       return enableFirstInvalidElementScrollingOnSubmit;
//     };

//     this.getDomModifier = function (el) {
//       var modifierKey = (el !== undefined ? el.attr('element-modifier') : this.defaultElementModifier) ||
//         (el !== undefined ? el.attr('data-element-modifier') : this.defaultElementModifier) ||
//         this.defaultElementModifier;

//       if (modifierKey === undefined) {
//         throw new Error('Please set a default dom modifier via the setDefaultElementModifier method on the validator class.');
//       }

//       return elementStateModifiers[modifierKey];
//     };

//     this.makeValid = function (el) {
//       if (autoValidateEnabledOnControl(el)) {
//         if (validElementStylingEnabled(el)) {
//           this.getDomModifier(el).makeValid(el);
//         } else {
//           this.makeDefault(el);
//         }
//       }
//     };

//     this.makeInvalid = function (el, errorMsg) {
//       if (autoValidateEnabledOnControl(el)) {
//         if (invalidElementStylingEnabled(el)) {
//           this.getDomModifier(el).makeInvalid(el, errorMsg);
//         } else {
//           this.makeDefault(el);
//         }
//       }
//     };

//     this.makeDefault = function (el) {
//       if (autoValidateEnabledOnControl(el)) {
//         var dm = this.getDomModifier(el);
//         if (dm.makeDefault) {
//           dm.makeDefault(el);
//         }
//       }
//     };

//     this.waitForAsyncValidators = function (el) {
//       if (autoValidateEnabledOnControl(el)) {
//         var dm = this.getDomModifier(el);
//         if (dm.waitForAsyncValidators) {
//           dm.waitForAsyncValidators(el);
//         }
//       }
//     };

//     this.defaultFormValidationOptions = {
//       forceValidation: false,
//       disabled: false,
//       validateNonVisibleControls: false,
//       removeExternalValidationErrorsOnSubmit: true,
//       validateOnFormSubmit: false,
//       waitForAsyncValidators: true
//     };

//     this.$get = [
//       function () {
//         return this;
//       }
//     ];
//   }

//   angular.module('jcs-autoValidate').provider('validator', ValidatorFn);

//   function Bootstrap3ElementModifierFn($log) {
//     var customCss = [
//       '<style>' +
//       '.glyphicon-spin-jcs {' +
//       '-webkit-animation: spin 1000ms infinite linear;' +
//       'animation: spin 1000ms infinite linear;' +
//       '}' +
//       '@-webkit-keyframes spin {' +
//       '0% {' +
//       '-webkit-transform: rotate(0deg);' +
//       'transform: rotate(0deg);' +
//       '}' +
//       '100% {' +
//       '-webkit-transform: rotate(359deg);' +
//       'transform: rotate(359deg);' +
//       '}' +
//       '}' +
//       '@keyframes spin {' +
//       '0% {' +
//       '-webkit-transform: rotate(0deg);' +
//       'transform: rotate(0deg);' +
//       '}' +
//       '100% {' +
//       '-webkit-transform: rotate(359deg);' +
//       'transform: rotate(359deg);' +
//       '}' +
//       '}' +
//       '</style>'
//     ].join('');

//     angular.element(document.body).append(angular.element(customCss));

//     var reset = function (el) {
//       angular.forEach(el.find('span'), function (spanEl) {
//         spanEl = angular.element(spanEl);
//         if (spanEl.hasClass('error-msg') || spanEl.hasClass('form-control-feedback') || spanEl.hasClass('control-feedback')) {
//           spanEl.remove();
//         }
//       });

//       el.removeClass('has-success has-error has-feedback');
//     },
//       findWithClassElementAsc = function (el, klass) {
//         var returnEl,
//           parent = el;
//         for (var i = 0; i <= 10; i += 1) {
//           if (parent !== undefined && parent.hasClass(klass)) {
//             returnEl = parent;
//             break;
//           } else if (parent !== undefined) {
//             parent = parent.parent();
//           }
//         }

//         return returnEl;
//       },

//       findWithClassElementDesc = function (el, klass) {
//         var child;
//         for (var i = 0; i < el.children.length; i += 1) {
//           child = el.children[i];
//           if (child !== undefined && angular.element(child).hasClass(klass)) {
//             break;
//           } else if (child.children !== undefined) {
//             child = findWithClassElementDesc(child, klass);
//             if (child.length > 0) {
//               break;
//             }
//           }
//         }

//         return angular.element(child);
//       },

//       findFormGroupElement = function (el) {
//         return findWithClassElementAsc(el, 'form-group-custom');
//       },

//       findInputGroupElement = function (el) {
//         return findWithClassElementDesc(el, 'input-group');
//       },

//       insertAfter = function (referenceNode, newNode) {
//         referenceNode[0].parentNode.insertBefore(newNode[0], referenceNode[0].nextSibling);
//       },

//       /**
//        * @ngdoc property
//        * @name bootstrap3ElementModifier#addValidationStateIcons
//        * @propertyOf bootstrap3ElementModifier
//        * @returns {bool} True if an state icon will be added to the element in the valid and invalid control
//        * states.  The default is false.
//        */
//       addValidationStateIcons = false,

//       /**
//        * @ngdoc function
//        * @name bootstrap3ElementModifier#enableValidationStateIcons
//        * @methodOf bootstrap3ElementModifier
//        *
//        * @description
//        * Makes an element appear invalid by apply an icon to the input element.
//        *
//        * @param {bool} enable - True to enable the icon otherwise false.
//        */
//       enableValidationStateIcons = function (enable) {
//         addValidationStateIcons = enable;
//       },

//       /**
//        * @ngdoc function
//        * @name bootstrap3ElementModifier#makeValid
//        * @methodOf bootstrap3ElementModifier
//        *
//        * @description
//        * Makes an element appear valid by apply bootstrap 3 specific styles and child elements. If the service
//        * property 'addValidationStateIcons' is true it will also append validation glyphicon to the element.
//        * See: http://getbootstrap.com/css/#forms-control-validation
//        *
//        * @param {Element} el - The input control element that is the target of the validation.
//        */
//       makeValid = function (el) {
//         var frmGroupEl = findFormGroupElement(el),
//           inputGroupEl;

//         if (frmGroupEl) {
//           reset(frmGroupEl);
//           inputGroupEl = findInputGroupElement(frmGroupEl[0]);
//           frmGroupEl.addClass('has-success ' + (inputGroupEl.length > 0 || addValidationStateIcons === false ? '' : 'has-feedback'));
//           if (addValidationStateIcons) {
//             var iconElText = '<span class="glyphicon glyphicon-ok form-control-feedback"></span>';
//             if (inputGroupEl.length > 0) {
//               iconElText = iconElText.replace('form-', '');
//               iconElText = '<span class="input-group-addon control-feedback">' + iconElText + '</span';
//             }

//             insertAfter(el, angular.element(iconElText));
//           }
//         } else {
//           $log.error('Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group class L476');
//         }
//       },

//       /**
//        * @ngdoc function
//        * @name bootstrap3ElementModifier#makeInvalid
//        * @methodOf bootstrap3ElementModifier
//        *
//        * @description
//        * Makes an element appear invalid by apply bootstrap 3 specific styles and child elements. If the service
//        * property 'addValidationStateIcons' is true it will also append validation glyphicon to the element.
//        * See: http://getbootstrap.com/css/#forms-control-validation
//        *
//        * @param {Element} el - The input control element that is the target of the validation.
//        */
//       makeInvalid = function (el, errorMsg) {
//         var frmGroupEl = findFormGroupElement(el),
//           helpTextEl = angular.element('<span class="help-block has-error error-msg">' + errorMsg + '</span>'),
//           inputGroupEl;

//         if (frmGroupEl) {
//           reset(frmGroupEl);
//           inputGroupEl = findInputGroupElement(frmGroupEl[0]);
//           frmGroupEl.addClass('has-error ' + (inputGroupEl.length > 0 || addValidationStateIcons === false ? '' : 'has-feedback'));
//           insertAfter(inputGroupEl.length > 0 ? inputGroupEl : getCorrectElementToPlaceErrorElementAfter(el), helpTextEl);
//           if (addValidationStateIcons) {
//             var iconElText = '<span class="glyphicon glyphicon-remove form-control-feedback"></span>';
//             if (inputGroupEl.length > 0) {
//               iconElText = iconElText.replace('form-', '');
//               iconElText = '<span class="input-group-addon control-feedback">' + iconElText + '</span>';
//             }

//             insertAfter(getCorrectElementToPlaceErrorElementAfter(el), angular.element(iconElText));
//           }
//         } else {
//           $log.error('Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group class L512');
//         }
//       },

//       getCorrectElementToPlaceErrorElementAfter = function (el) {
//         var correctEl = el,
//           elType = el[0].type ? el[0].type.toLowerCase() : '';

//         if ((elType === 'checkbox' || elType === 'radio') && el.parent()[0].nodeName.toLowerCase() === 'label') {
//           correctEl = el.parent();
//         }

//         return correctEl;
//       },

//       /**
//        * @ngdoc function
//        * @name bootstrap3ElementModifier#makeDefault
//        * @methodOf bootstrap3ElementModifier
//        *
//        * @description
//        * Makes an element appear in its default visual state by apply bootstrap 3 specific styles and child elements.
//        *
//        * @param {Element} el - The input control element that is the target of the validation.
//        */
//       makeDefault = function (el) {
//         var frmGroupEl = findFormGroupElement(el);
//         if (frmGroupEl) {
//           reset(frmGroupEl);
//         } else {
//           $log.error('Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group class L542');
//         }
//       },

//       waitForAsyncValidators = function (el) {
//         var frmGroupEl = findFormGroupElement(el),
//           inputGroupEl;

//         if (frmGroupEl) {
//           reset(frmGroupEl);
//           inputGroupEl = findInputGroupElement(frmGroupEl[0]);
//           frmGroupEl.addClass('has-feedback ' + (inputGroupEl.length > 0 || addValidationStateIcons === false ? '' : 'has-feedback'));
//           if (addValidationStateIcons) {
//             var iconElText = '<span class="glyphicon glyphicon-repeat glyphicon-spin-jcs form-control-feedback"></span>';
//             if (inputGroupEl.length > 0) {
//               iconElText = iconElText.replace('form-', '');
//               iconElText = '<span class="input-group-addon control-feedback">' + iconElText + '</span>';
//             }

//             insertAfter(el, angular.element(iconElText));
//           }
//         } else {
//           $log.error('Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group class L564');
//         }
//       };

//     return {
//       makeValid: makeValid,
//       makeInvalid: makeInvalid,
//       makeDefault: makeDefault,
//       waitForAsyncValidators: waitForAsyncValidators,
//       enableValidationStateIcons: enableValidationStateIcons,
//       key: 'bs3'
//     };
//   }

//   Bootstrap3ElementModifierFn.$inject = [
//     '$log'
//   ];

//   angular.module('jcs-autoValidate').factory('bootstrap3ElementModifier', Bootstrap3ElementModifierFn);

//   /*
//    * Taken from https://github.com/angular/angular.js/issues/2690#issue-14462164 (with added tests of course!)
//    */
//   function JCSDebounceFn($timeout) {
//     var debounce = function (func, wait, immediate) {
//       var timeout;
//       return function () {
//         var context = this;
//         var args = arguments;
//         var later = function () {
//           timeout = null;
//           if (!immediate) {
//             func.apply(context, args);
//           }
//         };

//         var callNow = immediate && !timeout;
//         $timeout.cancel(timeout);
//         timeout = $timeout(later, wait, false);
//         if (callNow) {
//           func.apply(context, args);
//         }
//       };
//     };

//     return {
//       debounce: debounce
//     };
//   }

//   JCSDebounceFn.$inject = [
//     '$timeout'
//   ];

//   angular.module('jcs-autoValidate').factory('jcs-debounce', JCSDebounceFn);

//   /**
//    * Replaces string placeholders with corresponding template string
//    */
//   if (!('format' in String.prototype)) {
//     String.prototype.format = function () {
//       var args = arguments;
//       return this.replace(/{(\d+)}/g, function (match, number) {
//         return typeof args[number] !== undefined ? args[number] : match;
//       });
//     };
//   }

//   angular.autoValidate = angular.autoValidate || {
//     errorMessages: {}
//   };

//   angular.autoValidate.errorMessages['default'] = {
//     defaultMsg: 'Please add error message for {0}',
//     email: 'Please enter a valid email address',
//     minlength: 'Please enter at least {0} characters',
//     maxlength: 'You have entered more than the maximum {0} characters',
//     min: 'Please enter the minimum number of {0}',
//     max: 'Please enter the maximum number of {0}',
//     required: 'This field is required',
//     date: 'Please enter a valid date',
//     pattern: 'Please ensure the entered information adheres to this pattern {0}',
//     number: 'Please enter a valid number',
//     url: 'Please enter a valid URL in the format of http(s)://www.google.com'
//   };

//   function DefaultErrorMessageResolverFn($q, $http) {
//     var currentCulture = 'default',

//       i18nFileRootPath = 'js/angular-auto-validate/dist/lang',

//       cultureRetrievalPromise,

//       loadRemoteCulture = function (culture) {
//         cultureRetrievalPromise = $http.get('{0}/jcs-auto-validate_{1}.json'.format(i18nFileRootPath, culture.toLowerCase()));
//         return cultureRetrievalPromise;
//       },

//       /**
//        * @ngdoc function
//        * @name defaultErrorMessageResolver#setI18nFileRootPath
//        * @methodOf defaultErrorMessageResolver
//        *
//        * @description
//        * Set the root path to the il8n files on the server
//        *
//        * @param {String} rootPath - The root path on the server to the il8n file - this defaults
//        * to 'js/angular-auto-validate/lang/'
//        */
//       setI18nFileRootPath = function (rootPath) {
//         i18nFileRootPath = rootPath;
//       },

//       /**
//        * @ngdoc function
//        * @name defaultErrorMessageResolver#setCulture
//        * @methodOf defaultErrorMessageResolver
//        *
//        * @description
//        * Set the culture for the error messages by loading an the correct culture resource file.
//        *
//        * @param {String} culture - The new culture in the format of 'en-gb' etc.
//        * @param {Function} cultureLoadingFn - A optional function to load the culture resolve which should
//        * return a promise which is resolved with the culture errorMessage object.  If a function is not specified
//        * the culture file is loaded from the **i18nFileRootPath**.
//        * @returns {Promise} - A promise which is resolved with the loaded culture error messages object.
//        */
//       setCulture = function (culture, cultureLoadingFn) {
//         var defer = $q.defer();
//         cultureLoadingFn = cultureLoadingFn || loadRemoteCulture;
//         currentCulture = culture.toLowerCase();
//         if (angular.autoValidate.errorMessages[currentCulture] === undefined) {
//           cultureRetrievalPromise = cultureLoadingFn(culture);
//           cultureRetrievalPromise.then(function (response) {
//             cultureRetrievalPromise = undefined;
//             angular.autoValidate.errorMessages[currentCulture] = response.data;
//             defer.resolve(angular.autoValidate.errorMessages[currentCulture]);
//           }, function (err) {
//             angular.autoValidate.errorMessages[currentCulture] = {
//               defaultMsg: 'Loading culture failed!'
//             };
//             cultureRetrievalPromise = null;
//             defer.reject(err);
//           });
//         } else {
//           defer.resolve(angular.autoValidate.errorMessages[currentCulture]);
//         }

//         return defer.promise;
//       },

//       getErrorMessages = function (culture) {
//         var defer = $q.defer();
//         culture = culture === undefined ? currentCulture : culture.toLowerCase();
//         if (cultureRetrievalPromise !== undefined) {
//           cultureRetrievalPromise.then(function () {
//             defer.resolve(angular.autoValidate.errorMessages[culture]);
//           }, function (err) {
//             defer.reject(err);
//           });
//         } else {
//           defer.resolve(angular.autoValidate.errorMessages[culture]);
//         }
//         return defer.promise;
//       },

//       getMessageTypeOverride = function (errorType, el) {
//         var overrideKey;

//         if (el) {
//           // try and find an attribute which overrides the given error type in the form of errorType-err-type="someMsgKey"
//           errorType += '-err-type';

//           overrideKey = el.attr('ng-' + errorType);
//           if (overrideKey === undefined) {
//             overrideKey = el.attr('data-ng-' + errorType) || el.attr(errorType);
//           }

//           if (overrideKey) {
//             overrideKey = overrideKey.replace(/[\W]/g, '');
//           }
//         }

//         return overrideKey;
//       },

//       /**
//        * @ngdoc function
//        * @name defaultErrorMessageResolver#resolve
//        * @methodOf defaultErrorMessageResolver
//        *
//        * @description
//        * Resolves a validate error type into a user validation error message
//        *
//        * @param {String} errorType - The type of validation error that has occurred.
//        * @param {Element} el - The input element that is the source of the validation error.
//        * @returns {Promise} A promise that is resolved when the validation message has been produced.
//        */
//       resolve = function (errorType, el) {
//         var defer = $q.defer(),
//           errMsg,
//           parameters = [],
//           parameter,
//           messageTypeOverride;

//         if (cultureRetrievalPromise !== undefined) {
//           cultureRetrievalPromise.then(function () {
//             resolve(errorType, el).then(function (msg) {
//               defer.resolve(msg);
//             });
//           });
//         } else {
//           errMsg = angular.autoValidate.errorMessages[currentCulture][errorType];
//           messageTypeOverride = getMessageTypeOverride(errorType, el);
//           if (messageTypeOverride) {
//             errMsg = angular.autoValidate.errorMessages[currentCulture][messageTypeOverride];
//           }

//           if (errMsg === undefined && messageTypeOverride !== undefined) {
//             errMsg = angular.autoValidate.errorMessages[currentCulture].defaultMsg.format(messageTypeOverride);
//           } else if (errMsg === undefined) {
//             errMsg = angular.autoValidate.errorMessages[currentCulture].defaultMsg.format(errorType);
//           }

//           if (el && el.attr) {
//             try {
//               parameter = el.attr('ng-' + errorType);
//               if (parameter === undefined) {
//                 parameter = el.attr('data-ng-' + errorType) || el.attr(errorType);
//               }

//               parameters.push(parameter || '');

//               errMsg = errMsg.format(parameters);
//             } catch (e) { }
//           }

//           defer.resolve(errMsg);
//         }

//         return defer.promise;
//       };

//     return {
//       setI18nFileRootPath: setI18nFileRootPath,
//       setCulture: setCulture,
//       getErrorMessages: getErrorMessages,
//       resolve: resolve
//     };
//   }

//   DefaultErrorMessageResolverFn.$inject = [
//     '$q',
//     '$http'
//   ];

//   angular.module('jcs-autoValidate').factory('defaultErrorMessageResolver', DefaultErrorMessageResolverFn);

//   function Foundation5ElementModifierFn() {
//     var reset = function (el, inputEl) {
//       angular.forEach(el.find('small'), function (smallEl) {
//         if (angular.element(smallEl).hasClass('error')) {
//           angular.element(smallEl).remove();
//         }
//       });

//       inputEl.removeClass('error');
//     },
//       findParentColumn = function (el) {
//         var parent = el;
//         for (var i = 0; i <= 3; i += 1) {
//           if (parent !== undefined && (parent.hasClass('columns') || parent.hasClass('column'))) {
//             break;
//           } else if (parent !== undefined) {
//             parent = parent.parent();
//           }
//         }

//         return parent;
//       },

//       /**
//        * @ngdoc function
//        * @name foundation5ElementModifier#makeValid
//        * @methodOf foundation5ElementModifier
//        *
//        * @description
//        * Makes an element appear valid by apply Foundation 5 specific styles and child elements.
//        * See: http://foundation.zurb.com/docs/components/forms.html
//        *
//        * @param {Element} el - The input control element that is the target of the validation.
//        */
//       makeValid = function (el) {
//         var parentColumn = findParentColumn(el);
//         reset(parentColumn && parentColumn.length > 0 ? parentColumn : el, el);
//       },

//       /**
//        * @ngdoc function
//        * @name foundation5ElementModifier#makeInvalid
//        * @methodOf foundation5ElementModifier
//        *
//        * @description
//        * Makes an element appear invalid by apply Foundation 5 specific styles and child elements.
//        * See: http://foundation.zurb.com/docs/components/forms.html
//        *
//        * @param {Element} el - The input control element that is the target of the validation.
//        */
//       makeInvalid = function (el, errorMsg) {
//         var parentColumn = findParentColumn(el),
//           helpTextEl;
//         reset(parentColumn || el, el);
//         el.addClass('error');
//         if (parentColumn) {
//           helpTextEl = angular.element('<small class="error">' + errorMsg + '</small>');
//           parentColumn.append(helpTextEl);
//         }
//       },

//       /**
//        * @ngdoc function
//        * @name foundation5ElementModifier#makeDefault
//        * @methodOf foundation5ElementModifier
//        *
//        * @description
//        * Makes an element appear in its default visual state by apply foundation 5 specific styles and child elements.
//        *
//        * @param {Element} el - The input control element that is the target of the validation.
//        */
//       makeDefault = function (el) {
//         makeValid(el);
//       };

//     return {
//       makeValid: makeValid,
//       makeInvalid: makeInvalid,
//       makeDefault: makeDefault,
//       key: 'foundation5'
//     };
//   }

//   angular.module('jcs-autoValidate').factory('foundation5ElementModifier', Foundation5ElementModifierFn);

//   function ElementUtilsFn() {
//     var isElementVisible = function (el) {
//       return el[0].offsetWidth > 0 && el[0].offsetHeight > 0;
//     };

//     return {
//       isElementVisible: isElementVisible
//     };
//   }

//   function ValidationManagerFn(validator, elementUtils, $anchorScroll) {
//     var elementTypesToValidate = ['input', 'textarea', 'select', 'form'],

//       elementIsVisible = function (el) {
//         return elementUtils.isElementVisible(el);
//       },

//       getFormOptions = function (el) {
//         var frmCtrl = angular.element(el).controller('form'),
//           options;

//         if (frmCtrl !== undefined && frmCtrl !== null) {
//           options = frmCtrl.autoValidateFormOptions;
//         } else {
//           options = validator.defaultFormValidationOptions;
//         }

//         return options;
//       },

//       /**
//        * Only validate if the element is present, it is visible, if it is not a comment,
//        * it is either a valid user input control (input, select, textare, form) or
//        * it is a custom control register by the developer.
//        * @param el
//        * @param formOptions The validation options of the parent form
//        * @returns {boolean} true to indicate it should be validated
//        */
//       shouldValidateElement = function (el, formOptions, formSubmitted) {
//         var elementExists = el && el.length > 0,
//           isElementAComment = elementExists && el[0].nodeName.toLowerCase() === '#comment',
//           correctVisibilityToValidate,
//           correctTypeToValidate,
//           correctPhaseToValidate;

//         if (elementExists && isElementAComment === false) {
//           correctVisibilityToValidate = elementIsVisible(el) || formOptions.validateNonVisibleControls;
//           correctTypeToValidate = elementTypesToValidate.indexOf(el[0].nodeName.toLowerCase()) > -1 ||
//             el[0].hasAttribute('register-custom-form-control');
//           correctPhaseToValidate = formOptions.validateOnFormSubmit === false ||
//             (formOptions.validateOnFormSubmit === true && formSubmitted === true);
//         }

//         return elementExists && !isElementAComment && correctVisibilityToValidate && correctTypeToValidate && correctPhaseToValidate;

//       },

//       /**
//        * @ngdoc validateElement
//        * @name validation#validateElement
//        * @param {object} modelCtrl holds the information about the element e.g. $invalid, $valid
//        * @param {options}
//        *  - forceValidation if set to true forces the validation even if the element is pristine
//        *  - disabled if set to true forces the validation is disabled and will return true
//        *  - validateNonVisibleControls if set to true forces the validation of non visible element i.e. display:block
//        * @description
//        * Validate the form element and make invalid/valid element model status.
//        *
//        * As of v1.17.22:
//        * BREAKING CHANGE to validateElement on the validationManger.  The third parameter is now the parent form's
//        * autoValidateFormOptions object on the form controller.  This can be left blank and will be found by the
//        * validationManager.
//        */
//       validateElement = function (modelCtrl, el, options) {
//         var isValid = true,
//           frmOptions = options || getFormOptions(el),
//           needsValidation = modelCtrl.$pristine === false || frmOptions.forceValidation,
//           errorType,
//           findErrorType = function ($errors) {
//             var keepGoing = true,
//               errorTypeToReturn;
//             angular.forEach($errors, function (status, errortype) {
//               if (keepGoing && status) {
//                 keepGoing = false;
//                 errorTypeToReturn = errortype;
//               }
//             });

//             return errorTypeToReturn;
//           };

//         if (frmOptions.disabled === false) {
//           if ((frmOptions.forceValidation ||
//             (shouldValidateElement(el, frmOptions, frmOptions.getFormController().$submitted) &&
//               modelCtrl &&
//               needsValidation))) {
//             isValid = !modelCtrl.$invalid;

//             if (frmOptions.removeExternalValidationErrorsOnSubmit && modelCtrl.removeAllExternalValidation) {
//               modelCtrl.removeAllExternalValidation();
//             }

//             if (modelCtrl.$pending !== undefined && options.waitForAsyncValidators === true) {
//               // we have pending async validators
//               validator.waitForAsyncValidators(el);
//             } else {
//               if (isValid) {
//                 validator.makeValid(el);
//               } else {
//                 errorType = findErrorType(modelCtrl.$errors || modelCtrl.$error);
//                 if (errorType === undefined) {
//                   // we have a weird situation some users are encountering where a custom control
//                   // is valid but the ngModel is report it isn't and thus no valid error type can be found
//                   isValid = true;
//                 } else {
//                   validator.getErrorMessage(errorType, el).then(function (errorMsg) {
//                     validator.makeInvalid(el, errorMsg);
//                   });
//                 }
//               }
//             }
//           }
//         }

//         return isValid;
//       },

//       resetElement = function (element) {
//         validator.makeDefault(element);
//       },

//       resetForm = function (frmElement) {
//         angular.forEach((frmElement[0].all || frmElement[0].elements) || frmElement[0], function (element) {
//           var controller,
//             ctrlElement = angular.element(element);
//           controller = ctrlElement.controller('ngModel');

//           if (controller !== undefined) {
//             if (ctrlElement[0].nodeName.toLowerCase() === 'form') {
//               // we probably have a sub form
//               resetForm(ctrlElement);
//             } else {
//               controller.$setPristine();
//             }
//           }
//         });
//       },

//       validateForm = function (frmElement) {
//         var frmValid = true,
//           frmCtrl = frmElement ? angular.element(frmElement).controller('form') : undefined,
//           processElement = function (ctrlElement, force, formOptions) {
//             var controller, isValid, ctrlFormOptions, originalForceValue;

//             ctrlElement = angular.element(ctrlElement);
//             controller = ctrlElement.controller('ngModel');

//             if (controller !== undefined && (force || shouldValidateElement(ctrlElement, formOptions, frmCtrl.$submitted))) {
//               if (ctrlElement[0].nodeName.toLowerCase() === 'form') {
//                 // we probably have a sub form
//                 validateForm(ctrlElement);
//               } else {
//                 // we need to get the options for the element rather than use the passed in as the
//                 // element could be an ng-form and have different options to the parent form.
//                 ctrlFormOptions = getFormOptions(ctrlElement);
//                 originalForceValue = ctrlFormOptions.forceValidation;
//                 ctrlFormOptions.forceValidation = force;
//                 try {
//                   isValid = validateElement(controller, ctrlElement, ctrlFormOptions);
//                   if (validator.firstInvalidElementScrollingOnSubmitEnabled() && !isValid && frmValid) {
//                     var ctrlElementId = ctrlElement.attr('id');
//                     if (ctrlElementId) {
//                       $anchorScroll(ctrlElementId);
//                     }
//                   }
//                   frmValid = frmValid && isValid;
//                 } finally {
//                   ctrlFormOptions.forceValidation = originalForceValue;
//                 }
//               }
//             }
//           },
//           clonedOptions;

//         if (frmElement === undefined || (frmCtrl !== undefined && frmCtrl.autoValidateFormOptions.disabled)) {
//           return frmElement !== undefined;
//         }

//         //force the validation of controls
//         clonedOptions = angular.copy(frmCtrl.autoValidateFormOptions);
//         clonedOptions.forceValidation = true;

//         // IE8 holds the child controls collection in the all property
//         // Firefox in the elements and chrome as a child iterator
//         angular.forEach((frmElement[0].elements || frmElement[0].all) || frmElement[0], function (ctrlElement) {
//           processElement(ctrlElement, true, clonedOptions);
//         });

//         // If you have a custom form control that should be validated i.e.
//         // <my-custom-element>...</my-custom-element> it will not be part of the forms
//         // HTMLFormControlsCollection and thus won't be included in the above element iteration although
//         // it will be on the Angular FormController (if it has a name attribute).  So adding the directive
//         // register-custom-form-control="" to the control root and autoValidate will include it in this
//         // iteration.
//         if (frmElement[0].customHTMLFormControlsCollection) {
//           angular.forEach(frmElement[0].customHTMLFormControlsCollection, function (ctrlElement) {
//             // need to force the validation as the element might not be a known form input type
//             // so the normal validation process will ignore it.
//             processElement(ctrlElement, true, clonedOptions);
//           });
//         }

//         return frmValid;
//       },

//       setElementValidationError = function (element, errorMsgKey, errorMsg) {
//         if (errorMsgKey) {
//           validator.getErrorMessage(errorMsgKey, element).then(function (msg) {
//             validator.makeInvalid(element, msg);
//           });
//         } else {
//           validator.makeInvalid(element, errorMsg);
//         }
//       };

//     return {
//       setElementValidationError: setElementValidationError,
//       validateElement: validateElement,
//       validateForm: validateForm,
//       resetElement: resetElement,
//       resetForm: resetForm
//     };
//   }

//   ValidationManagerFn.$inject = [
//     'validator',
//     'jcs-elementUtils',
//     '$anchorScroll'
//   ];

//   angular.module('jcs-autoValidate').factory('jcs-elementUtils', ElementUtilsFn);
//   angular.module('jcs-autoValidate').factory('validationManager', ValidationManagerFn);

//   function parseBooleanAttributeValue(val, defaultValue) {
//     if ((val === undefined || val === null) && defaultValue !== undefined) {
//       return defaultValue;
//     } else {
//       return val !== 'false';
//     }
//   }

//   function parseOptions(ctrl, validator, attrs) {
//     var opts = ctrl.autoValidateFormOptions = ctrl.autoValidateFormOptions || angular.copy(validator.defaultFormValidationOptions);

//     // needed to stop circular ref in json serialisation
//     opts.getFormController = function () {
//       return ctrl;
//     };
//     opts.waitForAsyncValidators = parseBooleanAttributeValue(attrs.waitForAsyncValidators, opts.waitForAsyncValidators);
//     opts.forceValidation = false;
//     opts.disabled = !validator.isEnabled() || parseBooleanAttributeValue(attrs.disableDynamicValidation, opts.disabled);
//     opts.validateNonVisibleControls = parseBooleanAttributeValue(attrs.validateNonVisibleControls, opts.validateNonVisibleControls);
//     opts.validateOnFormSubmit = parseBooleanAttributeValue(attrs.validateOnFormSubmit, opts.validateOnFormSubmit);
//     opts.removeExternalValidationErrorsOnSubmit = attrs.removeExternalValidationErrorsOnSubmit === undefined ?
//       opts.removeExternalValidationErrorsOnSubmit :
//       parseBooleanAttributeValue(attrs.removeExternalValidationErrorsOnSubmit, opts.removeExternalValidationErrorsOnSubmit);

//     // the library might be globally disabled but enabled on a particular form so check the
//     // disableDynamicValidation attribute is on the form
//     if (validator.isEnabled() === false && attrs.disableDynamicValidation === 'false') {
//       opts.disabled = false;
//     }
//   }

//   angular.module('jcs-autoValidate').directive('form', [
//     'validator',
//     function (validator) {
//       return {
//         restrict: 'E',
//         require: 'form',
//         priority: 9999,
//         compile: function () {
//           return {
//             pre: function (scope, element, attrs, ctrl) {
//               parseOptions(ctrl, validator, attrs);
//             }
//           };
//         }
//       };
//     }
//   ]);

//   angular.module('jcs-autoValidate').directive('ngForm', [
//     'validator',
//     function (validator) {
//       return {
//         restrict: 'EA',
//         require: 'form',
//         priority: 9999,
//         compile: function () {
//           return {
//             pre: function (scope, element, attrs, ctrl) {
//               parseOptions(ctrl, validator, attrs);
//             }
//           };
//         }
//       };
//     }
//   ]);

//   function FormResetDirectiveFn(validationManager) {
//     return {
//       restrict: 'E',
//       link: function (scope, el) {
//         var formController = el.controller('form');

//         function resetFn() {
//           validationManager.resetForm(el);
//           if (formController.$setPristine) {
//             formController.$setPristine();
//           }

//           if (formController.$setUntouched) {
//             formController.$setUntouched();
//           }
//         }

//         if (formController !== undefined &&
//           formController.autoValidateFormOptions &&
//           formController.autoValidateFormOptions.disabled === false) {
//           el.on('reset', resetFn);

//           scope.$on('$destroy', function () {
//             el.off('reset', resetFn);
//           });
//         }
//       }
//     };
//   }

//   FormResetDirectiveFn.$inject = [
//     'validationManager'
//   ];

//   angular.module('jcs-autoValidate').directive('form', FormResetDirectiveFn);

//   function RegisterCustomFormControlFn() {
//     var findParentForm = function (el) {
//       var parent = el;
//       for (var i = 0; i <= 50; i += 1) {
//         if (parent !== undefined && parent.nodeName.toLowerCase() === 'form') {
//           break;
//         } else if (parent !== undefined) {
//           parent = angular.element(parent).parent()[0];
//         }
//       }

//       return parent;
//     };

//     return {
//       restrict: 'A',
//       link: function (scope, element) {
//         var frmEl = findParentForm(element.parent()[0]);
//         if (frmEl) {
//           frmEl.customHTMLFormControlsCollection = frmEl.customHTMLFormControlsCollection || [];
//           frmEl.customHTMLFormControlsCollection.push(element[0]);
//         }
//       }
//     };
//   }

//   angular.module('jcs-autoValidate').directive('registerCustomFormControl', RegisterCustomFormControlFn);

//   function SubmitDecorator($delegate, $parse, validationManager) {
//     $delegate[0].compile = function ($element, attrs) {
//       var fn = $parse(attrs.ngSubmit),
//         force = attrs.ngSubmitForce === 'true';

//       return function (scope, element) {
//         var formController = element.controller('form'),
//           resetListenerOffFn;

//         function handlerFn(event) {
//           scope.$apply(function () {
//             if (formController !== undefined &&
//               formController !== null &&
//               formController.autoValidateFormOptions &&
//               formController.autoValidateFormOptions.disabled === true) {
//               fn(scope, {
//                 $event: event
//               });
//             } else {
//               if (formController.$setSubmitted === undefined) {
//                 // we probably have angular <= 1.2
//                 formController.$submitted = true;
//               }

//               if (validationManager.validateForm(element) || force === true) {
//                 fn(scope, {
//                   $event: event
//                 });
//               }
//             }
//           });
//         }

//         function resetFormFn() {
//           if (element[0].reset) {
//             element[0].reset();
//           } else {
//             validationManager.resetForm(element);
//           }
//         }

//         if (formController && formController.autoValidateFormOptions) {
//           // allow the form to be reset programatically or via raising the event
//           // form:formName:reset
//           formController.autoValidateFormOptions.resetForm = resetFormFn;
//           if (formController.$name !== undefined && formController.$name !== '') {
//             resetListenerOffFn = scope.$on('form:' + formController.$name + ':reset', resetFormFn);
//           }
//         }

//         element.on('submit', handlerFn);
//         scope.$on('$destroy', function () {
//           element.off('submit', handlerFn);
//           if (resetListenerOffFn) {
//             resetListenerOffFn();
//           }
//         });
//       };
//     };

//     return $delegate;
//   }

//   SubmitDecorator.$inject = [
//     '$delegate',
//     '$parse',
//     'validationManager'
//   ];

//   function ProviderFn($provide) {
//     $provide.decorator('ngSubmitDirective', SubmitDecorator);
//   }

//   ProviderFn.$inject = [
//     '$provide'
//   ];

//   angular.module('jcs-autoValidate').config(ProviderFn);

//   angular.module('jcs-autoValidate').config(['$provide',
//     function ($provide) {
//       $provide.decorator('ngModelDirective', [
//         '$timeout',
//         '$delegate',
//         'validationManager',
//         'jcs-debounce',
//         function ($timeout, $delegate, validationManager, debounce) {
//           var directive = $delegate[0],
//             link = directive.link || directive.compile;

//           directive.compile = function (el) {
//             var supportsNgModelOptions = angular.version.major >= 1 && angular.version.minor >= 3,
//               originalLink = link;

//             // in the RC of 1.3 there is no directive.link only the directive.compile which
//             // needs to be invoked to get at the link functions.
//             if (supportsNgModelOptions && angular.isFunction(link)) {
//               originalLink = link(el);
//             }

//             return {
//               pre: function (scope, element, attrs, ctrls) {
//                 var ngModelCtrl = ctrls[0],
//                   frmCtrl = ctrls[1],
//                   ngModelOptions = attrs.ngModelOptions === undefined ? undefined : scope.$eval(attrs.ngModelOptions),
//                   setValidity = ngModelCtrl.$setValidity,
//                   setPristine = ngModelCtrl.$setPristine,
//                   setValidationState = debounce.debounce(function () {
//                     var validateOptions = frmCtrl !== undefined && frmCtrl !== null ? frmCtrl.autoValidateFormOptions : undefined;
//                     validationManager.validateElement(ngModelCtrl, element, validateOptions);
//                   }, 100);

//                 if (attrs.formnovalidate === undefined &&
//                   (frmCtrl !== undefined && frmCtrl !== null && frmCtrl.autoValidateFormOptions &&
//                     frmCtrl.autoValidateFormOptions.disabled === false)) {
//                   // if the version of angular supports ng-model-options let angular handle the element.on bit
//                   // fixes issue with async validators
//                   if (supportsNgModelOptions ||
//                     (!supportsNgModelOptions || ngModelOptions === undefined || ngModelOptions.updateOn === undefined || ngModelOptions.updateOn === '')) {
//                     ngModelCtrl.$setValidity = function (validationErrorKey, isValid) {
//                       setValidity.call(ngModelCtrl, validationErrorKey, isValid);
//                       setValidationState();
//                     };
//                   } else {
//                     element.on(ngModelOptions.updateOn, function () {
//                       setValidationState();
//                     });

//                     scope.$on('$destroy', function () {
//                       element.off(ngModelOptions.updateOn);
//                     });
//                   }

//                   // We override this so we can reset the element state when it is called.
//                   ngModelCtrl.$setPristine = function () {
//                     setPristine.call(ngModelCtrl);
//                     validationManager.resetElement(element);
//                   };

//                   ngModelCtrl.autoValidated = true;
//                 }

//                 ngModelCtrl.setExternalValidation = function (errorMsgKey, errorMessage, addToModelErrors) {
//                   if (addToModelErrors) {
//                     var collection = ngModelCtrl.$error || ngModelCtrl.$errors;
//                     collection[errorMsgKey] = false;
//                   }

//                   ngModelCtrl.externalErrors = ngModelCtrl.externalErrors || {};
//                   ngModelCtrl.externalErrors[errorMsgKey] = false;
//                   validationManager.setElementValidationError(element, errorMsgKey, errorMessage);
//                 };

//                 ngModelCtrl.removeExternalValidation = function (errorMsgKey, addToModelErrors) {
//                   if (addToModelErrors) {
//                     var collection = ngModelCtrl.$error || ngModelCtrl.$errors;
//                     delete collection[errorMsgKey];
//                   }

//                   if (ngModelCtrl.externalErrors) {
//                     delete ngModelCtrl.externalErrors[errorMsgKey];
//                   }

//                   validationManager.resetElement(element);
//                 };

//                 ngModelCtrl.removeAllExternalValidation = function () {
//                   if (ngModelCtrl.externalErrors) {
//                     var errorCollection = ngModelCtrl.$error || ngModelCtrl.$errors;
//                     angular.forEach(ngModelCtrl.externalErrors, function (value, key) {
//                       delete errorCollection[key];
//                     });

//                     ngModelCtrl.externalErrors = {};

//                     validationManager.resetElement(element);
//                   }
//                 };

//                 if (frmCtrl) {
//                   frmCtrl.setExternalValidation = function (modelProperty, errorMsgKey, errorMessageOverride, addToModelErrors) {
//                     var success = false;
//                     if (frmCtrl[modelProperty]) {
//                       frmCtrl[modelProperty].setExternalValidation(errorMsgKey, errorMessageOverride, addToModelErrors);
//                       success = true;
//                     }

//                     return success;
//                   };

//                   frmCtrl.removeExternalValidation = function (modelProperty, errorMsgKey, errorMessageOverride, addToModelErrors) {
//                     var success = false;
//                     if (frmCtrl[modelProperty]) {
//                       frmCtrl[modelProperty].removeExternalValidation(errorMsgKey, addToModelErrors);
//                       success = true;
//                     }

//                     return success;
//                   };
//                 }

//                 return originalLink.pre ?
//                   originalLink.pre.apply(this, arguments) :
//                   this;
//               },
//               post: function (scope, element, attrs, ctrls) {
//                 return originalLink.post ?
//                   originalLink.post.apply(this, arguments) :
//                   originalLink.apply(this, arguments);
//               }
//             };
//           };

//           return $delegate;
//         }
//       ]);
//     }
//   ]);

//   function AutoValidateRunFn(validator, defaultErrorMessageResolver, bootstrap3ElementModifier, foundation5ElementModifier) {
//     validator.setErrorMessageResolver(defaultErrorMessageResolver.resolve);
//     validator.registerDomModifier(bootstrap3ElementModifier.key, bootstrap3ElementModifier);
//     validator.registerDomModifier(foundation5ElementModifier.key, foundation5ElementModifier);
//     validator.setDefaultElementModifier(bootstrap3ElementModifier.key);
//   }

//   AutoValidateRunFn.$inject = [
//     'validator',
//     'defaultErrorMessageResolver',
//     'bootstrap3ElementModifier',
//     'foundation5ElementModifier'
//   ];

//   angular.module('jcs-autoValidate').run(AutoValidateRunFn);

// } (String, angular));

(function () {
  'use strict';

  angular.module('musix').service('Authorization', ['StorageService', AuthService]);
  AuthService.$inject = ['StorageService'];

  /* @ngInject */
  function AuthService(StorageService) {
    return {
      TokenPresent: TokenPresent,
    };

    this.isAuthorized = false;

    function TokenPresent() {
      var tokenPresent = StorageService.isExist('ussAPIToken');
      // var loginTime = new Date(StorageService.getCookie('loginTime'));
      // var currentTime = new Date();
      // if (loginTime !== null || loginTime !== undefined) {
      //   var tdiff = parseInt((currentTime - loginTime) / 1000);

      //   if (tdiff > 800) {
      //     this.isAuthorized = false;
      //     return false;
      //   }
      // }

      if (tokenPresent) {
        this.isAuthorized = true;
        return true;
      }
      this.isAuthorized = false;
      return false;
    }
  }
})();

(function () {
  'use strict';

  angular.module('musix').controller('roleCtrl', ['$state', '$location', 'lodash', 'notify', 'adminService', CtrlFunction]);
  CtrlFunction.$inject = ['$state', '$location', 'lodash', 'notify', 'adminService'];
  /* @ngInject */
  function CtrlFunction($state, $location, lodash, notify, adminService) {
    var vm = this;
    vm.formdata = {};
    vm.showForm = false;
    vm.records = [];
    vm.menuMaster = {};
    vm.SelectedMenu = {};
    vm.isEdit = false;
    var RolePermissions = [];

    vm.submitRecord = function () {
      if (Object.keys(vm.formdata).length) {
        vm.gridOptions2.api.forEachNode(function (node) {
          RolePermissions.push(node.data);
        });

        vm.formdata.RolePermissions = RolePermissions;
        vm.submitData = JSON.stringify(vm.formdata, null, 2);
        adminService.UpsertPlantMaster(vm.submitData).then(function (data) {
          if (data) {
            vm.showForm = false;
            init();
          }
        });
      } else {
        notify('warning', 'Please Enter Form Data');
      }
    };

    /**
     * @name editRecord
     * @kind function
     * @description for editing selected row in grid
     */
    vm.editRecord = function () {
      vm.selectedRowData = vm.gridOptions.api.getSelectedRows();
      vm.formdata = vm.selectedRowData[0];
      vm.gridOptions2.api.setRowData(vm.formdata.RolePermissions);
      if (vm.formdata) {
        vm.showForm = true;
        vm.isEdit = true;
      } else {
        notify({ message: 'Select A Record', classes: 'alert-warning' });
      }
    };

    /**
     * @name newRecord
     * @kind function
     * @description for adding new record
     */
    vm.newRecord = function () {
      vm.formdata = {};
      vm.showForm = true;
      vm.isEdit = false;
      vm.gridOptions2.api.setRowData([]);
    };

    /**
     * @ngdoc function
     * @name cancelRecord
     * @description for canceling the form
     */
    vm.cancelForm = function () {
      vm.showForm = false;
      vm.formdata = {};
      vm.isEdit = false;
      vm.gridOptions2.api.setRowData([]);
      $state.go('home.main');
    };
    /**
     * @ngDoc function
     * @name getProcess
     * @kind function
     * @description for getting process data for the grid
     * @param  none
     * @returns none
     */
    function init() {
      adminService.GetRoleMaster().then(function (data) {
        vm.gridOptions.api.setRowData(data);
        vm.gridOptions.api.sizeColumnsToFit();
      });
    }
    init();

    function dateFormatter(params) {
      return params.value ? new Date(params.value).toLocaleDateString('en-GB') : '';
    }

    var columnDefs = [
      { headerName: 'RoleId', field: 'RoleId', checkboxSelection: true },
      { headerName: 'RoleName', field: 'RoleName' },
      { headerName: 'RoleDescription', field: 'RoleDescription' },
      { headerName: 'AddDate', field: 'AddDate', valueFormatter: dateFormatter },
    ];

    /**
     * @ngDoc function
     * @name gridOptions
     * @description for initializing grid in view
     * @param  none
     * @returns none
     */
    vm.gridOptions = {
      columnDefs: columnDefs,
      angularCompileRows: true,
      enableColResize: true,
      suppressDragLeaveHidesColumns: true,
      enableSorting: true,
      enableFilter: true,
      floatingFilter: true,
      rowSelection: 'single',
      rowDeselection: true,
    };
  }
})();

(function () {
  'use strict';

  angular.module('musix').service('userMasterService', ['userMasterResource', Service]);
  Service.$inject = ['userMasterResource'];
  /* @ngInject */
  function Service(userMasterResource) {
    return {
      getuserService: getuserService,
      postuser: postuser,
      getallroles: getallroles,
      GetGstinMaster: GetGstinMaster,
      GetUserByDepartment: GetUserByDepartment,
    };

    function GetUserByDepartment(data) {
      return userMasterResource.GetUserByDepartment(data);
    }
    function GetGstinMaster() {
      return userMasterResource.GetGstinMaster();
    }

    function getuserService() {
      return userMasterResource.getuserResource();
    }

    function getallroles() {
      return userMasterResource.getallroles();
    }

    function postuser(data) {
      return userMasterResource.postuser(data);
    }
  }
})();

(function () {
  'use strict';

  angular.module('musix').service('userMasterResource', ['DataService', Resource]);
  Resource.$inject = ['DataService'];
  /* @ngInject */
  function Resource(DataService) {
    return {
      getuserResource: getuserResource,
      postuser: postuser,
      getallroles: getallroles,
      GetGstinMaster: GetGstinMaster,
      GetUserByDepartment: GetUserByDepartment,
    };

    function GetGstinMaster() {
      var apiConfig = DataService.getDataApiConfig({ showSpinner: true });
      return DataService.get('/user/GetGstinMaster', apiConfig);
    }

    function GetUserByDepartment(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showSpinner: true });
      return DataService.get('/user/GetUserByDepartment/', apiConfig);
    }

    function getuserResource() {
      var apiConfig = DataService.getDataApiConfig({ showSpinner: true });
      return DataService.get('/user/GetUserMaster', apiConfig);
    }

    function getallroles() {
      var apiConfig = DataService.getDataApiConfig({ showSpinner: true });
      return DataService.get('/user/getallroles', apiConfig);
    }

    function postuser(data) {
      var apiConfig = DataService.getDataApiConfig({
        parameter: data,
        showSpinner: true,
        showToaster: true,
      });
      return DataService.post('/user/upsertuser', apiConfig);
    }
  }
})();

(function () {
  'use strict';

  angular.module('musix').controller('userCtrl', ['$state', 'notify', 'adminService', 'userMasterService', userCtrl]);
  userCtrl.inject = ['$state', 'notify', 'adminService', 'userMasterService'];
  /* @ngInject */
  function userCtrl($state, notify, adminService, userMasterService) {
    var vm = this;

    vm.useridisable = false;
    vm.formdata = {};
    vm.role = {};
    vm.RoleMaster = {};
    vm.SelectedRole = {};
    vm.SelectedGstin = {};

    vm.GetRoles = function () {
      userMasterService.getallroles().then(function (data) {
        vm.AllRoles = data;
      });
    };
    /**
     * @ngDoc function
     * @name viewRecord
     * @kind function
     * @description for viewing selected row in grid
     */
    vm.viewRecord = function (onRowSelected) {
      vm.selectedRowData = vm.gridOptions.api.getSelectedRows();
      vm.formdata = vm.selectedRowData[0];
      if (Object.keys(vm.formdata).length > 0) {
        vm.showForm = true;
        vm.isView = true;
        vm.useridisable = true;
        clearSelectedValues();
        if (vm.formdata.Role !== null && Object.keys(vm.formdata.Role).length > 0) {
          vm.SelectedRole = vm.formdata.Role;
        }
        if (vm.formdata.Gstin !== null && Object.keys(vm.formdata.Gstin).length > 0) {
          vm.SelectedGstin = vm.formdata.Gstin;
        }
      } else {
        notify({
          message: 'Select a record to view.',
          classes: 'alert-warning',
        });
      }
    };
    /**
     * @ngDoc function
     * @name newRecord
     * @kind function
     * @description for adding new user
     */
    vm.newRecord = function () {
      vm.showForm = true;
      vm.formdata = {};
      vm.isView = false;
      vm.useridisable = false;
      clearSelectedValues();
    };

    function clearSelectedValues() {
      vm.SelectedRole = {};
      vm.SelectedGstin = {};
    }
    /**
     * @ngDoc function
     * @name editRecord
     * @kind function
     * @description for editing selected row
     */
    vm.editRecord = function () {
      vm.selectedRowData = vm.gridOptions.api.getSelectedRows();
      vm.formdata = vm.selectedRowData[0];
      if (vm.formdata) {
        if (!vm.formdata.IsAccountDisabled) {
          clearSelectedValues();
          if (vm.formdata.Role !== null && Object.keys(vm.formdata.Role).length > 0) {
            vm.SelectedRole = vm.formdata.Role;
          }
          if (vm.formdata.Gstin !== null && Object.keys(vm.formdata.Gstin).length > 0) {
            vm.SelectedGstin.Gstin = vm.formdata.Gstin;
          }
          vm.useridisable = true;
          vm.showForm = true;
          vm.isView = false;
        } else {
          notify({
            message: 'Cannot edit closed account.',
            classes: 'alert-warning',
          });
        }
      } else {
        notify({
          message: 'Select a record to edit.',
          classes: 'alert-warning',
        });
      }
    };

    /**
     * @ngDoc function
     * @name submitRecord
     * @kind function
     * @description for submiting new or edited record
     */
    // submit record
    vm.submitRecord = function () {
      if (Object.keys(vm.formdata).length > 0) {
        if (vm.SelectedRole !== null && Object.keys(vm.SelectedRole).length > 0) {
          vm.formdata.RoleId = vm.SelectedRole.RoleId;
        }
        if (vm.SelectedGstin !== null && Object.keys(vm.SelectedGstin).length > 0) {
          vm.formdata.Gstin = vm.SelectedGstin.Gstin;
        } else {
          vm.formdata.Gstin = '';
        }
        vm.submitData = JSON.stringify(vm.formdata);
        userMasterService.postuser(vm.submitData).then(function (data) {
          // this is for refereshing grid
          if (data !== null) {
            vm.showForm = false;
            vm.isView = false;
            init();
          }
        });
      } else {
        notify('warning', 'Please Select User Role');
        notify({
          message: 'Select a user role.',
          classes: 'alert-warning',
        });
      }
    };

    /**
     * @ngDoc function
     * @name getuserService
     * @kind function
     * @description for fetching data for grid
     */
    // for grid data
    function init() {
      userMasterService.getuserService().then(function (data) {
        vm.records = data;
        vm.gridOptions.api.setRowData(vm.records);
        vm.gridOptions.columnApi.autoSizeAllColumns();

        // var allColIds = vm.gridOptions.columnApi.getAllColumns()
        // allColIds.forEach(element => {
        //   params.columnApi.autoSizeColumns(element);
        // });
        //vm.gridOptions.api.sizeColumnsToFit();
      });
    }
    init();

    vm.cancelForm = function () {
      vm.showForm = false;
      $state.reload();
    };

    vm.GetRoleMaster = function () {
      adminService.GetRoleMaster().then(function (data) {
        vm.RoleMaster = data;
      });
    };

    vm.GetGstinMaster = function () {
      userMasterService.GetGstinMaster().then(function (data) {
        vm.GstinMaster = data;
      });
    };

    var columnDefs = [
      { headerName: 'UserName', field: 'UserName', checkboxSelection: true },
      { headerName: 'FullName', field: 'FullName' },
      { headerName: 'EmailId', field: 'EmailId' },
      { headerName: 'PhoneNo', field: 'PhoneNo' },
      { headerName: 'Designation', field: 'Designation' },
      { headerName: 'Role', field: 'Role.RoleName' },
      { headerName: 'GSTIN', field: 'Gstin' },
      { headerName: 'Last Login Date', field: 'LastLoginDate' },
      { headerName: 'Password Change Date', field: 'PasswordChangeDate' },
      { headerName: 'Account Disabled', field: 'IsAccountDisabled' },
      { headerName: 'Account Disabled Date', field: 'AccountDisabledDate' },
    ];

    /**
     * @ngDoc function
     * @name gridOptions
     * @kind function
     * @description for initialize grid in view
     */

    vm.gridOptions = {
      // onGridReady: function () {
      //   vm.gridOptions.api.showLoadingOverlay();
      // },
      columnDefs: columnDefs,
      angularCompileRows: true,
      //suppressMenuHide: true,
      enableColResize: true,
      suppressDragLeaveHidesColumns: true,
      enableSorting: true,
      enableFilter: true,
      floatingFilter: true,
      rowSelection: 'single',
      rowDeselection: true,
      // rowHeight: 48,
      animateRows: true,
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('musix')
    .service('gstinmasterService', ['gstinmasterResource', Service]);
  Service.$inject = ['gstinmasterResource'];
  /* @ngInject */
  function Service(gstinmasterResource) {
    return {
      GetGstinMaster: GetGstinMaster,
      SaveGstinMaster: SaveGstinMaster
    };

    function GetGstinMaster() {
      return gstinmasterResource.GetGstinMaster();
    }
    function SaveGstinMaster(data) {
      return gstinmasterResource.SaveGstinMaster(data);
    }
  }
})();

(function () {
  'use strict';

  angular.module('musix').service('gstinmasterResource', ['DataService', Resource]);
  Resource.$inject = ['DataService'];
  /* @ngInject */
  function Resource(DataService) {
    return {
      GetGstinMaster: GetGstinMaster,
      SaveGstinMaster: SaveGstinMaster,
    };

    function GetGstinMaster() {
      var apiConfig = DataService.getDataApiConfig({ showSpinner: true });
      return DataService.get('/user/GetGstinMaster', apiConfig);
    }
    function SaveGstinMaster(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showToaster: true });
      return DataService.post('/user/SaveGstinMaster', apiConfig);
    }
  }
})();

(function () {
  'use strict';

  angular.module('musix').controller('gstinmasterCtrl', ['lodash', 'notify', 'gstinmasterService', Controller]);

  Controller.$inject = ['lodash', 'notify', 'gstinmasterService'];
  /* @ngInject */
  function Controller(lodash, notify, gstinmasterService) {
    var vm = this;
    vm.discode = false;
    /**
     * @ngDoc function
     * @name newRecord
     * @kind function
     * @description for adding new state
     * @param  none
     * @returns none
     */
    vm.newRecord = function () {
      vm.discode = false;
      vm.showform = true;
      vm.formdata = {};
    };
    /**
     * @ngDoc function
     * @name editRecord
     * @kind function
     * @description for editing selected row
     * @param  none
     * @returns none
     */
    vm.editRecord = function () {
      vm.discode = true;
      vm.selectedRowData = vm.gridOptions.api.getSelectedRows();
      vm.formdata = vm.selectedRowData[0];
      if (vm.formdata) {
        vm.showform = true;
      } else {
        notify({ message: 'To Edit Select A Record.', classes: 'alert-warning' });
      }
    };

    /**
     * @ngDoc function
     * @name submitRecord
     * @kind function
     * @description for submiting new state
     * @param  none
     * @returns none
     */
    //submit record
    vm.submitRecord = function () {
      if (lodash.isUndefined(vm.formdata.Gstin) || lodash.isEmpty(vm.formdata.Gstin)) {
        notify({ message: 'Please Enter GSTIN.', classes: 'alert-warning' });
      } else {
        vm.discode = false;
        vm.submitData = JSON.stringify(vm.formdata);
        gstinmasterService.SaveGstinMaster(vm.submitData).then(function (data) {
          vm.showform = false;
          // this is for refereshing grid
          if (data !== null) {
            gstinmasterService.GetGstinMaster().then(function (data) {
              vm.records = data;
              vm.gridOptions.api.setRowData(vm.records);
            });
          }
        });
      }
    };

    /**
     * @ngDoc function
     * @name getstateService
     * @kind function
     * @description for fetching data for grid
     * @param  none
     * @returns none
     */
    //for grid
    gstinmasterService.GetGstinMaster().then(function (data) {
      if (data) {
        vm.records = data;
        vm.gridOptions.api.setRowData(vm.records);
        vm.gridOptions.columnApi.autoSizeAllColumns();
      } else vm.gridOptions.api.setRowData([]);
    });
    var columnDefs = [
      { headerName: 'GSTIN', field: 'Gstin' },
      { headerName: 'Trade Name', field: 'TradeName' },
      { headerName: 'Legal Name', field: 'LegalName' },
      { headerName: 'AddrBnm', field: 'AddrBnm' },
      { headerName: 'AddrBno', field: 'AddrBno' },
      { headerName: 'AddrFlno', field: 'AddrFlno' },
      { headerName: 'AddrSt', field: 'AddrSt' },
      { headerName: 'AddrLoc', field: 'AddrLoc' },
      { headerName: 'StateCode', field: 'StateCode' },
      { headerName: 'AddrPncd', field: 'AddrPncd' },
      { headerName: 'TxpType', field: 'TxpType' },
      { headerName: 'Status', field: 'Status' },
      { headerName: 'BlkStatus', field: 'BlkStatus' },
      { headerName: 'DtReg', field: 'DtReg' },
      { headerName: 'DtDReg', field: 'DtDReg' },
      { headerName: 'Gsp Eway Key', field: 'GspApiKey' },
      { headerName: 'Gsp Eway Username', field: 'GspApiUsername' },
      { headerName: 'Gsp Eway Password', field: 'GspApiPassword' },
      { headerName: 'Eway Username', field: 'EWBUsername' },
      { headerName: 'Eway Password', field: 'EWBPassword' },
      { headerName: 'Gsp E-Inv Key', field: 'GspEinvApiKey' },
      { headerName: 'Gsp E-Inv Username', field: 'GspEinvApiUsername' },
      { headerName: 'Gsp E-Inv Password', field: 'GspEinvApiPassword' },
      { headerName: 'E-Inv UserName', field: 'EInvUserName' },
      { headerName: 'E-Inv Password', field: 'EInvPassword' },
    ];
    /**
     * @ngDoc function
     * @name gridOptions
     * @description for initializing grid
     * @param  none
     * @returns none
     */
    vm.gridOptions = {
      // onGridReady: function () {
      //   vm.gridOptions.api.showLoadingOverlay();
      // },
      columnDefs: columnDefs,
      angularCompileRows: true,
      //suppressMenuHide: true,
      enableColResize: true,
      suppressDragLeaveHidesColumns: true,
      enableSorting: true,
      enableFilter: true,
      floatingFilter: true,
      rowSelection: 'single',
      rowDeselection: true,
      // rowHeight: 48,
      animateRows: true,
    };
  }
})();

(function () {
  angular.module('Login', []);
})();

(function () {
  'use strict';

  angular.module('Login').service('LoginResource', ['DataService', LoginResource]);

  LoginResource.$inject = ['DataService'];

  function LoginResource(DataService) {
    return {
      login: login,
    };

    function login(user) {
      var data = 'grant_type=password&username=' + encodeURIComponent(user.username) + '&password=' + encodeURIComponent(user.password);
      var apiConfig = DataService.getDataApiConfig({
        parameter: data,
        showSpinner: true,
      });
      return DataService.post('login', apiConfig);
    }
  }
})();

(function () {
  'use strict';

  angular.module('Login').service('LoginService', ['LoginResource', 'StorageService', LoginService]);

  LoginService.$inject = ['LoginResource', 'StorageService'];

  /* @ngInject */
  function LoginService(LoginResource, StorageService) {
    return {
      login: login,
    };

    function login(user) {
      return LoginResource.login(user);
    }
  }
})();

(function () {
  'use strict';

  angular.module('Login').controller('LoginCtrl', ['$state', 'lodash', 'notify', 'StorageService', 'userProfileService', 'LoginService', LoginCtrl]);

  LoginCtrl.$inject = ['$state', 'lodash', 'notify', 'StorageService', 'userProfileService', 'LoginService'];
  /* @ngInject */
  function LoginCtrl($state, lodash, notify, StorageService, userProfileService, LoginService) {
    var vm = this;
    vm.user = { username: '', password: '' };
    vm.invalidCreds = false;
    vm.errorMessage = '';

    vm.login = function () {
      LoginService.login(vm.user).then(function (response) {
        if (response.hasOwnProperty('error')) {
          notify({
            message: 'Error : ' + response.error + ' Description :' + response.error_description,
            classes: 'alert-danger',
          });
        }
        if (response.hasOwnProperty('access_token')) {
          StorageService.setCookie('ussAPIToken', response.access_token);
          userProfileService.GetUserDetailByUserName(vm.user.username).then(function (response2) {
            StorageService.setCookie('FullName', response2.FullName);
            StorageService.setCookie('UserTitle', response2.Designation);
            StorageService.setCookie('UserDepartment', response2.UserDepartment);
            StorageService.setCookie('UserDepartmentId', response2.DepartmentId);
            StorageService.setCookie('RoleId', response2.RoleId);
            StorageService.setCookie('UserName', response2.Username);
            StorageService.setCookie('UserPhoto', response2.ProfilePhoto);
            // if (response2.UserName === '') StorageService.setCookie('IsNightMode', 1);
            // else StorageService.setCookie('IsNightMode', 0);
            $state.go('app.dashboard');
          });
        }
      });
    };

    vm.Quotes = [
      {
        quote: "In the end, it's not the years in your life that count. It's the life in your years.",
        author: 'Abraham Lincoln',
      },
      {
        quote: "The greatest day in your life and mine is when we take total responsibility for our attitudes.That's the day we truly grow up.",
        author: 'John C. Maxwell',
      },
      {
        quote: 'Life is not a problem to be solved, but a reality to be experienced.',
        author: 'Soren Kierkegaard',
      },
      {
        quote: 'What we think determines what happens to us, so if we want to change our lives, we need to stretch our minds.',
        author: 'Wayne Dyer',
      },
      {
        quote: 'Life is ten percent what happens to you and ninety percent how you respond to it.',
        author: 'Lou Holtz',
      },
      {
        quote: 'Believe that life is worth living and your belief will help create the fact.',
        author: 'William James',
      },
      {
        quote: 'The only disability in life is a bad attitude.',
        author: 'Scott Hamilton',
      },
      {
        quote:
          'Too often we underestimate the power of a touch, a smile, a kind word, a listening ear, an honest compliment, or the smallest act of caring, all of which have the potential to turn a life around.',
        author: 'Leo Buscaglia',
      },
      {
        quote: "Life isn't about finding yourself.Life is about creating yourself.",
        author: 'George Bernard Shaw',
      },
      {
        quote: 'There is more to life than increasing its speed.',
        author: 'Mahatma Gandhi',
      },
      {
        quote: 'Life is really simple, but we insist on making it complicated.',
        author: 'Confucius',
      },
      {
        quote: "Our prime purpose in this life is to help others.And if you can't help them, at least don't hurt them.",
        author: 'Dalai Lama',
      },
      {
        quote: 'There are three constants in life...change, choice and principles.',
        author: 'Stephen Covey',
      },
      {
        quote: 'Lifes most persistent and urgent question is, What are you doing for others?',
        author: 'Martin Luther King, Jr.',
      },
      {
        quote:
          "Life is a series of natural and spontaneous changes.Don't resist them--that only creates sorrow.Let reality be reality.Let things flow naturally forward in whatever way they like.",
        author: 'Lao Tzu',
      },
      {
        quote: 'Change is the law of life.And those who look only to the past or present are certain to miss the future.',
        author: 'John F.Kennedy',
      },
      {
        quote: 'Only a life lived for others is a life worthwhile.',
        author: 'Albert Einstein',
      },
      {
        quote:
          'When life is too easy for us, we must beware or we may not be ready to meet the blows which sooner or later come to everyone, rich or poor.',
        author: 'Eleanor Roosevelt',
      },
      {
        quote: 'God gave us the gift of life; it is up to us to give ourselves the gift of living well.',
        author: 'Voltaire',
      },
      {
        quote: 'We make a living by what we get, but we make a life by what we give.',
        author: 'Winston Churchill',
      },
      {
        quote: 'All life is an experiment.The more experiments you make the better.',
        author: 'Ralph Waldo Emerson',
      },
      {
        quote:
          'My mission in life is not merely to survive, but to thrive; and to do so with some passion, some compassion, some humor, and some style.',
        author: 'Maya Angelou',
      },
      {
        quote: "Once you say you're going to settle for second, that's what happens to you in life.",
        author: 'John F.Kennedy',
      },
      {
        quote: 'There is no passion to be found playing small--in settling for a life that is less than the one you are capable of living.',
        author: 'Nelson Mandela',
      },
      {
        quote:
          "If you don't design your own life plan, chances are you'll fall into someone else's plan. And guess what they have planned for you? Not much.",
        author: 'Jim Rohn',
      },
      {
        quote: "I've failed over and over and over again in my life and that is why I succeed.",
        author: 'Michael Jordan',
      },
      {
        quote: 'The biggest adventure you can take is to live the life of your dreams.',
        author: 'Oprah Winfrey',
      },
      {
        quote:
          'Literature adds to reality, it does not simply describe it.It enriches the necessary competencies that daily life requires and provides; and in this respect, it irrigates the deserts that our lives have already become.',
        author: 'C.S.Lewis',
      },
      {
        quote:
          'Anyone who stops learning is old, whether at twenty or eighty. Anyone who keeps learning stays young.The greatest thing in life is to keep your mind young.',
        author: 'Henry Ford',
      },
      {
        quote: "Many of life's failures are people who did not realize how close they were to success when they gave up.",
        author: 'Thomas A. Edison',
      },
      {
        quote:
          'The most difficult thing is the decision to act, the rest is merely tenacity.The fears are paper tigers.You can do anything you decide to do.You can act to change and control your life; and the procedure, the process is its own reward.',
        author: 'Amelia Earhart',
      },
      {
        quote: 'People grow through experience if they meet life honestly and courageously.This is how character is built.',
        author: 'Eleanor Roosevelt',
      },
      {
        quote:
          'Remember your dreams and fight for them. You must know what you want from life.There is just one thing that makes your dream become impossible: the fear of failure.',
        author: 'Paulo Coelho',
      },
      {
        quote:
          'Our greatest happiness does not depend on the condition of life in which chance has placed us, but is always the result of a good conscience, good health, occupation, and freedom in all just pursuits.',
        author: 'Thomas Jefferson',
      },
      {
        quote:
          "The quality of a person's life is in direct proportion to their commitment to excellence, regardless of their chosen field of endeavor.",
        author: 'Vince Lombardi',
      },
      {
        quote:
          "Communication is a skill that you can learn. It's like riding a bicycle or typing.If you're willing to work at it, you can rapidly improve the quality of every part of your life.",
        author: 'Brian Tracy',
      },
      {
        quote:
          'Today is life--the only life you are sure of.Make the most of today.Get interested in something.Shake yourself awake.Develop a hobby.Let the winds of enthusiasm sweep through you.Live today with gusto.',
        author: 'Dale Carnegie',
      },
      {
        quote:
          "The secret of success is learning how to use pain and pleasure instead of having pain and pleasure use you. If you do that, you're in control of your life.If you don't, life controls you.",
        author: 'Tony Robbins',
      },
      {
        quote: "In three words I can sum up everything I've learned about life: it goes on.",
        author: 'Robert Frost',
      },
      {
        quote: 'We have always held to the hope, the belief, the conviction that there is a better life, a better world, beyond the horizon.',
        author: 'Franklin D.Roosevelt',
      },

      {
        quote: 'Life takes on meaning when you become motivated, set goals and charge after them in an unstoppable manner.',
        author: 'Les Brown',
      },
      {
        quote: 'Life is a daring adventure or nothing at all.',
        author: 'Helen Keller',
      },
      {
        quote: 'The ultimate value of life depends upon awareness and the power of contemplation rather than upon mere survival.',
        author: 'Aristotle',
      },
      {
        quote: "Don't take life too seriously.You'll never get out of it alive.",
        author: 'Elbert Hubbard',
      },
      {
        quote: 'Each life is made up of mistakes and learning, waiting and growing, practicing patience and being persistent.',
        author: 'Billy Graham',
      },
      {
        quote: 'Each person must live their life as a model for others.',
        author: 'Rosa Parks',
      },
      {
        quote:
          'My philosophy of life is that if we make up our mind what we are going to make of our lives, then work hard toward that goal, we never lose--somehow we win out.',
        author: 'Ronald Reagan',
      },
      {
        quote: 'Life is not about how fast you run or how high you climb, but how well you bounce.',
        author: 'Vivian Komori',
      },
      {
        quote:
          'Transformation is a process, and as life happens there are tons of ups and downs. Its a journey of discovery--there are moments on mountaintops and moments in deep valleys of despair.',
        author: 'Rick Warren',
      },

      {
        quote: 'Live life to the fullest, and focus on the positive.',
        author: 'Matt Cameron',
      },
    ];
    vm.randomQuote = lodash.sample(vm.Quotes);
  }
})();

(function () {
  'use strict';

  angular.module('musix').service('dashboardService', ['$q', '$timeout', '$state', 'StorageService', 'dashboardResource', Service]);
  Service.$inject = ['$q', '$timeout', '$state', 'StorageService', 'dashboardResource'];
  /* @ngInject */
  function Service($q, $timeout, $state, StorageService, dashboardResource) {
    var recordData = {};
    var sanctionedProposalData = {};
    var dashboardCondition = '';
    var RoleId = '';
    var FullName = '';
    var UserTitle = '';
    var UserPhoto = '';
    var UserDepartmentId = '';

    var isView = false;

    // var role = StorageService.getCookie("Role");
    // var userName = StorageService.getCookie("FullName");
    // var title = StorageService.getCookie("title");

    return {
      dateFormatter: dateFormatter,
      datetimeFormatter: datetimeFormatter,
      GetEwayStatistics: GetEwayStatistics,
      GetEnvoiceStatistics: GetEnvoiceStatistics,
      GetRfqEstimationFiles: GetRfqEstimationFiles,
      UploadRfqEstimationFile: UploadRfqEstimationFile,
      DownloadRfqEstimationFile: DownloadRfqEstimationFile,
      DeleteRfqEstimationFile: DeleteRfqEstimationFile,
      GetUserNotifications: GetUserNotifications,
      GetUserNotificationCount: GetUserNotificationCount,
      ReadUserNotification: ReadUserNotification,
      ReadAllUserNotification: ReadAllUserNotification,
      DownloadRfqSalesforceFile: DownloadRfqSalesforceFile,
      GetRfqSalesforceFiles: GetRfqSalesforceFiles,
      getProfileData: getProfileData,
      getEditData: getEditData,
      setEditData: setEditData,
      getSanctionedProposal: getSanctionedProposal,
      setSanctionedProposal: setSanctionedProposal,
      GoToProposal: GoToProposal,
      setDashboardCondition: setDashboardCondition,
      getDashboardCondition: getDashboardCondition,
      getView: getView,
      setView: setView,
    };

    function dateFormatter(params) {
      return params.value ? new Date(params.value).toLocaleDateString('en-GB') : '';
    }
    function datetimeFormatter(params) {
      return params.value ? new Date(params.value).toLocaleDateString('en-GB') + ' at ' + new Date(params.value).toLocaleTimeString('en-GB') : '';
    }

    // PMC

    function getDashboardCondition() {
      var deferral = $q.defer();
      $timeout(function () {
        deferral.resolve(dashboardCondition);
      }, 0);
      return deferral.promise;
    }

    function setDashboardCondition() {
      dashboardCondition = StorageService.getCookie('Condition');
    }

    function getSanctionedProposal() {
      var deferral = $q.defer();
      $timeout(function () {
        /*
         *  object sent but ag-grid requires array,
         *  either ctrl or service should convert it
         */
        deferral.resolve(sanctionedProposalData);
      }, 0);
      return deferral.promise;
    }

    function setSanctionedProposal(value) {
      sanctionedProposalData = value;
    }
    function GoToProposal(dep, con, isWithObjection) {
      StorageService.setCookie('Department', dep);
      StorageService.setCookie('Condition', con);
      setDashboardCondition();
      if (isWithObjection) $state.go('app.sanctionedproposal.objrecords');
      else $state.go('app.sanctionedproposal.records');
    }

    function getEditData() {
      var deferral = $q.defer();
      $timeout(function () {
        /*
         *  object sent but ag-grid requires array,
         *  either ctrl or service should convert it
         */
        deferral.resolve(recordData);
      }, 0);
      return deferral.promise;
    }

    function getProfileData(data) {
      var deferral = $q.defer();
      $timeout(function () {
        /*
         *  object sent but ag-grid requires array,
         *  either ctrl or service should convert it
         */
        deferral.resolve(data);
      }, 0);
      return deferral.promise;
    }

    function setEditData(value) {
      recordData = value;
    }

    function setView(value) {
      isView = value;
    }

    function getView() {
      return isView;
    }
    function GetEwayStatistics() {
      return dashboardResource.GetEwayStatistics();
    }
    function GetEnvoiceStatistics() {
      return dashboardResource.GetEnvoiceStatistics();
    }

    //-------------------------------------------------------------------------------------------

    function ReadUserNotification(data) {
      return dashboardResource.ReadUserNotification(data);
    }

    function ReadAllUserNotification() {
      return dashboardResource.ReadAllUserNotification();
    }

    function DownloadRfqEstimationFile(data) {
      return dashboardResource.DownloadRfqEstimationFile(data);
    }

    function DeleteRfqEstimationFile(data) {
      return dashboardResource.DeleteRfqEstimationFile(data);
    }

    function GetUserNotifications() {
      return dashboardResource.GetUserNotifications();
    }
    function GetUserNotificationCount() {
      return dashboardResource.GetUserNotificationCount();
    }

    function UploadRfqEstimationFile(data) {
      return dashboardResource.UploadRfqEstimationFile(data);
    }

    function GetRfqEstimationFiles(data) {
      return dashboardResource.GetRfqEstimationFiles(data);
    }
    function GetRfqSalesforceFiles(data) {
      return dashboardResource.GetRfqSalesforceFiles(data);
    }
    function DownloadRfqSalesforceFile(data) {
      return dashboardResource.DownloadRfqSalesforceFile(data);
    }
  }
})();

(function () {
  'use strict';

  angular.module('musix').service('dashboardResource', ['DataService', Resource]);
  Resource.$inject = ['DataService'];
  /* @ngInject */
  function Resource(DataService) {
    return {
      GetEwayStatistics: GetEwayStatistics,
      GetEnvoiceStatistics: GetEnvoiceStatistics,
      GetRfqEstimationFiles: GetRfqEstimationFiles,
      UploadRfqEstimationFile: UploadRfqEstimationFile,
      DownloadRfqEstimationFile: DownloadRfqEstimationFile,
      DeleteRfqEstimationFile: DeleteRfqEstimationFile,
      GetUserNotificationCount: GetUserNotificationCount,
      GetUserNotifications: GetUserNotifications,
      ReadUserNotification: ReadUserNotification,
      ReadAllUserNotification: ReadAllUserNotification,
      DownloadRfqSalesforceFile: DownloadRfqSalesforceFile,
      GetRfqSalesforceFiles: GetRfqSalesforceFiles,
    };
    function GetEwayStatistics() {
      var apiConfig = DataService.getDataApiConfig({ showSpinner: true });
      return DataService.get('/dashboard/GetEwayStatistics', apiConfig);
    }
    function GetEnvoiceStatistics() {
      var apiConfig = DataService.getDataApiConfig({ showSpinner: true });
      return DataService.get('/dashboard/GetEnvoiceStatistics', apiConfig);
    }

    //=============================================================================
    function DownloadRfqEstimationFile(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showSpinner: true, responseType: 'arraybuffer' });
      return DataService.post('/rfq/DownloadRfqEstimationFile', apiConfig);
    }
    function DownloadRfqSalesforceFile(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showSpinner: true, responseType: 'arraybuffer' });
      return DataService.post('/rfq/DownloadRfqSalesforceFile', apiConfig);
    }
    function GetRfqSalesforceFiles(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showSpinner: true });
      return DataService.post('/rfq/GetRfqSalesforceFiles', apiConfig);
    }

    function GetUserNotificationCount() {
      var apiConfig = DataService.getDataApiConfig({ showSpinner: true });
      return DataService.get('/user/GetUserNotificationCount', apiConfig);
    }
    function GetUserNotifications() {
      var apiConfig = DataService.getDataApiConfig({ showSpinner: true });
      return DataService.get('/user/GetUserNotifications', apiConfig);
    }

    function ReadUserNotification(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showSpinner: true });
      return DataService.get('/User/ReadUserNotification/', apiConfig);
    }
    function ReadAllUserNotification() {
      var apiConfig = DataService.getDataApiConfig({ showSpinner: true });
      return DataService.get('/User/ReadAllUserNotification', apiConfig);
    }

    function DeleteRfqEstimationFile(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showSpinner: true });
      return DataService.get('/rfq/DeleteRfqEstimationFile/', apiConfig);
    }

    function GetRfqEstimationFiles(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showSpinner: true });
      return DataService.post('/rfq/GetRfqEstimationFiles', apiConfig);
    }
    function UploadRfqEstimationFile(data) {
      var apiConfig = DataService.getDataApiConfig({ parameter: data, showSpinner: true });
      return DataService.post('/upload/UploadRfqEstimationFile', apiConfig);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('musix')
    .controller('DashboardController', [
      '$scope',
      '$rootScope',
      'lodash',
      'config',
      'notify',
      'Authorization',
      'StorageService',
      'FileSaver',
      'Blob',
      'Upload',
      'fileMd5Service',
      '$timeout',
      '$state',
      '$location',
      '$window',
      'dashboardService',
      MainController,
    ]);

  MainController.$inject = [
    '$scope',
    '$rootScope',
    'lodash',
    'config',
    'notify',
    'Authorization',
    'StorageService',
    'FileSaver',
    'Blob',
    'Upload',
    'fileMd5Service',
    '$timeout',
    '$state',
    '$location',
    '$window',
    'dashboardService',
  ];
  /* @ngInject */
  function MainController(
    $scope,
    $rootScope,
    lodash,
    config,
    notify,
    Authorization,
    StorageService,
    FileSaver,
    Blob,
    Upload,
    fileMd5Service,
    $timeout,
    $state,
    $location,
    $window,
    dashboardService
  ) {
    var vm = this;
    vm.showMenu = false;
    vm.RoleId = '';
    vm.FullName = '';
    vm.UserTitle = '';
    vm.UserPhoto = '';
    vm.UserDepartmentId = '';
    vm.showRecords = false;
    vm.formType = '';
    vm.formTypeCount = 0;
    vm.RfqType = 0;
    // vm.RfqHlp = {}
    vm.DashboardUpdateTime = {};
    vm.SelectedRfq = {};
    vm.IsFileUploadAllowed = false;
    vm.showFileUploadForm = false;
    vm.NotificationSidebar = false;
    vm.EnvoiceStatistics = {};

    vm.UserNotifications = {};
    vm.UserNotificationCount = 0;
    vm.CurrentPageNumber = 1;
    vm.showReportTile = false;
    vm.RfqTypeId = 0;
    vm.IsNightMode = StorageService.getCookie('IsNightMode');

    var savedFilterModel = null;

    function gridHeight() {
      var eGridDiv = document.querySelector('#mainGrid');
      eGridDiv.style.height = $window.innerHeight - 180 + 'px';
      vm.gridOptions.api.doLayout();
    }

    vm.showMenuFn = function () {
      vm.showMenu === !vm.showMenu;
      console.log(vm.showMenu);
      console.log(!vm.showMenu);
    };

    vm.listeningIcon = false;
    vm.toggleVoiceInput = function () {
      console.log($rootScope);
      console.log($rootScope.speech);
      $rootScope.speech.listening = !$rootScope.speech.listening;
      if ($rootScope.speech.listening) {
        $rootScope.listeningIcon = true;
        $rootScope.speech.recognition.start();
      } else {
        $rootScope.listeningIcon = false;
        $rootScope.speech.recognition.stop();
      }
    };

    vm.FirstRecordsPage = function () {
      vm.CurrentPageNumber = 1;
      vm.GetRfqHlp(
        true,
        vm.formType,
        vm.formTypeCount,
        vm.gridOptions.api.getFilterModel(),
        vm.gridOptions.api.getFilterInstance('RfqNo').filterText,
        vm.gridOptions.api.getFilterInstance('PartNumber').filterText,
        vm.gridOptions.api.getFilterInstance('CustomerName').filterText
      );
    };
    vm.PreviousRecordsPage = function () {
      vm.CurrentPageNumber = vm.CurrentPageNumber - 1;
      if (vm.CurrentPageNumber === 0) {
        vm.CurrentPageNumber = 1;
        vm.GetRfqHlp(
          true,
          vm.formType,
          vm.formTypeCount,
          vm.gridOptions.api.getFilterModel(),
          vm.gridOptions.api.getFilterInstance('RfqNo').filterText,
          vm.gridOptions.api.getFilterInstance('PartNumber').filterText,
          vm.gridOptions.api.getFilterInstance('CustomerName').filterText
        );
      } else {
        vm.GetRfqHlp(
          true,
          vm.formType,
          vm.formTypeCount,
          vm.gridOptions.api.getFilterModel(),
          vm.gridOptions.api.getFilterInstance('RfqNo').filterText,
          vm.gridOptions.api.getFilterInstance('PartNumber').filterText,
          vm.gridOptions.api.getFilterInstance('CustomerName').filterText
        );
      }
    };
    vm.NextRecordsPage = function () {
      vm.CurrentPageNumber = vm.CurrentPageNumber + 1;
      vm.GetRfqHlp(
        true,
        vm.formType,
        vm.formTypeCount,
        vm.gridOptions.api.getFilterModel(),
        vm.gridOptions.api.getFilterInstance('RfqNo').filterText,
        vm.gridOptions.api.getFilterInstance('PartNumber').filterText,
        vm.gridOptions.api.getFilterInstance('CustomerName').filterText
      );
    };
    vm.RefreshRecords = function () {
      vm.CurrentPageNumber = 1;
      vm.GetRfqHlp(true, vm.formType, vm.formTypeCount, null, null, null, null);
    };

    vm.GetRfqHlp = function (showRecords, formType, formTypeCount, savedFilterModel, sRfqNo, sPartNumber, sCustomerName) {
      vm.formType = formType;
      vm.formTypeCount = formTypeCount;
      vm.sendlvlData = {
        StatusDepartment: formType,
        RfqNo: sRfqNo,
        PartNumber: sPartNumber,
        CustomerName: sCustomerName,
        PageNumber: vm.CurrentPageNumber,
      };
      gridHeight();
    };

    vm.autoSizeColumns = function () {
      // vm.gridOptions.api.sizeColumnsToFit();
      var allColumnIds = [];
      vm.gridOptions.columnApi.getAllColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      //skipHeader : true
      vm.gridOptions.columnApi.autoSizeColumns(allColumnIds, true);
    };

    /**
     * Notification Sidebar
     */
    vm.GetUserNotifications = function () {
      vm.NotificationSidebar = true;
      dashboardService.GetUserNotifications().then(function (data) {
        vm.UserNotifications = data;
      });
    };
    vm.GetUserNotificationCount = function () {
      dashboardService.GetUserNotificationCount().then(function (data) {
        vm.UserNotificationCount = data;
      });
    };
    vm.ReadUserNotification = function (data) {
      dashboardService.ReadUserNotification(data).then(function (data) {
        notify({ message: data, classes: 'alert-info' });
        vm.GetUserNotifications();
        vm.GetUserNotificationCount();
      });
    };
    vm.ReadAllUserNotification = function () {
      dashboardService.ReadAllUserNotification().then(function (data) {
        notify({ message: data, classes: 'alert-info' });
        vm.GetUserNotifications();
        vm.GetUserNotificationCount();
      });
    };

    /**
     * File Sidebar
     */
    vm.checkFileUploadAllowed = function () {
      vm.showFileUploadForm = false;
      vm.FileRemarks = '';
      vm.RfqFile = {};
      dashboardService.getSelectedRfq().then(function (data) {
        vm.SelectedRfq = data;
        if (vm.SelectedRfq !== null && Object.keys(vm.SelectedRfq).length) {
          vm.IsFileUploadAllowed = true;
          vm.sendData = {
            RfqType: vm.SelectedRfq.RfqType,
            RfqTerritoryId: vm.SelectedRfq.RfqTerritoryId,
            RfqNo: vm.SelectedRfq.RfqNo,
            RfqPartNo: vm.SelectedRfq.RfqPartNo,
            RfqPartRevNo: vm.SelectedRfq.RfqPartRevNo,
          };
          dashboardService.GetRfqSalesforceFiles(vm.sendData).then(function (data) {
            vm.RfqSalesforceFiles = data;
            vm.RfqSalesforceFiles.forEach(function (rw) {
              rw.Department = 'Salesforce';
            });
            // vm.filesGridOptions.api.updateRowData({ add: vm.RfqSalesforceFiles });
            // vm.filesGridOptions.api.sizeColumnsToFit();
          });
          dashboardService.GetRfqEstimationFiles(vm.sendData).then(function (data) {
            vm.RfqEstimationFiles = data;
            // vm.filesGridOptions.api.updateRowData({ add: vm.RfqEstimationFiles });
            // vm.filesGridOptions.api.sizeColumnsToFit();
          });
        } else {
          vm.IsFileUploadAllowed = false;
          notify({ message: 'RFQ Not Selected OR File Attachements Not Allowed.', classes: 'alert-warning' });
        }
      });
    };
    vm.DownloadRfqSalesforceFile = function (Id) {
      vm.sd = {
        RfqDocId: Id,
      };
      dashboardService.DownloadRfqSalesforceFile(vm.sd).then(function (data) {
        //console.log(data);
      });
    };
    vm.DownloadRfqEstimationFile = function (data) {
      vm.sd = {
        RfqEstimationDocumentId: data,
      };
      dashboardService.DownloadRfqEstimationFile(vm.sd).then(function (data) {
        //console.log(data);
      });
    };
    vm.DeleteRfqEstimationFile = function (data) {
      dashboardService.DeleteRfqEstimationFile(data.toString()).then(function (data) {
        if (data === 'File Deleted Successfully.') {
          notify({ message: data, classes: 'alert-info' });
          vm.checkFileUploadAllowed();
        }
      });
    };
    vm.UploadRfqEstimationFile = function () {
      if (vm.RfqFile.size > 0 && vm.RfqFile.type.length > 0) {
        fileMd5Service
          .md5(vm.RfqFile)
          .progress(function (stats) {
            // //console.log('Hashed ' + stats.loaded + ' B out of ' + stats.total + ' B');
          })
          .error(function (error) {
            //console.log('Error calculating md5: %o', error);
          })
          .success(function (md5sum) {
            ////console.log('MD5 for ' + vm.RfqFile.name + ' is ' + md5sum.toUpperCase());
            var upload = Upload.upload({
              url: config.apiURL + '/upload/UploadRfqEstimationFile', //'http://localhost:63745/api/upload/UploadRfqEstimationFile',
              // url: 'http://bflestimationdv.bharatforge.com/bflapi/api/upload/UploadRfqEstimationFile',
              // url: 'http://bflestimation.kalyanicorp.com/bflapi/api/upload/UploadRfqEstimationFile',
              data: {
                file: vm.RfqFile,
                RfqType: vm.SelectedRfq.RfqType,
                RfqTerritoryId: vm.SelectedRfq.RfqTerritoryId,
                RfqNo: vm.SelectedRfq.RfqNo,
                RfqPartNo: vm.SelectedRfq.RfqPartNo,
                RfqPartRevNo: vm.SelectedRfq.RfqPartRevNo,
                Remarks: vm.FileRemarks,
                FileName: vm.RfqFile.name,
                FileType: vm.RfqFile.type,
                FileHash: md5sum.toUpperCase(),
              },
            });
            upload.then(function (data) {
              if (data) {
                notify({ message: 'File Uploaded Successfully.', classes: 'alert-info' });
                vm.FileRemarks = '';
                vm.RfqFile = {};
                vm.checkFileUploadAllowed();
              }
            });
          });
      } else {
        notify({ message: 'File Not Recognised OR File Type Allowed.', classes: 'alert-warning' });
      }
    };
    /**
     *  Apply User Details On Login
     */
    vm.InitializeUserLabel = function () {
      if (vm.RoleId === '' && vm.FullName === '' && vm.UserTitle === '' && vm.UserPhoto === '' && vm.UserDepartmentId === '') {
        console.log('InitializeUserLabel');
        vm.RoleId = StorageService.getCookie('RoleId');
        vm.UserDepartmentId = StorageService.getCookie('UserDepartmentId');
        vm.FullName = StorageService.getCookie('FullName');
        vm.UserTitle = StorageService.getCookie('UserTitle');
        vm.UserPhoto = 'data:image/png;base64,' + StorageService.getCookie('UserPhoto');
      }
    };
    vm.init = function () {
      console.log('init');
      vm.DashboardUpdateTime = new Date();
      vm.InitializeUserLabel();
      // dashboardService.getSelectedRfq().then(function (data) {
      //   vm.SelectedRfq = data;
      //   if (vm.SelectedRfq !== null && Object.keys(vm.SelectedRfq).length) dashboardService.setSelectedRfq({});
      // });
      dashboardService.GetEnvoiceStatistics().then(function (data) {
        vm.EnvoiceStatistics = data;
      });
      dashboardService.GetEwayStatistics().then(function (data) {
        vm.EwayStatistics = data;
      });
      // vm.GetUserNotificationCount();
    };

    if (Authorization.TokenPresent() === true && Authorization.isAuthorized === true) {
      vm.init();
    }

    $scope.isActive = function (route) {
      var appSection = $location.path().split('/');
      return route === appSection[1];
    };

    /**
     * @name goToRoute
     * @kind function
     * @description for viewing selected row
     */
    vm.goToRoute = function (onRowSelected) {
      /// vm.selectedRowData = vm.gridOptions.api.getSelectedRows();
      // vm.formdata = vm.selectedRowData[0];
      vm.formdata = onRowSelected;
      if (Object.keys(vm.formdata).length) {
        dashboardService.setSelectedRfq(vm.formdata);
        $state.go(vm.formdata.StatusState);
      } else {
        notify({ message: 'Select A Record.', classes: 'alert-warning' });
      }
    };

    vm.logout = function () {
      StorageService.removeCookie('debug');
      StorageService.removeCookie('ussAPIToken');
      StorageService.removeCookie('UserName');
      StorageService.removeCookie('FullName');
      StorageService.removeCookie('RoleId');
      StorageService.removeCookie('UserTitle');
      StorageService.removeCookie('UserDepartment');
      StorageService.removeCookie('UserDepartmentId');
      StorageService.removeCookie('UserPhoto');
      StorageService.removeCookie('LoginTime');
      if (Authorization.TokenPresent() === false && Authorization.isAuthorized === false) {
        vm.RoleId = '';
        vm.FullName = '';
        vm.UserTitle = '';
        vm.UserPhoto = '';
        vm.UserDepartmentId = '';
        $state.go('login');
      }
    };
  }
})();

(function () {
  'use strict';

  /* @ngdoc object
   * @name common.service
   * @requires $stateProvider
   *
   * @description: factory
   *
   */
  angular.module('Common.Config', []);

  var app = angular.module('Common.Config');

  var remoteServiceHost = '';
  var cdnURL = '';
  var buildDirURL = '';
  var remoteServiceName = '';

  var WinLoc = window.location;
  var authURL = 'https://' + WinLoc.host + '/apiapp/token';
  var apiURL = 'https://' + WinLoc.host + '/apiapp/api';

  // var authURL = 'https://gst.impinc.in/apiapp/token';
  // var apiURL = 'https://gst.impinc.in/apiapp/api';

  // var authURL = 'http://localhost:63745/token';
  // var apiURL = 'http://localhost:63745/api';

  // var authURL = 'https://localhost:44354/token';
  // var apiURL = 'https://localhost:44354/api';

  // TODO: var windowHeight = angular.element(window).height() - 154;

  var config = {
    authURL: authURL,
    apiURL: apiURL,
    remoteServiceHost: remoteServiceHost,
    cdnURL: cdnURL,
    setRemoteServiceHost: setRemoteServiceHost,
    setAPIURL: setAPIURL,
    setCDNUrl: setCDNUrl,
    setBuildDirUrl: setBuildDirUrl,
  };

  function setRemoteServiceHost(remoteHostName) {
    this.remoteServiceHost = remoteHostName;
    app.value('config', this);
  }

  function setAPIURL(apiURL) {
    this.authURL = apiURL + 'token';
    this.apiURL = apiURL + 'api';
    this.apiURL = apiURL;
    app.value('config', this);
  }

  function setCDNUrl(CDNUrl) {
    this.cdnURL = CDNUrl;
    app.value('config', this);
  }

  function setBuildDirUrl(buildUrl) {
    this.buildDirURL = buildUrl;
    app.value('config', this);
  }

  app.value('config', config);

  app.config([
    '$httpProvider',
    function ($httpProvider) {
      $httpProvider.defaults.useXDomain = true;
    },
  ]);
})();

(function () {
  'use strict';

  /**
   * @name common
   *
   * @description Its Commomn Module which is for Integrating Common Services, Common Directive throughout the App
   *
   */
  angular
    .module('Common', [
      'Common.DataService',
      'Common.StorageService',
      'Common.Config',
      // TODO: 'Common.EnvConfigConstant'
    ])
    .config(config);

  function config() {}
})();

(function () {
  'use strict';

  angular.module('musix').service('adminService', ['$timeout', '$q', 'adminResource', Service]);

  Service.$inject = ['$timeout', '$q', 'adminResource'];
  /* @ngInject */
  function Service($timeout, $q, adminResource) {
    var recordData = {};
    var isView = false;
    var isEdit = false;

    return {
      getEditData: getEditData,
      setEditData: setEditData,
      GetRoleMaster: GetRoleMaster,
      UpsertPlantMaster: UpsertPlantMaster,
    };

    function GetRoleMaster() {
      return adminResource.GetRoleMaster();
    }

    function UpsertPlantMaster(data) {
      return adminResource.UpsertPlantMaster(data);
    }

    function getEditData() {
      var deferral = $q.defer();
      $timeout(function () {
        /*
         *  object sent but ag-grid requires array,
         *  either ctrl or service should convert it
         */
        deferral.resolve(recordData);
      }, 0);
      return deferral.promise;
    }

    function setEditData(value) {
      recordData = value;
    }
  }
})();

(function () {
  'use strict';

  angular.module('musix').service('adminResource', ['DataService', Resource]);
  Resource.$inject = ['DataService'];
  /* @ngInject */
  function Resource(DataService) {
    return {
      GetRoleMaster: GetRoleMaster,
      UpsertPlantMaster: UpsertPlantMaster,
    };

    function GetRoleMaster() {
      var apiConfig = DataService.getDataApiConfig({
        showSpinner: true,
      });
      return DataService.get('/User/GetRolesMaster', apiConfig);
    }

    function UpsertPlantMaster(data) {
      var apiConfig = DataService.getDataApiConfig({
        parameter: data,
        showSpinner: true,
        showToaster: true,
      });
      return DataService.post('/User/UpsertRoleMaster', apiConfig);
    }
  }
})();

angular.element(document).ready(function ($timeout) {
  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element('body > #wrapper').height() - 61;
    angular.element('.sidebar-panel').css('min-height', heightWithoutNavbar + 'px');

    var navbarHeight = angular.element('nav.navbar-default').height();
    var wrapperHeight = angular.element('#page-wrapper').height();

    if (navbarHeight > wrapperHeight) {
      angular.element('#page-wrapper').css('min-height', navbarHeight + 'px');
    }

    if (navbarHeight < wrapperHeight) {
      angular.element('#page-wrapper').css('min-height', angular.element(window).height() + 'px');
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeight) {
        angular.element('#page-wrapper').css('min-height', navbarHeight + 'px');
      } else {
        angular.element('#page-wrapper').css('min-height', angular.element(window).height() - 60 + 'px');
      }
    }
  }

  angular.element(window).bind('load resize scroll', function () {
    // var result = document.getElementsByClassName("body");
    if (!angular.element('body').hasClass('body-small')) {
      // if (!result.classList.contains('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function () {
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav')) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function () {
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind('load resize', function () {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small');
    } else {
      angular.element('body').removeClass('body-small');
    }
  });
});

(function () {
  'use strict';

  angular.module('musix').run(runBlock);

  /** @ngInject */
  function runBlock(
    cfpLoadingBar,
    $timeout,
    $log,
    $rootScope,
    $window,
    bootstrap3ElementModifier,
    validator,
    $uibModalStack,
    $transitions,
    $trace,
    notify
  ) {
    notify.config({ position: 'center' });
    validator.setValidElementStyling(false);
    bootstrap3ElementModifier.enableValidationStateIcons(false);
    // validator.defaultFormValidationOptions.disabled= true;

    // $trace.enable()
    /*
    $transitions.onStart({}, function (trans) {
      var $state = trans.router.stateService;
      var Authorization = trans.injector().get('Authorization');
      if (Authorization.isAuthorized) {
        // //console.log('if')
        $timeout(function () {
          $state.go(trans.$to());
        });
      } else if (Authorization.TokenPresent()) {
        ////console.log('else if')
        if (Authorization.isAuthorized) {
          ////console.log('else if if')
          $timeout(function () {
            $state.go(trans.$to());
          });
        }
      } else {
        $timeout(function () {
          $state.go('login');
        });
      }
    });*/
    $transitions.onSuccess({}, function () {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    });

    $rootScope.isShowSpinner = false;
    $rootScope.showVoiceInputIcon = false;
    $rootScope.listeningIcon = false;

    $rootScope.startSpinner = function () {
      $rootScope.isShowSpinner = true;
      cfpLoadingBar.start();
    };

    $rootScope.stopSpinner = function () {
      $rootScope.isShowSpinner = false;
      cfpLoadingBar.complete();
    };
    if ('SpeechRecognition' in $window || 'webkitSpeechRecognition' in $window) {
      $rootScope.showVoiceInputIcon = true;
      $window.SpeechRecognition = $window.SpeechRecognition || $window.webkitSpeechRecognition;
      $rootScope.speech = {
        enabled: true,
        listening: false,
        recognition: new $window.SpeechRecognition(),
        text: '',
      };
      $rootScope.speech.recognition.continuous = true;
      $rootScope.speech.recognition.interimResults = true;
      $rootScope.speech.recognition.lang = 'mr-IN';
      $rootScope.speech.recognition.addEventListener('result', function (event) {
        var audio = event.results[event.results.length - 1];
        $rootScope.speech.text = audio[0].transcript;
        var tag = document.activeElement.nodeName;
        if (tag === 'INPUT' || tag === 'TEXTAREA') {
          if (audio.isFinal) {
            document.activeElement.value += $rootScope.speech.text;
          }
        }
        result.innerText = $rootScope.speech.text;
      });
      $rootScope.speech.recognition.addEventListener('audiostart', function () {
        //notify({ message: 'Audio capturing started', classes: 'alert-info' });
      });
      $rootScope.speech.recognition.addEventListener('audioend', function () {
        //notify({ message: 'Audio capturing ended', classes: 'alert-info' });
        $timeout(function () {
          $rootScope.listeningIcon = false;
        });
      });
      $rootScope.speech.recognition.addEventListener('speechstart', function () {
        notify({ message: 'Speech has been detected', classes: 'alert-info' });
      });
      $rootScope.speech.recognition.addEventListener('speechend', function () {
        notify({ message: 'Speech has stopped being detected', classes: 'alert-info' });
      });
      $rootScope.speech.recognition.addEventListener('nomatch', function () {
        notify({ message: 'Speech not recognized', classes: 'alert-info' });
      });
    } else {
      $rootScope.showVoiceInputIcon = false;
    }

    $log.debug('runBlock end');
  }
})();

(function () {
  'use strict';
  angular.module('musix').config(routerConfig);
  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    // $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/login');
    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/login/login.html',
        controller: 'LoginCtrl as vm',
      })
      .state('app', {
        abstract: true,
        url: '/app',
        templateUrl: 'app/components/common/content.html',
      })
      .state('app.401', {
        url: '/401',
        templateUrl: 'app/components/common/401.html',
      })

      .state('app.dashboard', {
        url: '/dashboard',
        templateUrl: 'app/dashboard/dashboard.html',
        controller: 'DashboardController as vm',
        // data: { pageTitle: 'Example view' }
      })

      // E-Invoice
      //ewaybill
      .state('app.einvoice', {
        url: '/einvoice',
      })

      .state('app.einvoice.master', {
        url: '/master',
        // template: '<div ui-view="master"></div>'
        // templateUrl: 'app/master/master.html'
        //controller: 'DetailCtrl as vm'
      })
      .state('app.einvoice.master.cancellationreason', {
        url: '/cancellationreason',
        templateUrl: 'app/einvoice/master/master.html',
        controller: 'envoicemasterCtrl as vm',
      })
      .state('app.einvoice.master.country', {
        url: '/country',
        templateUrl: 'app/einvoice/master/master.html',
        controller: 'envoicemasterCtrl as vm',
      })
      .state('app.einvoice.master.currency', {
        url: '/currency',
        templateUrl: 'app/einvoice/master/master.html',
        controller: 'envoicemasterCtrl as vm',
      })
      .state('app.einvoice.master.documenttype', {
        url: '/documenttype',
        templateUrl: 'app/einvoice/master/master.html',
        controller: 'envoicemasterCtrl as vm',
      })
      .state('app.einvoice.master.errorlist', {
        url: '/errorlist',
        templateUrl: 'app/einvoice/master/master.html',
        controller: 'envoicemasterCtrl as vm',
      })
      .state('app.einvoice.master.ewaybilltransportmode', {
        url: '/ewaybilltransportmode',
        templateUrl: 'app/einvoice/master/master.html',
        controller: 'envoicemasterCtrl as vm',
      })
      .state('app.einvoice.master.ewaybillvehicletype', {
        url: '/ewaybillvehicletype',
        templateUrl: 'app/einvoice/master/master.html',
        controller: 'envoicemasterCtrl as vm',
      })
      .state('app.einvoice.master.gsttaxrate', {
        url: '/gsttaxrate',
        templateUrl: 'app/einvoice/master/master.html',
        controller: 'envoicemasterCtrl as vm',
      })
      .state('app.einvoice.master.port', {
        url: '/port',
        templateUrl: 'app/einvoice/master/master.html',
        controller: 'envoicemasterCtrl as vm',
      })
      .state('app.einvoice.master.state', {
        url: '/state',
        templateUrl: 'app/einvoice/master/master.html',
        controller: 'envoicemasterCtrl as vm',
      })
      .state('app.einvoice.master.typeoftransaction', {
        url: '/typeoftransaction',
        templateUrl: 'app/einvoice/master/master.html',
        controller: 'envoicemasterCtrl as vm',
      })
      .state('app.einvoice.master.unit', {
        url: '/unit',
        templateUrl: 'app/einvoice/master/master.html',
        controller: 'envoicemasterCtrl as vm',
      })
      //einvoice
      .state('app.einvoice.invoice', {
        url: '/invoice',
      })
      .state('app.einvoice.invoice.import', {
        url: '/import',
        templateUrl: 'app/einvoice/invoice/invoice.html',
        controller: 'invoiceCtrl as vm',
      })
      .state('app.einvoice.invoice.forirn', {
        url: '/forirn',
        templateUrl: 'app/einvoice/invoice/invoice.html',
        controller: 'invoiceCtrl as vm',
      })
      .state('app.einvoice.invoice.withirn', {
        url: '/withirn',
        templateUrl: 'app/einvoice/invoice/invoice.html',
        controller: 'invoiceCtrl as vm',
      })
      .state('app.einvoice.invoice.cancelled', {
        url: '/cancelled',
        templateUrl: 'app/einvoice/invoice/invoice.html',
        controller: 'invoiceCtrl as vm',
      })
      .state('app.einvoice.invoice.view', {
        url: '/view',
        templateUrl: 'app/einvoice/invoice/invoiceview.html',
        controller: 'invoiceCtrl as vm',
      })
      //ewaybill
      .state('app.eway', {
        url: '/eway',
      })
      .state('app.eway.invoice', {
        url: '/invoice',
      })
      .state('app.eway.invoice.import', {
        url: '/import',
        templateUrl: 'app/eway/invoice/invoicerecord.html',
        controller: 'ewayInvoiceCtrl as vm',
      })
      .state('app.eway.invoice.forewb', {
        url: '/forewb',
        templateUrl: 'app/eway/invoice/invoicerecord.html',
        controller: 'ewayInvoiceCtrl as vm',
      })
      .state('app.eway.invoice.withewb', {
        url: '/withewb',
        templateUrl: 'app/eway/invoice/invoicerecord.html',
        controller: 'ewayInvoiceCtrl as vm',
      })
      .state('app.eway.invoice.forclose', {
        url: '/forclose',
        templateUrl: 'app/eway/invoice/invoicerecord.html',
        controller: 'ewayInvoiceCtrl as vm',
      })
      .state('app.eway.invoice.cancelled', {
        url: '/cancelled',
        templateUrl: 'app/eway/invoice/invoicerecord.html',
        controller: 'ewayInvoiceCtrl as vm',
      })
      .state('app.eway.invoice.view', {
        url: '/view',
        templateUrl: 'app/eway/invoice/invoiceview.html',
        controller: 'ewayInvoiceCtrl as vm',
      })

      .state('app.eway.master', {
        url: '/master',
      })
      .state('app.eway.master.BillStatus', {
        url: '/BillStatus',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.CancelReason', {
        url: '/CancelReason',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.ConsignStatus', {
        url: '/ConsignStatus',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.DocType', {
        url: '/DocType',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.ErrorCode', {
        url: '/ErrorCode',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.GenMode', {
        url: '/GenMode',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.StateCode', {
        url: '/StateCode',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.SubSupplyType', {
        url: '/SubSupplyType',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.SupplyType', {
        url: '/SupplyType',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.TransMode', {
        url: '/TransMode',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.TransType', {
        url: '/TransType',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.Unit', {
        url: '/Unit',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.ValExtReason', {
        url: '/ValExtReason',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.VehicleType', {
        url: '/VehicleType',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.ValidVehicleNumber', {
        url: '/ValidVehicleNumber',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.TaxRates', {
        url: '/TaxRates',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })
      .state('app.eway.master.SupplyDocType', {
        url: '/SupplyDocType',
        templateUrl: 'app/eway/master/master.html',
        controller: 'ewayMasterCtrl as vm',
      })

      .state('app.sanctionedproposal', {
        abstract: true,
        url: '/sanctionedproposal',
        template: '<ui-view/>',
      })
      .state('app.sanctionedproposal.records', {
        url: '/records',
        templateUrl: 'app/sanctionedproposal/sanctionedproposal.records.html',
        controller: 'sanctionedproposalRCtrl as vm',
        resolve: {
          sanctionedproposalRecords: function (sanctionedproposalService) {
            return sanctionedproposalService.GetSanctionedProposalWithConditions();
          },
        },
        // data: { pageTitle: 'Example view' }
      })
      .state('app.sanctionedproposal.objrecords', {
        url: '/objrecords',
        templateUrl: 'app/sanctionedproposal/sanctionedproposal.records.html',
        controller: 'sanctionedproposalRCtrl as vm',
        resolve: {
          sanctionedproposalRecords: function (sanctionedproposalService) {
            return sanctionedproposalService.GetSanctionedProposalWithObjections();
          },
        },
        // data: { pageTitle: 'Example view' }
      })
      .state('app.sanctionedproposal.view', {
        url: '/view',
        templateUrl: 'app/sanctionedproposal/sanctionedproposal.html',
        controller: 'sanctionedproposalCtrl as vm',
        // data: { pageTitle: 'Example view' }
      })

      .state('app.admin', {
        url: '/admin',
      })
      .state('app.admin.user', {
        url: '/user',
        templateUrl: 'app/admin/user/user.html',
        controller: 'userCtrl as vm',
      })

      .state('app.admin.gstinmaster', {
        url: '/gstinmaster',
        templateUrl: 'app/admin/gstinmaster/gstinmaster.html',
        controller: 'gstinmasterCtrl as vm',
      })
      .state('app.admin.role', {
        url: '/role',
        templateUrl: 'app/admin/role/role.html',
        controller: 'roleCtrl as vm',
      })

      .state('app.admin.logs', {
        url: '/logs',
        templateUrl: 'app/admin/logs/logs.html',
        controller: 'logsCtrl as vm',
      })
      .state('app.user', {
        url: '/user',
      })
      .state('app.user.profile', {
        url: '/profile',
        templateUrl: 'app/user/profile/userprofile.html',
        controller: 'userProfileCtrl as vm',
      });
  }
})();

(function () {
  'use strict';

  angular.module('musix').config(config);

  /* @ngInject */
  function config(fileMd5ServiceProvider, $logProvider, $compileProvider, cfpLoadingBarProvider) {
    // Enable log
    // $logProvider.debugEnabled(false);
    // $compileProvider.debugInfoEnabled(false);
    // fileMd5ServiceProvider.configure({
    //   chunkSize: noBytes
    // })
    cfpLoadingBarProvider.includeBar = true;
    cfpLoadingBarProvider.includeSpinner = true;
    cfpLoadingBarProvider.parentSelector = '#loading-bar-container';
    //cfpLoadingBarProvider.latencyThreshold = 500;
  }
})();

'use strict';

// Directive used to set metisMenu and minimalize button
angular
  .module('musix')
  .directive('sideNavigation', function ($timeout) {
    return {
      restrict: 'A',
      link: function (scope, element) {
        // Call metsi to build when user signup
        scope.$watch('authentication.user', function () {
          $timeout(function () {
            element.metisMenu();
          });
        });

        // Colapse menu in mobile mode after click on element
        var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
        menuElement.click(function () {
          if (angular.element(window).width() < 769) {
            angular.element('body').toggleClass('mini-navbar');
          }
        });

        // Enable initial fixed sidebar
        if (angular.element('body').hasClass('fixed-sidebar')) {
          var sidebar = element.parent();
          sidebar.slimScroll({
            height: '100%',
            railOpacity: 0.9,
          });
        }
      },
    };
  })
  .directive('minimalizaSidebar', function ($timeout) {
    return {
      restrict: 'A',
      template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="far fa-bars"></i></a>',
      controller: function ($scope) {
        $scope.minimalize = function () {
          angular.element('body').toggleClass('mini-navbar');
          if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
            // Hide menu in order to smoothly turn on when maximize menu
            angular.element('#side-menu').hide();
            // For smoothly turn on menu
            $timeout(function () {
              angular.element('#side-menu').fadeIn(10);
            }, 10);
          } else {
            // Remove all inline style from jquery fadeIn function to reset menu state
            angular.element('#side-menu').removeAttr('style');
          }
        };
      },
    };
  })
  // .directive('iCheck', function ($timeout) {
  //     return {
  //         restrict: 'A',
  //         require: 'ngModel',
  //         link: function ($scope, element, $attrs, ngModel) {
  //             return $timeout(function () {
  //                 var value;
  //                 value = $attrs['value'];

  //                 $scope.$watch($attrs['ngModel'], function (newValue) {
  //                     $(element).iCheck('update');
  //                 })

  //                 return $(element).iCheck({
  //                     checkboxClass: 'icheckbox_square-green',
  //                     radioClass: 'iradio_square-green'

  //                 }).on('ifChanged', function (event) {
  //                     if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
  //                         $scope.$apply(function () {
  //                             return ngModel.$setViewValue(event.target.checked);
  //                         });
  //                     }
  //                     if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
  //                         return $scope.$apply(function () {
  //                             return ngModel.$setViewValue(value);
  //                         });
  //                     }
  //                 });
  //             });
  //         }
  //     };
  // })
  /**
   * iboxTools - Directive for iBox tools elements in right corner of ibox
   */
  .directive('iboxTools', function ($timeout) {
    return {
      restrict: 'A',
      scope: true,
      // templateUrl: '../app/components/common/ibox_tools.html',
      controller: function ($scope, $element) {
        // Function for collapse ibox
        $scope.showhide = function () {
          var ibox = $element.closest('div.ibox');
          var icon = $element.find('i:last');
          var content = ibox.children('.ibox-content');
          content.slideToggle(200);
          // Toggle icon from up to down
          icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
          ibox.toggleClass('').toggleClass('border-bottom');
          $timeout(function () {
            ibox.resize();
            ibox.find('[id^=map-]').resize();
          }, 50);
        };
        // Function for close ibox
        $scope.closebox = function () {
          var ibox = $element.closest('div.ibox');
          ibox.remove();
        };
        // Function for full screen
        $scope.fullscreen = function () {
          var ibox = $element.closest('div.ibox');
          var button = $element.find('i.fa-expand');
          $('body').toggleClass('fullscreen-ibox-mode');
          button.toggleClass('fa-expand').toggleClass('fa-compress');
          ibox.toggleClass('fullscreen');
          setTimeout(function () {
            $(window).trigger('resize');
          }, 100);
        };

        // Function for RFQ full screen
        $scope.fullscreenRfq = function () {
          var ibox = $element.closest('div.ibox');
          var button = $element.find('i.fa-expand');
          ibox.toggleClass('collapsed');
          $('body').toggleClass('fullscreen-ibox-mode');
          button.toggleClass('fa-expand').toggleClass('fa-compress');
          ibox.toggleClass('fullscreen');
          setTimeout(function () {
            $(window).trigger('resize');
          }, 100);
        };
      },
    };
  })
  /**
   * fullScroll - Directive for slimScroll with 100%
   */
  .directive('fullScroll', function ($timeout) {
    return {
      restrict: 'A',
      link: function (scope, element) {
        $timeout(function () {
          element.slimscroll({
            height: '70vh',
            railOpacity: 0.9,
          });
        });
      },
    };
  })
  /**
   * slimScroll - Directive for slimScroll with custom height
   */
  .directive('slimScroll', function ($timeout) {
    return {
      restrict: 'A',
      scope: {
        boxHeight: '@',
      },
      link: function (scope, element) {
        $timeout(function () {
          element.slimscroll({
            height: scope.boxHeight,
            railOpacity: 0.9,
          });
        });
      },
    };
  })
  /**
   * icheck - Directive for custom checkbox icheck
   */
  .directive('icheck', function ($timeout) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function ($scope, element, $attrs, ngModel) {
        return $timeout(function () {
          var value;
          value = $attrs.value;

          $scope.$watch($attrs.ngModel, function (newValue) {
            $(element).iCheck('update');
          });

          return $(element)
            .iCheck({
              checkboxClass: 'icheckbox_square-green',
              radioClass: 'iradio_square-green',
            })
            .on('ifChanged', function (event) {
              if ($(element).attr('type') === 'checkbox' && $attrs.ngModel) {
                $scope.$apply(function () {
                  return ngModel.$setViewValue(event.target.checked);
                });
              }
              if ($(element).attr('type') === 'radio' && $attrs.ngModel) {
                return $scope.$apply(function () {
                  return ngModel.$setViewValue(value);
                });
              }
            });
        });
      },
    };
  });

angular.module("musix").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin/admin.html","<div ui-view=\"main\"></div>");
$templateCache.put("app/dashboard/dashboard.html","<style>\n  /* Workflow Container */\n  .workflow-section {\n      margin-bottom: 32px;\n  }\n\n  /* Section Header */\n  .workflow-header {\n     display: flex;\n     align-items: center;\n     margin-bottom: 24px;\n     padding-bottom: 12px;\n     border-bottom: 1px solid #e7eaec;\n     gap: 12px;\n  }\n  \n  .workflow-header h2 {\n     margin: 0;\n     font-size: 24px;\n     font-weight: 600;\n  }\n  \n  .workflow-header i {\n     font-size: 24px;\n  }\n\n  /* Process Row */\n  .workflow-row {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 18px;\n  }\n\n  .workflow-card {\n      flex: 1;\n      min-width: 220px;\n      position: relative;\n  }\n\n  @media (min-width: 1200px) {\n      .workflow-card:not(:last-child)::after {\n          content: \"\";\n          position: absolute;\n          top: 50%;\n          right: -14px;\n          width: 10px;\n          height: 2px;\n          background: #d8dce2;\n          z-index: 10;\n      }\n  }\n\n  /* Card / Widget styling */\n  .workflow-card .ibox {\n      margin-bottom: 0;\n      height: 100%;\n      border-radius: 6px;\n      transition: transform 0.2s ease, box-shadow 0.2s ease;\n      background: #ffffff;\n      border: 1px solid #e2e8f0;\n      box-shadow: 0 1px 2px rgba(0,0,0,0.03);\n  }\n  \n  .workflow-card .ibox:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 4px 12px rgba(0,0,0,0.05);\n      border-color: #cbd5e1;\n  }\n\n  .workflow-card .ibox-content {\n      min-height: 180px;\n      padding: 24px;\n      border-style: none;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      border-radius: 6px;\n      background: transparent;\n  }\n\n  .kpi-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: flex-start;\n  }\n\n  .kpi-title {\n      font-size: 15px;\n      font-weight: 600;\n      color: #475569;\n      margin: 0;\n      line-height: 1.4;\n      padding-right: 10px;\n  }\n\n  .kpi-icon {\n      font-size: 18px;\n      color: #94a3b8;\n  }\n\n  .metric-number {\n      font-size: 44px;\n      font-weight: 600;\n      color: #1f2937 !important;\n      margin: 16px 0;\n      line-height: 1;\n      letter-spacing: -0.02em;\n  }\n\n  .kpi-footer {\n      display: flex;\n      align-items: center;\n      margin-top: auto;\n  }\n\n  .kpi-card a {\n      text-decoration: none;\n      color: inherit;\n      display: flex;\n      flex-direction: column;\n      height: 100%;\n  }\n\n  .kpi-card a:hover {\n      text-decoration: none;\n      color: inherit;\n  }\n</style><div class=\"wrapper wrapper-content\"><div class=\"workflow-section workflow-invoice\" ng-show=\"vm.RoleId === \'1\' || vm.RoleId === \'2\' || vm.RoleId === \'3\'\"><div class=\"workflow-header\"><i class=\"far fa-file-invoice\" style=\"color: #006cb2;\"></i><h2 style=\"color: #006cb2;\">E - Invoice</h2></div><div class=\"workflow-row\"><div class=\"workflow-card\"><div class=\"ibox kpi-card\"><div class=\"ibox-content\"><a ui-sref=\"app.einvoice.invoice.import\"><div class=\"kpi-header\"><h4 class=\"kpi-title\">Invoices From ERP</h4><i class=\"far fa-cloud-download kpi-icon\"></i></div><h1 class=\"metric-number\">{{vm.EnvoiceStatistics.InvoiceToImportTotal}}</h1><div class=\"kpi-footer\"><span class=\"label label-info\">Pending Import</span></div></a></div></div></div><div class=\"workflow-card\"><div class=\"ibox kpi-card\"><div class=\"ibox-content\"><a ui-sref=\"app.einvoice.invoice.forirn\"><div class=\"kpi-header\"><h4 class=\"kpi-title\">Get IRN For Invoice</h4><i class=\"far fa-key kpi-icon\"></i></div><h1 class=\"metric-number\">{{vm.EnvoiceStatistics.InvoiceForIrnTotal}}</h1><div class=\"kpi-footer\"><span class=\"label label-warning\">Pending IRN</span></div></a></div></div></div><div class=\"workflow-card\"><div class=\"ibox kpi-card\"><div class=\"ibox-content\"><a ui-sref=\"app.einvoice.invoice.withirn\"><div class=\"kpi-header\"><h4 class=\"kpi-title\">Invoice Done</h4><i class=\"far fa-check-circle kpi-icon\"></i></div><h1 class=\"metric-number\">{{vm.EnvoiceStatistics.InvoiceWithIrnMonthly}}</h1><div class=\"kpi-footer\"><span class=\"label label-success\">Completed</span></div></a></div></div></div><div class=\"workflow-card\"><div class=\"ibox kpi-card\"><div class=\"ibox-content\"><a ui-sref=\"app.einvoice.invoice.cancelled\"><div class=\"kpi-header\"><h4 class=\"kpi-title\">Invoice Cancelled</h4><i class=\"far fa-times-circle kpi-icon\"></i></div><h1 class=\"metric-number\">{{vm.EnvoiceStatistics.InvoiceCancelledMonthly}}</h1><div class=\"kpi-footer\"><span class=\"label label-danger\">Cancelled</span></div></a></div></div></div></div></div><div class=\"workflow-section workflow-ewb\" ng-show=\"vm.RoleId === \'1\' || vm.RoleId === \'2\' || vm.RoleId === \'4\'\"><div class=\"workflow-header\"><i class=\"far fa-truck\" style=\"color: #0097a7;\"></i><h2 style=\"color: #0097a7;\">E - Waybill</h2></div><div class=\"workflow-row\"><div class=\"workflow-card\"><div class=\"ibox kpi-card\"><div class=\"ibox-content\"><a ui-sref=\"app.eway.invoice.import\"><div class=\"kpi-header\"><h4 class=\"kpi-title\">Import from ERP</h4><i class=\"far fa-cloud-download kpi-icon\"></i></div><h1 class=\"metric-number\">{{vm.EwayStatistics.InvoiceToImportTotal}}</h1><div class=\"kpi-footer\"><span class=\"label label-info\">Pending Import</span></div></a></div></div></div><div class=\"workflow-card\"><div class=\"ibox kpi-card\"><div class=\"ibox-content\"><a ui-sref=\"app.eway.invoice.forewb\"><div class=\"kpi-header\"><h4 class=\"kpi-title\">Generate EWB</h4><i class=\"far fa-cogs kpi-icon\"></i></div><h1 class=\"metric-number\">{{vm.EwayStatistics.InvoiceForEwbTotal}}</h1><div class=\"kpi-footer\"><span class=\"label label-warning\">Pending EWB</span></div></a></div></div></div><div class=\"workflow-card\"><div class=\"ibox kpi-card\"><div class=\"ibox-content\"><a ui-sref=\"app.eway.invoice.withewb\"><div class=\"kpi-header\"><h4 class=\"kpi-title\">EWB Done</h4><i class=\"far fa-check-circle kpi-icon\"></i></div><h1 class=\"metric-number\">{{vm.EwayStatistics.InvoiceWithEwbTotal}}</h1><div class=\"kpi-footer\"><span class=\"label label-success\">Completed</span></div></a></div></div></div><div class=\"workflow-card\"><div class=\"ibox kpi-card\"><div class=\"ibox-content\"><a ui-sref=\"app.eway.invoice.forclose\"><div class=\"kpi-header\"><h4 class=\"kpi-title\">EWB Closure</h4><i class=\"far fa-stop-circle kpi-icon\"></i></div><h1 class=\"metric-number\">{{vm.EwayStatistics.InvoiceForCloseTotal}}</h1><div class=\"kpi-footer\"><span class=\"label bg-info\">Pending Closure</span></div></a></div></div></div><div class=\"workflow-card\"><div class=\"ibox kpi-card\"><div class=\"ibox-content\"><a ui-sref=\"app.eway.invoice.cancelled\"><div class=\"kpi-header\"><h4 class=\"kpi-title\">EWB Cancelled</h4><i class=\"far fa-times-circle kpi-icon\"></i></div><h1 class=\"metric-number\">{{vm.EwayStatistics.InvoiceCancelledTotal}}</h1><div class=\"kpi-footer\"><span class=\"label label-danger\">Cancelled</span></div></a></div></div></div></div></div></div>");
$templateCache.put("app/dashboard/samplehtml.html","");
$templateCache.put("app/login/login.html","<style>\n  /* Flat styled full-page login with gradient background */\n  .login-full-page {\n    background: linear-gradient(135deg, #006cb2 0%, #003a68 100%);\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    padding: 40px 20px;\n    color: #ffffff;\n  }\n\n  .login-header-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n    max-width: 650px;\n    margin-bottom: 30px;\n    gap: 20px;\n    flex-wrap: wrap;\n  }\n\n  .login-title-section h1 {\n    font-size: 28px;\n    font-weight: 800;\n    color: #ffffff;\n    margin: 0;\n    letter-spacing: -0.5px;\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);\n  }\n\n  .login-title-section p {\n    font-size: 13px;\n    color: #cbd5e1;\n    margin: 5px 0 0 0;\n  }\n\n  .partner-logos {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    background: rgba(255, 255, 255, 0.95);\n    padding: 8px 15px;\n    border-radius: 12px;\n  }\n\n  .partner-logo-img {\n    height: 70px;\n    width: auto;\n    object-fit: contain;\n  }\n\n  /* Flat Card */\n  .flat-login-card {\n    background-color: #ffffff;\n    border: none;\n    border-radius: 16px;\n    padding: 40px;\n    width: 100%;\n    max-width: 450px;\n    margin-bottom: 25px;\n    color: #333333;\n  }\n\n  .flat-login-card h2 {\n    font-size: 22px;\n    font-weight: 700;\n    color: #0f172a;\n    margin-top: 0;\n    margin-bottom: 25px;\n  }\n\n  /* Flat Material Button but matching theme */\n  .btn-material {\n    background-color: #003a68;\n    border: none;\n    border-radius: 8px;\n    color: #ffffff;\n    font-size: 16px;\n    font-weight: 600;\n    height: 46px;\n    width: 100%;\n    margin-top: 10px;\n    transition: all 0.2s ease;\n  }\n\n  .btn-material:hover:not([disabled]) {\n    background-color: #002d54;\n    color: #ffffff;\n  }\n\n  .btn-material[disabled] {\n    background-color: #cbd5e1;\n    color: #94a3b8;\n    cursor: not-allowed;\n  }\n\n  /* Developer Credit */\n  .dev-credit-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 10px;\n    gap: 5px;\n  }\n\n  .dev-credit-text {\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    color: #e2e8f0;\n    font-weight: 600;\n  }\n\n  .dev-logo-container {\n    background: rgba(255, 255, 255, 0.95);\n    padding: 6px 15px;\n    border-radius: 8px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .dev-logo {\n    height: 64px;\n    width: auto;\n    object-fit: contain;\n  }\n\n  /* Quote styling at the very bottom */\n  .flat-quote-section {\n    max-width: 600px;\n    text-align: center;\n    margin-top: 30px;\n    color: #e2e8f0;\n    font-size: 13px;\n  }\n\n  .flat-quote-text {\n    font-style: italic;\n    line-height: 1.6;\n    margin-bottom: 5px;\n  }\n\n  /* Responsive layout tweaks */\n  @media (max-width: 640px) {\n    .login-header-container {\n      flex-direction: column;\n      text-align: center;\n      align-items: center;\n      gap: 25px;\n    }\n\n    .partner-logos {\n      border-top: none;\n      padding: 10px 20px;\n    }\n  }\n</style><div class=\"login-full-page animated fadeIn\"><div class=\"login-header-container\"><div class=\"login-title-section\"><h1>IMPINC - GST</h1><p>Enterprise Tax Management Suite</p></div><div class=\"partner-logos\"><img class=\"partner-logo-img\" ng-src=\"https://3dincredible.com/wp-content/uploads/2022/09/3d-logo-r.png\" alt=\"inc3d Logo\"> <img class=\"partner-logo-img\" ng-src=\"https://imp-india.com/wp-content/uploads/2026/05/1000319285.png\" alt=\"IMP Logo\" style=\"border-left: 1px solid #cbd5e1; padding-left: 15px;\"></div></div><div style=\"width: 100%; display: flex; flex-direction: column; align-items: center;\"><div class=\"flat-login-card\"><h2>Sign In</h2><form role=\"form\" ng-submit=\"vm.login()\" novalidate=\"novalidate\"><div class=\"input-group\" ng-show=\"!vm.userValidity\" style=\"margin-bottom: 20px;\"><span class=\"input-group-addon\"><i class=\"far fa-user\"></i></span> <input name=\"username\" type=\"text\" required=\"\" class=\"form-control\" ng-model=\"vm.user.username\" placeholder=\"Username\" ng-minlength=\"1\"></div><div class=\"input-group\" style=\"margin-bottom: 20px;\"><span class=\"input-group-addon\"><i class=\"far fa-lock\"></i></span> <input validate-on=\"blur\" name=\"password\" type=\"password\" required=\"\" class=\"form-control\" ng-model=\"vm.user.password\" placeholder=\"Password\" ng-minlength=\"1\"></div><button type=\"submit\" ng-disabled=\"isShowSpinner\" class=\"btn btn-material\"><span ng-hide=\"isShowSpinner\">Login</span> <span ng-show=\"isShowSpinner\"><i class=\"far fa-spinner-third fa-spin fa-fw\"></i> Signing In...</span></button></form></div><div class=\"dev-credit-section\"><span class=\"dev-credit-text\">Developed By</span><div class=\"dev-logo-container\"><img class=\"dev-logo\" ng-src=\"./assets/USS-Logo.png\" alt=\"Users Software Systems\"></div></div></div><div class=\"flat-quote-section\"><p class=\"flat-quote-text\">\"{{vm.randomQuote.quote}}\"</p><span>— {{vm.randomQuote.author}}</span></div></div>");
$templateCache.put("app/user/user.html","<div ui-view=\"main\"></div>");
$templateCache.put("app/admin/role/role.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-sm-6\"><h2>Role <span ng-show=\"vm.showForm\">Form</span> <span ng-hide=\"vm.showForm\">Records</span></h2><ol class=\"breadcrumb\"><li><a ui-sref=\"home.main\">Home</a></li><li class=\"active\"><strong>Admin</strong></li></ol></div><div class=\"col-sm-6\" ng-hide=\"vm.showForm\"></div><div class=\"col-sm-6\" ng-show=\"vm.showForm\"></div></div><div class=\"wrapper wrapper-content\" ng-hide=\"vm.showForm\"><div class=\"row\"><div class=\"col-lg-12\"><div ag-grid=\"vm.gridOptions\" class=\"ag-theme-balham\" style=\"height: 400px\"></div></div></div></div><div class=\"wrapper wrapper-content\" ng-show=\"vm.showForm\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"fQuestionForm\" novalidate=\"\" class=\"\" ng-show=\"vm.showForm\" ng-submit=\"fQuestionForm.$valid && vm.submitRecord()\"><fieldset><div class=\"row m-b-sm\"><div class=\"form-group required col-md-1\"><label class=\"control-label\" for=\"no\">Id</label> <input class=\"form-control\" name=\"no\" ng-model=\"vm.formdata.RoleId\" type=\"text\" disabled=\"\"></div><div class=\"form-group col-md-4\"><label class=\"control-label required\" for=\"no\">Name</label> <input class=\"form-control\" name=\"no\" ng-model=\"vm.formdata.RoleName\" type=\"text\" required=\"\"></div><div class=\"form-group col-md-7\"><label class=\"control-label\" for=\"no\">Description</label> <input class=\"form-control\" name=\"no\" ng-model=\"vm.formdata.RoleDescription\" type=\"text\"></div></div></fieldset><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12\"><button type=\"submit\" class=\"btn btn-success btn-outline pull-right\" ng-disabled=\"vm.isView;isShowSpinner\">Submit</button> <button type=\"reset\" class=\"btn btn-default pull-right\" ng-click=\"vm.cancelForm()\" style=\"margin-right: 10px\">Cancel</button></div></div></div></form></div></div></div>");
$templateCache.put("app/admin/user/user.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-sm-6\"><h2>User <span ng-show=\"vm.showForm\">Form</span> <span ng-hide=\"vm.showForm\">Records</span></h2><ol class=\"breadcrumb\"><li><a ui-sref=\"home.main\">Home</a></li><li class=\"active\"><strong>Admin</strong></li></ol></div><div class=\"col-sm-6\" ng-hide=\"vm.showForm\"><div class=\"title-action\"><button class=\"btn btn-default btn-outline\" name=\"optradio\" ng-click=\"vm.viewRecord()\"><i class=\"far fa-eye\"></i> View</button><button class=\"btn btn-default btn-outline\" ng-click=\"vm.editRecord()\" name=\"optradio\"><i class=\"far fa-pencil-square-o\"></i> Edit</button> <button class=\"btn btn-default btn-outline\" ng-click=\"vm.newRecord()\" name=\"optradio\"><i class=\"far fa-plus\"></i> New</button></div></div><div class=\"col-sm-6\" ng-show=\"vm.showForm\"><div class=\"title-action\"><button class=\"btn btn-default btn-outline\" ng-click=\"vm.showForm=false\" name=\"optradio\"><i class=\"far fa-table\"></i> Records</button></div></div></div><div class=\"wrapper wrapper-content\" ng-hide=\"vm.showForm\"><div class=\"row\"><div class=\"col-lg-12\"><div ag-grid=\"vm.gridOptions\" class=\"ag-theme-balham\" style=\"height: 400px\"></div></div></div></div><div class=\"wrapper wrapper-content\" ng-show=\"vm.showForm\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12\"><form name=\"user\" novalidate=\"\" ng-submit=\"user.$valid && vm.submitRecord()\" class=\"\"><div class=\"row m-b-md\"><div class=\"form-group col-md-3\"><label class=\"control-label\" for=\"no\">UserName</label> <input class=\"form-control\" name=\"no\" ng-model=\"vm.formdata.UserName\" type=\"text\" maxlength=\"20\" ng-disabled=\"vm.formdata.AddDate !== NULL\" pattern=\"^[^\\-]+$\"></div><div class=\"form-group col-md-3\"><label class=\"control-label\" for=\"no\">Full Name</label> <input class=\"form-control\" name=\"no\" ng-model=\"vm.formdata.FullName\" type=\"text\" maxlength=\"255\"></div><div class=\"form-group col-md-3\"><label class=\"control-label\" for=\"no\">EmailId</label> <input class=\"form-control\" name=\"no\" ng-model=\"vm.formdata.EmailId\" type=\"text\" maxlength=\"255\"></div><div class=\"form-group col-md-3\"><label class=\"control-label\" for=\"no\">PhoneNo</label> <input class=\"form-control\" name=\"no\" ng-model=\"vm.formdata.PhoneNo\" type=\"number\" maxlength=\"10\"></div></div><div class=\"row m-b-md\"><div class=\"form-group col-md-3\"><label class=\"control-label\" for=\"no\">Designation</label> <input class=\"form-control\" name=\"no\" ng-model=\"vm.formdata.Designation\" type=\"text\" maxlength=\"255\"></div><div class=\"form-group col-md-6\"><label class=\"control-label\" for=\"no\">Gstin</label><ui-select ng-model=\"vm.SelectedGstin\" ng-click=\"vm.GetGstinMaster()\" theme=\"bootstrap\" reset-search-input=\"false\"><ui-select-match placeholder=\"\" allow-clear=\"true\">{{$select.selected.Gstin}}</ui-select-match><ui-select-choices repeat=\"item in vm.GstinMaster | propsFilter: {Gstin: $select.search,}\"><div class=\"row\"><div class=\"col-md-6\" ng-bind-html=\"item.Gstin | highlight: $select.search\">{{item.Gstin}}</div><div class=\"col-md-6\" ng-bind-html=\"item.TradeName | highlight: $select.search\">{{item.TradeName}}</div></div></ui-select-choices></ui-select></div><div class=\"form-group col-md-3\"><label class=\"control-label\" for=\"no\">Role</label><ui-select ng-model=\"vm.SelectedRole\" ng-click=\"vm.GetRoleMaster()\" theme=\"bootstrap\" reset-search-input=\"false\"><ui-select-match placeholder=\"\">{{$select.selected.RoleName}}</ui-select-match><ui-select-choices repeat=\"item in vm.RoleMaster | propsFilter: {RoleName: $select.search}\"><div class=\"row\"><div class=\"col-md-1\">{{item.RoleId}}</div><div class=\"col-md-2\" ng-bind-html=\"item.RoleName | highlight: $select.search\">{{item.RoleName}}</div></div></ui-select-choices></ui-select></div></div><div class=\"row m-t-md\"><div class=\"form-group col-md-6\"><div class=\"checkbox checkbox-danger checkbox-inline\"><input type=\"checkbox\" ng-model=\"vm.formdata.IsAccountDisabled\"> <label>Account Disabled <span ng-show=\"vm.formdata.AccountDisabledDate\"><b>{{vm.formdata.AccountDisabledDate}}</b></span></label></div></div><div class=\"col-md-6\"><button type=\"submit\" class=\"btn btn-success btn-outline pull-right\" ng-disabled=\"vm.isView\">SUBMIT</button> <button type=\"reset\" class=\"btn btn-default pull-right m-r-sm\" ng-click=\"vm.cancelForm()\">Cancel</button></div></div></form></div></div></div></div></div></div>");
$templateCache.put("app/admin/gstinmaster/gstinmaster.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-sm-4\"><h2>GSTIN <span ng-show=\"vm.showform\">Form</span> <span ng-hide=\"vm.showform\">Records</span></h2><ol class=\"breadcrumb\"><li><a ui-sref=\"home.main\">Home</a></li><li class=\"active\"><strong>E-Invoice</strong></li></ol></div><div class=\"col-sm-8\" ng-hide=\"vm.showform\"><div class=\"title-action\"><button class=\"btn btn-default btn-outline\" ng-click=\"vm.editRecord()\" name=\"optradio\"><i class=\"far fa-pencil-square-o\"></i> Edit</button> <button class=\"btn btn-default btn-outline\" ng-click=\"vm.newRecord()\" name=\"optradio\"><i class=\"far fa-plus\"></i> New</button></div></div><div class=\"col-sm-8\" ng-show=\"vm.showform\"><div class=\"title-action\"><button class=\"btn btn-default btn-outline\" ng-click=\"vm.showform=false\" name=\"optradio\"><i class=\"far fa-table\"></i> Records</button></div></div></div><div class=\"row\" ng-show=\"vm.showform\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content\"><div class=\"row\"><div class=\"ibox\"><div class=\"ibox-content\"><form id=\"unitmasterentry\" method=\"post\" autocomplete=\"off\"><div class=\"row m-b-sm\"><div class=\"form-group col-md-4\"><label class=\"control-label\" for=\"Gstin\">GSTIN</label> <input type=\"text\" class=\"form-control\" id=\"Gstin\" ng-model=\"vm.formdata.Gstin\"></div><div class=\"form-group col-md-4\"><label class=\"control-label\" for=\"GstinGspUsername\">GSTIN GSP Username</label> <input type=\"text\" class=\"form-control\" id=\"GstinGspUsername\" ng-model=\"vm.formdata.GstinGspUsername\"></div><div class=\"form-group col-md-4\"><label class=\"control-label\" for=\"GstinGspPassword\">GSTIN GSP Password</label> <input type=\"text\" class=\"form-control\" id=\"GstinGspPassword\" ng-model=\"vm.formdata.GstinGspPassword\"></div></div><div class=\"row m-b-md\"><div class=\"form-group col-md-4\"><label class=\"control-label\" for=\"GspApiKey\">GSP Api Key</label> <input type=\"number\" class=\"form-control\" id=\"GspApiKey\" ng-model=\"vm.formdata.GspApiKey\" min=\"1\" step=\"1\" onwheel=\"return false;\"></div><div class=\"form-group col-md-4\"><label class=\"control-label\" for=\"GspApiUsername\">GSP Api Username</label> <input type=\"text\" class=\"form-control\" id=\"GspApiUsername\" ng-model=\"vm.formdata.GspApiUsername\"></div><div class=\"form-group col-md-4\"><label class=\"control-label\" for=\"GspApiPassword\">GSP Api Password</label> <input type=\"text\" class=\"form-control\" id=\"GspApiPassword\" ng-model=\"vm.formdata.GspApiPassword\"></div></div><details open=\"\" class=\"m-b-sm\"><summary><strong>GSTIN Details</strong></summary><div class=\"panel panel-default\"><div class=\"panel-body\"><dl class=\"dl-horizontal m-b-none\"><dt>Trade Name :</dt><dd>{{vm.formdata.TradeName}}</dd><dt>Legal Name :</dt><dd>{{vm.formdata.LegalName}}</dd><dt>Addr Building Name :</dt><dd>{{vm.formdata.AddrBnm}}</dd><dt>Addr Block No :</dt><dd>{{vm.formdata.AddrBno}}</dd><dt>Addr Floor No :</dt><dd>{{vm.formdata.AddrFlno}}</dd><dt>Addr Street :</dt><dd>{{vm.formdata.AddrSt}}</dd><dt>Addr Location :</dt><dd>{{vm.formdata.AddrLoc}}</dd><dt>State Code :</dt><dd>{{vm.formdata.StateCode}}</dd><dt>Addr Pincode :</dt><dd>{{vm.formdata.AddrPncd}}</dd><dt>Txp Type :</dt><dd>{{vm.formdata.TxpType}}</dd><dt>Status :</dt><dd>{{vm.formdata.Status}}</dd><dt>Block Status :</dt><dd>{{vm.formdata.BlkStatus}}</dd><dt>Date Registered :</dt><dd>{{vm.formdata.DtReg | date:\"dd/MM/yyyy \'at\' h:mma\"}}</dd><dt>Date DeRegistered :</dt><dd>{{vm.formdata.DtDReg | date:\"dd/MM/yyyy \'at\' h:mma\"}}</dd></dl></div></div></details><div class=\"row\"><button type=\"submit\" class=\"btn btn-success btn-outline pull-right\" ng-click=\"vm.submitRecord()\"><i class=\"far fa-save\"></i> Save</button> <button class=\"btn btn-link pull-right\" ng-click=\"vm.showform=false\" style=\"margin-right:10px;\"><i class=\"far fa-times\"></i> Close</button></div></form></div></div></div></div></div></div><div class=\"row\" ng-hide=\"vm.showform\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content\"><div ag-grid=\"vm.gridOptions\" class=\"ag-theme-balham\" style=\"height: 400px;\"></div></div></div></div>");
$templateCache.put("app/components/common/401.html","<div class=\"middle-box text-center animated tada\"><h1>401</h1><h3 class=\"font-bold\">UNAUTHORIZED</h3><div class=\"error-desc\">The request has not been applied because it lacks valid authentication credentials <strong>or</strong> login has expired.<br>You can go back to home page or logout.<br><button ng-click=\"main.logout()\" class=\"btn btn-outline btn-danger m-t\"><i class=\"far fa-sign-out\"></i>&nbsp;Sign Out</button></div></div>");
$templateCache.put("app/components/common/content.html","<style>\r\n  #loading-bar .bar {\r\n    background-color: #008998;\r\n    position: relative;\r\n    height: 0px;\r\n    /* 3px */\r\n    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\r\n    background-size: 0rem;\r\n    /* 1rem 1rem; */\r\n  }\r\n\r\n  #loading-bar .peg {\r\n    height: 0px;\r\n    opacity: 0%;\r\n  }\r\n\r\n  #loading-bar-spinner {\r\n    top: 12px;\r\n    left: 48%\r\n  }\r\n\r\n  #loading-bar-spinner .spinner-icon {\r\n    width: 25px;\r\n    height: 25px;\r\n    border: solid 4px transparent;\r\n    border-top-color: #29d;\r\n    border-left-color: #29d;\r\n    border-radius: 80%;\r\n    -webkit-animation: loading-bar-spinner 400ms linear infinite;\r\n    -moz-animation: loading-bar-spinner 400ms linear infinite;\r\n    -ms-animation: loading-bar-spinner 400ms linear infinite;\r\n    -o-animation: loading-bar-spinner 400ms linear infinite;\r\n    animation: loading-bar-spinner 400ms linear infinite;\r\n  }\r\n\r\n  @-webkit-keyframes loading-bar-spinner {\r\n    0% {\r\n      -webkit-transform: rotate(0deg);\r\n      transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n      -webkit-transform: rotate(360deg);\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n\r\n  @-moz-keyframes loading-bar-spinner {\r\n    0% {\r\n      -moz-transform: rotate(0deg);\r\n      transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n      -moz-transform: rotate(360deg);\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n\r\n  @-o-keyframes loading-bar-spinner {\r\n    0% {\r\n      -o-transform: rotate(0deg);\r\n      transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n      -o-transform: rotate(360deg);\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n\r\n  @-ms-keyframes loading-bar-spinner {\r\n    0% {\r\n      -ms-transform: rotate(0deg);\r\n      transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n      -ms-transform: rotate(360deg);\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n\r\n  @keyframes loading-bar-spinner {\r\n    0% {\r\n      transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n</style><div id=\"loading-bar-container\"></div><div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\" onload=\"main.InitializeUserLabel()\"></div><div id=\"page-wrapper\" class=\"{{$state.current.name}}\" style=\"background-color: #f3f6fb;\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div></div><div ng-include=\"\'app/components/common/sidebar_notification.html\'\"></div><div ng-include=\"\'app/components/common/sidebar_file.html\'\"></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\">10GB of <strong>250GB</strong> Free.</div><div><strong>Copyright</strong> Example Company &copy; 2015-2016</div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"far fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"far fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"far fa-times\"></i></a></div>");
$templateCache.put("app/components/common/ibox_tools_full_screen.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"far fa-chevron-up\"></i></a> <a ng-click=\"fullscreen()\"><i class=\"far fa-expand\"></i></a> <a href=\"\" uib-dropdown-toggle=\"\"><i class=\"far fa-wrench\"></i></a><ul class=\"dropdown-user\" uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"far fa-times\"></i></a></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side hidden-print\" role=\"navigation\"><div class=\"sidebar-collapse\" full-scroll=\"\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\" style=\"padding:12px;\"><div class=\"profile-element open\"><img alt=\"image\" class=\"img-circle\" height=\"70px\" width=\"70px\" ng-src=\"{{main.UserPhoto}}\"> <a ui-sref=\"app.user.profile\" style=\"color: #676a6c;\"><span class=\"clear\"><h3 class=\"block m-b-xs m-t-sm text-primary\">{{main.FullName}}</h3><span class=\"text-xs block text-primary\">{{main.UserTitle}}</span></span></a></div></li><li><a ui-sref=\"app.dashboard\" ui-sref-opts=\"{reload: true, notify: false}\"><i class=\"far fa-home\"></i><span class=\"nav-label\">Dashboard</span></a></li><li ng-show=\"main.RoleId === \'1\' || main.RoleId === \'2\' || main.RoleId === \'3\'\"><a href=\"\"><i class=\"far fa-chevron-circle-right\"></i><span class=\"nav-label\">E-Invoice</span><span class=\"far fa plus-minus\"></span></a><ul class=\"nav nav-second-level\"><li><a ui-sref=\"\"><span class=\"nav-label\"><i class=\"far fa-angle-double-right\"></i>Master</span><span class=\"far fa plus-minus\"></span></a><ul class=\"nav nav-third-level\"><li ui-sref-active=\"active\"><a ui-sref=\"app.einvoice.master.cancellationreason\">Cancellation Reason</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.einvoice.master.country\">Country</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.einvoice.master.currency\">Currency</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.einvoice.master.documenttype\">Document Type</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.einvoice.master.errorlist\">Error List</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.einvoice.master.ewaybilltransportmode\">EwayBill Transport</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.einvoice.master.ewaybillvehicletype\">EwayBill Vehicle</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.einvoice.master.gsttaxrate\">Gst Tax Rate</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.einvoice.master.port\">Port</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.einvoice.master.state\">State</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.einvoice.master.typeoftransaction\">Type Of Transaction</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.einvoice.master.unit\">Unit</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"app.einvoice.invoice.import\"><i class=\"far fa-angle-double-right\"></i>Invoice From ERP</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.einvoice.invoice.forirn\"><i class=\"far fa-angle-double-right\"></i>Get IRN For Invoice</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.einvoice.invoice.withirn\"><i class=\"far fa-angle-double-right\"></i>Invoice Records</a></li></ul></li><li ng-show=\"main.RoleId === \'1\' || main.RoleId === \'2\' || main.RoleId === \'4\'\"><a href=\"\"><i class=\"far fa-chevron-circle-right\"></i><span class=\"nav-label\">Eway Bill</span><span class=\"far fa plus-minus\"></span></a><ul class=\"nav nav-second-level\"><li><a ui-sref=\"\"><span class=\"nav-label\"><i class=\"far fa-angle-double-right\"></i>Master</span><span class=\"far fa plus-minus\"></span></a><ul class=\"nav nav-third-level\"><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.BillStatus\"><i class=\"far fa-angle-right\"></i>Bill Status</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.CancelReason\"><i class=\"far fa-angle-right\"></i>Cancel Reason</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.ConsignStatus\"><i class=\"far fa-angle-right\"></i>Consignment Status</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.DocType\"><i class=\"far fa-angle-right\"></i>Document Type</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.ErrorCode\"><i class=\"far fa-angle-right\"></i>Error Code</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.GenMode\"><i class=\"far fa-angle-right\"></i>Mode of Generation</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.StateCode\"><i class=\"far fa-angle-right\"></i>State Code</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.SubSupplyType\"><i class=\"far fa-angle-right\"></i>Sub Supply Type</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.SupplyType\"><i class=\"far fa-angle-right\"></i>Supply Type</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.TransMode\"><i class=\"far fa-angle-right\"></i>Transport Mode</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.TransType\"><i class=\"far fa-angle-right\"></i>Transport Type</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.Unit\"><i class=\"far fa-angle-right\"></i>Unit</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.ValExtReason\"><i class=\"far fa-angle-right\"></i>Valid Extension Reason</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.VehicleType\"><i class=\"far fa-angle-right\"></i>Vehicle Type</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.ValidVehicleNumber\"><i class=\"far fa-angle-right\"></i>Valid Vehicle Number</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.TaxRates\"><i class=\"far fa-angle-right\"></i>Tax Rates</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.master.SupplyDocType\"><i class=\"far fa-angle-right\"></i>Supply-Doc Type</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.invoice.import\"><i class=\"far fa-angle-double-right\"></i>Invoice From ERP</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.invoice.forewb\"><i class=\"far fa-angle-double-right\"></i>Get EWB For Invoice</a></li><li ui-sref-active=\"active\"><a ui-sref=\"app.eway.invoice.withewb\"><i class=\"far fa-angle-double-right\"></i>Invoice with EWB</a></li></ul></li><li ng-show=\"main.RoleId === \'1\'\"><a href=\"\"><i class=\"far fa-chevron-circle-right\"></i><span class=\"nav-label\">Admin</span></a><ul class=\"nav nav-second-level\"><li><a ui-sref=\"app.admin.gstinmaster\"><i class=\"far fa-angle-double-right\"></i>GSTIN</a></li><li><a ui-sref=\"app.admin.user\"><i class=\"far fa-angle-double-right\"></i>Users</a></li><li><a ui-sref=\"app.admin.role\"><i class=\"far fa-angle-double-right\"></i>Role</a></li></ul></li></ul></div></nav>");
$templateCache.put("app/components/common/notify.html","");
$templateCache.put("app/components/common/sidebar_file.html","<div id=\"right-sidebar\" ng-show=\"main.IsFileUploadAllowed\" class=\"sidebar-open sidebar-file\"><div class=\"sidebar-container\"><div class=\"sidebar-title\" style=\"padding-bottom:5px;\"><div class=\"row\"><div class=\"col-md-7 p-xxs\"><h3><i class=\"far fa-paperclip\"></i> <span ng-show=\"main.showFileUploadForm\">Upload</span> Files <span>For <strong>RFQ :</strong> <span ng-show=\"main.SelectedRfq.RfqTypeObj.RfqTypeName\">{{main.SelectedRfq.RfqTypeObj.RfqTypeName}}-</span> <span ng-show=\"main.SelectedRfq.RfqTypeName\">{{main.SelectedRfq.RfqTypeName}}-</span> <span ng-show=\"main.SelectedRfq.Territory.TerritoryName\">{{main.SelectedRfq.Territory.TerritoryName}}-</span> <span ng-show=\"main.SelectedRfq.TerritoryName\">{{main.SelectedRfq.TerritoryName}}-</span> {{main.SelectedRfq.RfqNo}}-{{main.SelectedRfq.RfqPartNo}}-{{main.SelectedRfq.RfqPartRevNo}}</span></h3></div><div class=\"col-md-5 p-xxs\"><button class=\"btn btn-link p-xxs pull-right m-l-md\" type=\"button\" ng-click=\"main.IsFileUploadAllowed = !main.IsFileUploadAllowed\"><i class=\"far fa-window-close\"></i> Close</button><button class=\"btn btn-link p-xxs pull-right\" type=\"button\" ng-click=\"main.showFileUploadForm = !main.showFileUploadForm\"><i class=\"far fa-plus\"></i> New File</button></div></div></div><div ng-show=\"main.showFileUploadForm\"><div class=\"sidebar-message\"><div class=\"input-group\"><input type=\"text\" class=\"form-control input-sm\" ng-model=\"main.RfqFile.name\" readonly=\"\" placeholder=\"Max 50MB FileSize Allowed\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-outline btn-default\" ngf-select=\"\" ng-model=\"main.RfqFile\" ngf-max-size=\"50MB\" style=\"font-size: 13px\" ng-change=\"main.calculateHash()\">Select File!</button></span></div></div><div class=\"sidebar-message\"><input type=\"text\" name=\"remarks\" id=\"remarks\" maxlength=\"255\" class=\"form-control\" placeholder=\"Remarks\" ng-model=\"main.FileRemarks\"></div><div class=\"sidebar-message\"><button class=\"btn btn-outline btn-success pull-right m-l-sm\" type=\"button\" ng-click=\"main.UploadRfqEstimationFile()\"><i class=\"far fa-upload\"></i> Upload</button> <button class=\"btn btn-link pull-right\" type=\"button\" ng-click=\"main.showFileUploadForm = !main.showFileUploadForm\"><i class=\"far fa-cancel\"></i> Cancel</button></div></div><div ng-hide=\"true\"><div class=\"ibox\"><div class=\"ibox-content\"><div ag-grid=\"main.filesGridOptions\" class=\"ag-theme-material\" style=\"height: 450px\"></div></div></div></div><div ng-hide=\"main.showFileUploadForm\"><div full-scroll=\"\"><div class=\"table-responsive\"><table class=\"table table-condensed table-bordered\"><thead><th>Department</th><th>File</th><th>Remarks</th><th>Uploaded By</th><th>Delete</th></thead><tbody><tr></tr></tbody><tbody><tr ng-repeat=\"x in main.RfqSalesforceFiles\"><td>Salesforce</td><td><button class=\"btn btn-link\" type=\"button\" ng-click=\"main.DownloadRfqSalesforceFile(x.RfqDocId)\" ng-disabled=\"isShowSpinner\"><i ng-show=\"isShowSpinner\" class=\"far fa-spinner fa-spin\"></i><i class=\"far fa-download\"></i> {{x.FileName}}</button></td><td>{{x.Remarks}}</td><td>{{x.UploadDate | date: \"dd/MM/yyyy \'at\' h:mma\"}}</td><td></td></tr><tr ng-repeat=\"x in main.RfqEstimationFiles\"><td>{{x.UserDepartmentName}}</td><td><button class=\"btn btn-link\" type=\"button\" ng-click=\"main.DownloadRfqEstimationFile(x.RfqEstimationDocumentId)\" ng-disabled=\"isShowSpinner\"><i ng-show=\"isShowSpinner\" class=\"far fa-spinner fa-spin\"></i><i class=\"far fa-download\"></i> {{x.FileName}}</button></td><td>{{x.Remarks}}</td><td>{{x.FullName}} on {{x.UploadDate | date: \"dd/MM/yyyy \'at\' h:mma\"}}</td><td><button class=\"btn btn-danger\" type=\"button\" ng-click=\"main.DeleteRfqEstimationFile(x.RfqEstimationDocumentId)\" ng-disabled=\"isShowSpinner\" title=\"Are your sure you want to delete the file ?\"><i ng-show=\"isShowSpinner\" class=\"far fa-spinner fa-spin\"></i> <i class=\"far fa-trash\"></i></button></td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/components/common/sidebar_notification.html","<div id=\"right-sidebar\" ng-show=\"main.NotificationSidebar\" class=\"sidebar-open\" style=\"width: 400px\"><div class=\"sidebar-container\"><div class=\"sidebar-title\"><div class=\"row\"><div class=\"col-md-9 p-xxs\"><h3><i class=\"far fa-comment-alt-lines\"></i> Notifications</h3></div><div class=\"col-md-3 p-xxs\"><button class=\"btn btn-link p-xxs\" type=\"button\" ng-click=\"main.NotificationSidebar = !main.NotificationSidebar;\"><i class=\"far fa-window-close\"></i> Close</button></div></div></div><div full-scroll=\"\"><ul class=\"sidebar-list\"><li><button class=\"btn btn-link p-xxs\" type=\"button\" ng-click=\"main.ReadAllUserNotification()\"><i class=\"far fa-times-circle\"></i> Clear All Notifications</button></li><li ng-repeat=\"x in main.UserNotifications\"><button class=\"btn btn-link pull-right m-t-xs\" ng-click=\"main.ReadUserNotification(x.NotificationId)\"><i class=\"far fa-close\"></i></button><h4>{{x.NotificationTypeName}}</h4><strong>{{x.Rfq}}</strong><br>Remarks : {{x.Message}}<div class=\"small text-muted m-t-xs\">{{x.AddDate | date:\'short\'}}</div></li></ul></div></div></div>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-fixed-top\" role=\"navigation\" style=\"margin-bottom: 0px\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span> <span class=\"navbar-brand text-white hidden-xs\" style=\"padding-left: 0%;\" ui-sref=\"app.dashboard\">IMPINC - GST</span></div><ul class=\"nav navbar-top-links navbar-right\" style=\"margin-right: 0px\"><li><a ng-click=\"main.logout()\" style=\"vertical-align: top;\"><i class=\"far fa-sign-out\"></i> Sign Out</a></li></ul></nav></div>");
$templateCache.put("app/einvoice/invoice/invoice.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-sm-4\"><h2>{{vm.Title}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"app.dashboard\">Home</a></li><li><a>E-Invoice</a></li><li class=\"active\"><strong>Records</strong></li></ol></div><div class=\"col-sm-8\"><div class=\"title-action\"><button class=\"btn btn-default btn-outline\" name=\"optradio\" ng-hide=\"vm.Section === \'import\'\" ng-click=\"vm.SearchRecords()\"><i class=\"far fa-search\"></i> Search</button> <button class=\"btn btn-default btn-outline\" name=\"optradio\" ng-hide=\"vm.Section === \'import\'\" ng-click=\"vm.init()\"><i class=\"far fa-refresh\"></i> Refresh</button> <button type=\"button\" class=\"btn btn-default btn-outline\" ng-hide=\"vm.Section === \'import\'\" ng-click=\"vm.viewRecord()\"><i class=\"far fa-eye\"></i> View</button> <button type=\"button\" class=\"btn btn-primary btn-outline\" ng-show=\"vm.Section === \'import\'\" ng-click=\"vm.ImportSelectedInvoiceFromErpToEnvoice()\"><i class=\"far fa-download\"></i> Import Invoice</button></div></div></div><div class=\"wrapper wrapper-content\"><div class=\"row\" ng-show=\"vm.Section === \'import\' && vm.showErrorList > 0\"><div class=\"ibox\"><div class=\"ibox-title bg-warning\"><h5>Import Errors</h5><div ibox-tools=\"\"><div class=\"ibox-tools dropdown\" uib-dropdown=\"\"><a ng-click=\"showhide()\" type=\"button\" class=\"btn btn-link\" style=\"color: white !important;\"><i class=\"far fa-chevron-up\"></i></a></div></div></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"table-responsive\"><table class=\"table-bordered table-condensed\"><thead><th>Id</th><th>Field</th><th>ErrorMessage</th></thead><tbody><tr ng-repeat=\"x in vm.formdata.ErrorList\"><td>{{x.ObjectId}}</td><td>{{x.PropertyName}}</td><td>{{x.ErrorMessage}}</td></tr></tbody></table></div></div></div></div></div><div class=\"row\"><div ag-grid=\"vm.gridOptions\" class=\"ag-theme-balham\" style=\"height: 375px;\"></div></div><div class=\"row\" ng-hide=\"vm.Section === \'import\'\"><ul class=\"pagination-sm pagination pull-right m-b-none\"><li class=\"pagination-prev\"><a href=\"\" ng-click=\"vm.PreviousRecordsPage()\"><i class=\"far fa-angle-left\"></i> Previous Page</a></li><li class=\"pagination-page\"><a href=\"\"><strong>[{{vm.CurrentPageNumber}}]</strong></a></li><li class=\"pagination-next\"><a href=\"\" ng-click=\"vm.NextRecordsPage()\">Next Page <i class=\"far fa-angle-right\"></i></a></li></ul></div></div>");
$templateCache.put("app/einvoice/invoice/invoiceview.html","<style>\r\n    dt {\r\n        display: list-item;\r\n        list-style-type: disc;\r\n        list-style-position: outside;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-sm-4\"><h2>Invoice <small>ID: {{vm.formdata.DocDtls.No}}</small></h2><ol class=\"breadcrumb\"><li><a ui-sref=\"app.dashboard\">Home</a></li><li><a>E-Invoice</a></li><li class=\"active\"><strong>Invoice</strong></li></ol></div><div class=\"col-sm-8\"><div class=\"title-action\"><button class=\"btn btn-primary btn-outline m-r-sm\" name=\"optradio\" ng-click=\"qrcodeString=vm.formdata.QRImg\" ng-show=\"vm.formdata.QRImg\"><i class=\"far fa-qrcode\"></i> QR Code</button> <button class=\"btn btn-info btn-outline dim pull-right m-r-sm\" name=\"optradio\" ng-click=\"vm.PrintEnvoiceByIrn()\" ng-show=\"vm.formdata.Irn && vm.formdata.PdfPrint === null\" ng-disabled=\"isShowSpinner\"><i class=\"far fa-print\" ng-hide=\"isShowSpinner\"></i> <i ng-show=\"isShowSpinner\" class=\"far fa-spinner-third fa-spin fa-fw\"></i>Get Print Data From GSP</button> <button class=\"btn btn-info btn-outline\" name=\"optradio\" ng-click=\"vm.PrintEnvoicePdf()\" ng-show=\"vm.formdata.Irn && vm.formdata.PdfPrint\"><i class=\"far fa-print\"></i> Print PDF</button></div></div></div><div class=\"wrapper wrapper-content\"><div class=\"row\" ng-show=\"vm.showErrorList > 0 && vm.formdata.Irn == null\"><div class=\"ibox\"><div class=\"ibox-title bg-warning\"><h5>Invoice Errors</h5><div ibox-tools=\"\"><div class=\"ibox-tools dropdown\" uib-dropdown=\"\"><a ng-click=\"showhide()\" type=\"button\" class=\"btn btn-link\" style=\"color: white !important;\"><i class=\"far fa-chevron-up\"></i></a></div></div></div><div class=\"ibox-content\"><div class=\"row\" ng-repeat=\"x in vm.formdata.ErrorList\"><div class=\"col-sm-12\"><details class=\"m-b-sm\"><summary><small>Error on {{x.ErrorDateTime | date:\'medium\'}}</small></summary><div class=\"panel panel-default\"><div class=\"panel-body p-xxs\"><dl class=\"dl-horizontal m-b-none\"><div><dt>Type :</dt><dd>{{x.ErrorType}}</dd></div><div><dt>Code :</dt><dd>{{x.ErrorCode}}</dd></div><div><dt>Message:</dt><dd>{{x.ErrorMessage}}</dd></div><div><dt>Other Information :</dt><dd>{{x.InfoDtls}}</dd></div><div><dt>Message from Master :</dt><dd>{{x.ErrorMessageFromMaster}}</dd></div><div><dt>Reason :</dt><dd>{{x.ReasonForErro}}</dd></div><div><dt>Resolution :</dt><dd>{{x.Resolution}}</dd></div></dl></div></div></details></div></div></div></div></div><div class=\"row m-t-md\" ng-show=\"vm.formdata.QRImg && qrcodeString\"><div class=\"col-md-offset-4 col-md-4\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-md-8\"><h5>Signed QR Code</h5></div><div class=\"col-md-4\"><button ng-click=\"qrcodeString=null\" type=\"button\" class=\"btn btn-link pull-right\" style=\"padding-top: 0%;\"><i class=\"far fa-times\"></i> Close</button></div></div></div><div class=\"panel-body\"><textarea type=\"text\" id=\"text\" class=\"textarea\" ng-model=\"qrcodeString\" placeholder=\"YOUR TEXT TO ENCODE\" ng-hide=\"true\"></textarea><qr size=\"250\" text=\"qrcodeString\" input-mode=\"inputMode\" image=\"true\"></qr></div></div></div></div><div><div class=\"row m-t-md\"><div class=\"col-sm-3\"><h4>Document Details</h4><div class=\"panel panel-default\"><div class=\"panel-body p-md\"><dl class=\"m-b-none\"><dt>Type</dt><dd>{{vm.formdata.DocDtls.Typ}}</dd><dt>No</dt><dd>{{vm.formdata.DocDtls.No}}</dd><dt>Date</dt><dd>{{vm.formdata.DocDtls.Dt}}</dd></dl></div></div></div><div class=\"col-sm-3\"><h4>Transaction Details</h4><div class=\"panel panel-default\"><div class=\"panel-body p-md\"><dl class=\"m-b-none\"><div><dt>Supply Type</dt><dd>{{vm.formdata.TranDtls.SupTyp}}</dd></div><div><dt>Reverse Charge</dt><dd>{{vm.formdata.TranDtls.RegRev}}</dd></div><div><dt>Igst On Intra</dt><dd>{{vm.formdata.TranDtls.IgstOnIntra}}</dd></div></dl></div></div></div><div class=\"col-sm-3\"><h4>IRN Details</h4><div class=\"panel panel-default\"><div class=\"panel-body p-md\"><dl class=\"m-b-none\"><dt>IRN</dt><dd style=\"overflow-x:clip;\">{{vm.formdata.Irn}}</dd><dt>Ack. No</dt><dd>{{vm.formdata.AckNo}}</dd><dt>Ack. Date</dt><dd>{{vm.formdata.AckDate}}</dd></dl></div></div></div><div class=\"col-sm-3\"><h4>Cancellation Details</h4><div class=\"panel panel-default\"><div class=\"panel-body p-md\"><dl class=\"m-b-none\"><dt>Reason</dt><dd>{{vm.formdata.CnlRsn}}</dd><dt>Remarks</dt><dd>{{vm.formdata.CnlRem}}</dd><dt>Date</dt><dd>{{vm.formdata.CancelDate}}</dd></dl></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><table class=\"table table-responsive table-condensed table-bordered\" style=\"background-color: white;\"><thead><tr><th></th><th>Seller Details</th><th>Buyer Details</th><th>Display Details</th><th>Shipping Details</th></tr></thead><tbody><tr><td>GSTIN</td><td>{{vm.formdata.SellerDtls.Gstin}}</td><td>{{vm.formdata.BuyerDtls.Gstin}}</td><td>-</td><td>{{vm.formdata.ShipDtls.Gstin}}</td></tr><tr><td>Legal Name</td><td>{{vm.formdata.SellerDtls.LglNm}}</td><td>{{vm.formdata.BuyerDtls.LglNm}}</td><td>{{vm.formdata.DispDtls.Nm}}</td><td>{{vm.formdata.ShipDtls.LglNm}}</td></tr><tr><td>Trade Name</td><td>{{vm.formdata.SellerDtls.TrdNm}}</td><td>{{vm.formdata.BuyerDtls.TrdNm}}</td><td>-</td><td>{{vm.formdata.ShipDtls.TrdNm}}</td></tr><tr><td>Pos</td><td>-</td><td>{{vm.formdata.BuyerDtls.Pos}}</td><td>-</td><td>-</td></tr><tr><td>Address 1</td><td>{{vm.formdata.SellerDtls.Addr1}}</td><td>{{vm.formdata.BuyerDtls.Addr1}}</td><td>{{vm.formdata.DispDtls.Addr1}}</td><td>{{vm.formdata.ShipDtls.Addr1}}</td></tr><tr><td>Address 2</td><td>{{vm.formdata.SellerDtls.Addr2}}</td><td>{{vm.formdata.BuyerDtls.Addr2}}</td><td>{{vm.formdata.DispDtls.Addr2}}</td><td>{{vm.formdata.ShipDtls.Addr2}}</td></tr><tr><td>Location</td><td>{{vm.formdata.SellerDtls.Loc}}</td><td>{{vm.formdata.BuyerDtls.Loc}}</td><td>{{vm.formdata.DispDtls.Loc}}</td><td>{{vm.formdata.ShipDtls.Loc}}</td></tr><tr><td>Pin</td><td>{{vm.formdata.SellerDtls.Pin}}</td><td>{{vm.formdata.BuyerDtls.Pin}}</td><td>{{vm.formdata.DispDtls.Pin}}</td><td>{{vm.formdata.ShipDtls.Pin}}</td></tr><tr><td>State Code</td><td>{{vm.formdata.SellerDtls.Stcd}}</td><td>{{vm.formdata.BuyerDtls.Stcd}}</td><td>{{vm.formdata.DispDtls.Stcd}}</td><td>{{vm.formdata.ShipDtls.Stcd}}</td></tr><tr><td>Phone</td><td>{{vm.formdata.SellerDtls.Ph}}</td><td>{{vm.formdata.BuyerDtls.Ph}}</td><td>-</td><td>-</td></tr><tr><td>E-Mail</td><td>{{vm.formdata.SellerDtls.Em}}</td><td>{{vm.formdata.BuyerDtls.Em}}</td><td>-</td><td>-</td></tr></tbody></table></div></div><div class=\"\"><table class=\"table table-bordered table-responsive\" style=\"background-color: white;\"><caption><h4>Goods Details</h4></caption><thead><tr><th>SlNo</th><th>Prod Desc.</th><th>HSN Code</th><th>Quantity</th><th>Unit</th><th>Unit Price(Rs)</th><th>Discount(Rs)</th><th>Taxable Amount(Rs)</th><th>Tax Rate(GST+Cess |State Cess+CessNon.Advol)</th><th>Other charges(Rs)</th><th>Total</th></tr></thead><tbody><tr ng-repeat=\"x in vm.formdata.ItemList\"><td>{{x.SlNo}}</td><td>{{x.PrdDesc}}</td><td>{{x.HsnCd}}</td><td>{{x.Qty}}</td><td>{{x.Unit}}</td><td>{{x.UnitPrice}}</td><td>{{x.Discount}}</td><td>{{x.AssAmt}}</td><td>{{x.GstRt}} , {{x.IgstAmt}}, {{x.CgstAmt}} , {{x.SgstAmt }} , {{x.CesRt}} {{x.StateCesRt}}</td><td>{{x.OthChrg }}</td><td>{{x.TotItemVal}}</td></tr></tbody></table></div><div class=\"\"><table class=\"table table-bordered table-responsive invoice-table\" style=\"background-color: white;\"><caption><h4>Tax Details</h4></caption><thead><tr><th>Tax\'ble Amt</th><th>CGST Amt</th><th>SGST Amt</th><th>IGST Amt</th><th>CESS Amt</th><th>State CESS Amt</th><th>Discount</th><th>OtherCharges</th><th>Round off Amt</th><th>Total Inv.Amt</th></tr></thead><tbody><tr><td>{{vm.formdata.ValDtls.AssVal}}</td><td>{{vm.formdata.ValDtls.CgstVal}}</td><td>{{vm.formdata.ValDtls.SgstVal}}</td><td>{{vm.formdata.ValDtls.IgstVal}}</td><td>{{vm.formdata.ValDtls.CesVal}}</td><td>{{vm.formdata.ValDtls.StCesVal}}</td><td>{{vm.formdata.ValDtls.Discount}}</td><td>{{vm.formdata.ValDtls.OthChrg}}</td><td>{{vm.formdata.ValDtls.RndOffAmt}}</td><td>{{vm.formdata.ValDtls.TotInvVal}}</td></tr></tbody></table></div><div class=\"row\"><div class=\"col-md-4\"><table class=\"table table-bordered table-responsive\" style=\"background-color: white;\"><thead><tr><th colspan=\"2\">Payment Details</th></tr></thead><tbody><tr><td>Nm :</td><td>{{vm.formdata.Paytdls.Nm}}</td></tr><tr><td>AccDet :</td><td>{{vm.formdata.Paytdls.AccDet}}</td></tr><tr><td>Mode :</td><td>{{vm.formdata.Paytdls.Mode}}</td></tr><tr><td>FinInsBr :</td><td>{{vm.formdata.Paytdls.FinInsBr}}</td></tr><tr><td>PayTerm :</td><td>{{vm.formdata.Paytdls.PayTerm}}</td></tr><tr><td>PayInstr :</td><td>{{vm.formdata.Paytdls.PayInstr}}</td></tr><tr><td>CrTrn :</td><td>{{vm.formdata.Paytdls.CrTrn}}</td></tr><tr><td>DirDr :</td><td>{{vm.formdata.Paytdls.DirDr}}</td></tr><tr><td>CrDay :</td><td>{{vm.formdata.Paytdls.CrDay}}</td></tr><tr><td>PaidAmt :</td><td>{{vm.formdata.Paytdls.PaidAmt}}</td></tr><tr><td>PaymtDue :</td><td>{{vm.formdata.Paytdls.PaymtDue}}</td></tr></tbody></table></div><div class=\"col-md-4\"><table class=\"table table-bordered table-responsive\" style=\"background-color: white;\"><thead><tr><th colspan=\"2\">E-Way Bill Details</th></tr></thead><tbody><tr><td>TransId</td><td>{{vm.formdata.EwbDtls.TransId}}</td></tr><tr><td>TransName</td><td>{{vm.formdata.EwbDtls.TransName}}</td></tr><tr><td>Distance</td><td>{{vm.formdata.EwbDtls.Distance}}</td></tr><tr><td>TransDocNo</td><td>{{vm.formdata.EwbDtls.TransDocNo}}</td></tr><tr><td>TransDocDt</td><td>{{vm.formdata.EwbDtls.TransDocDt}}</td></tr><tr><td>VehNo</td><td>{{vm.formdata.EwbDtls.VehNo}}</td></tr><tr><td>VehType</td><td>{{vm.formdata.EwbDtls.VehType}}</td></tr><tr><td>TransMode</td><td>{{vm.formdata.EwbDtls.TransMode}}</td></tr></tbody></table></div><div class=\"col-md-4\"><table class=\"table table-bordered table-responsive\" style=\"background-color: white;\"><thead><tr><th colspan=\"2\">Export Details</th></tr></thead><tbody><tr><td>ShipBNo</td><td>{{vm.formdata.ExpDtls.ShipBNo}}</td></tr><tr><td>ShipBDt</td><td>{{vm.formdata.ExpDtls.ShipBDt}}</td></tr><tr><td>Port</td><td>{{vm.formdata.ExpDtls.Port}}</td></tr><tr><td>RefClm</td><td>{{vm.formdata.ExpDtls.RefClm}}</td></tr><tr><td>ForCur</td><td>{{vm.formdata.ExpDtls.ForCur}}</td></tr><tr><td>CntCode</td><td>{{vm.formdata.ExpDtls.CntCode}}</td></tr><tr><td>ExpDuty</td><td>{{vm.formdata.ExpDtls.ExpDuty}}</td></tr></tbody></table></div></div><div class=\"row\" ng-show=\"vm.formdata.Irn && !vm.formdata.CancelDate\"><div class=\"ibox collapsed\"><div class=\"ibox-title bg-danger\"><h5>Invoice Cancellation</h5><div ibox-tools=\"\"><div class=\"ibox-tools dropdown\" uib-dropdown=\"\"><a ng-click=\"showhide()\" type=\"button\" class=\"btn btn-link\"><i class=\"far fa-chevron-up\"></i></a></div></div></div><div class=\"ibox-content\"><div class=\"row m-b-sm\"><div class=\"form-group col-md-3\"><label class=\"control-label\" for=\"CnlRsn\">Reason</label><select name=\"CnlRsn\" ng-model=\"vm.formdata.CnlRsn\" class=\"form-control\"><option value=\"\" selected=\"\"></option><option value=\"1\">Duplicate</option><option value=\"2\">Data Entry Mistake</option></select></div><div class=\"form-group col-md-7\"><label class=\"control-label\" for=\"CnlRem\">Remark</label><select name=\"CnlRem\" ng-model=\"vm.formdata.CnlRem\" class=\"form-control\"><option value=\"\" selected=\"\"></option><option value=\"Duplicate\">Duplicate</option><option value=\"Data Entry Mistake\">Data Entry Mistake</option></select></div><div class=\"col-sm-2\"><button class=\"btn btn-danger btn-outline dim m-t-md\" name=\"optradio\" mwl-confirm=\"\" title=\"Are you sure ?\" message=\"\" placement=\"top\" on-confirm=\"vm.CancelInvoiceConfirm()\" on-cancel=\"vm.CancelInvoiceCancelled()\" confirm-button-type=\"danger\" cancel-button-type=\"default\"><i class=\"far fa-trash\"></i> Cancel</button></div></div></div></div></div><div class=\"row\"><button class=\"btn btn-success btn-outline dim pull-right\" ng-click=\"vm.GetIrnForInvoice()\" name=\"optradio\" ng-hide=\"vm.formdata.Irn\"><i class=\"far fa-arrow-down\" ng-hide=\"isShowSpinner\"></i> <i ng-show=\"isShowSpinner\" class=\"far fa-spinner-third fa-spin fa-fw\"></i> Get IRN</button></div></div></div>");
$templateCache.put("app/einvoice/master/master.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-sm-6\"><h2>{{vm.MasterName}} Master</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"home.main\">Home</a></li><li class=\"active\"><strong>E-Invoice</strong></li></ol></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content\"><div ag-grid=\"vm.gridOptions\" class=\"ag-theme-balham\" style=\"height: 400px;\"></div></div></div></div>");
$templateCache.put("app/eway/invoice/invoicerecord.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-sm-4\"><h2>{{vm.Title}}</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"app.dashboard\">Home</a></li><li><a>Ewaybill</a></li><li class=\"active\"><strong>Records</strong></li></ol></div><div class=\"col-sm-8\"><div class=\"title-action\"><button class=\"btn btn-default btn-outline\" name=\"optradio\" ng-hide=\"vm.Section == \'import\'\" ng-click=\"vm.SearchRecords()\"><i class=\"far fa-search\"></i> Search</button> <button class=\"btn btn-default btn-outline\" name=\"optradio\" ng-hide=\"vm.Section == \'import\'\" ng-click=\"vm.init()\"><i class=\"far fa-refresh\"></i> Refresh</button> <button type=\"button\" class=\"btn btn-default btn-outline\" ng-hide=\"vm.Section == \'import\'\" ng-click=\"vm.viewRecord()\"><i class=\"far fa-eye\"></i> View</button> <button type=\"button\" class=\"btn btn-primary btn-outline\" ng-show=\"vm.Section == \'import\'\" ng-click=\"vm.ImportSelectedInvoiceFromErp()\"><i class=\"far fa-download\"></i> Import Invoice</button></div></div></div><div class=\"wrapper wrapper-content\"><div class=\"row\"><div ag-grid=\"vm.gridOptions\" class=\"ag-theme-balham\" style=\"height: 375px;\"></div></div><div class=\"row\" ng-hide=\"vm.Section === \'import\'\"><ul class=\"pagination-sm pagination pull-right m-b-none\"><li class=\"pagination-prev\"><a href=\"\" ng-click=\"vm.PreviousRecordsPage()\"><i class=\"far fa-angle-left\"></i> Previous Page</a></li><li class=\"pagination-page\"><a href=\"\"><strong>[{{vm.CurrentPageNumber}}]</strong></a></li><li class=\"pagination-next\"><a href=\"\" ng-click=\"vm.NextRecordsPage()\">Next Page <i class=\"far fa-angle-right\"></i></a></li></ul></div></div>");
$templateCache.put("app/eway/invoice/invoiceview.html","<style>\r\n    dt {\r\n        display: list-item;\r\n        list-style-type: disc;\r\n        list-style-position: outside;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-sm-4\"><h2>Invoice</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"app.dashboard\">Home</a></li><li><a>Ewaybill</a></li><li class=\"active\"><strong>Invoice</strong></li></ol></div><div class=\"col-sm-8\"><div class=\"title-action\"><button class=\"btn btn-info btn-outline dim pull-right\" name=\"optradio\" ng-click=\"vm.PrintEwayFromWebtel()\" ng-show=\"vm.formdata.ewayBillNo && vm.formdata.PdfPrintSummary === null && vm.formdata.PdfPrintDetail === null\" ng-disabled=\"isShowSpinner\"><i class=\"far fa-print\" ng-hide=\"isShowSpinner\"></i> <i ng-show=\"isShowSpinner\" class=\"far fa-spinner-third fa-spin fa-fw\"></i>Get Print Data From GSP</button> <button class=\"btn btn-info btn-outline\" name=\"optradio\" ng-click=\"vm.PrintEwayPdf(\'Summary\')\" ng-show=\"vm.formdata.ewayBillNo && vm.formdata.PdfPrintSummary && vm.formdata.PdfPrintDetail\"><i class=\"far fa-print\"></i> Print Summary</button> <button class=\"btn btn-info btn-outline\" name=\"optradio\" ng-click=\"vm.PrintEwayPdf(\'Detail\')\" ng-show=\"vm.formdata.ewayBillNo && vm.formdata.PdfPrintSummary && vm.formdata.PdfPrintDetail\"><i class=\"far fa-print\"></i> Print Detail</button></div></div></div><div class=\"wrapper wrapper-content\"><div class=\"row\" ng-show=\"vm.showErrorList > 0\"><div class=\"ibox\"><div class=\"ibox-title bg-warning\"><h5>Invoice Errors</h5><div ibox-tools=\"\"><div class=\"ibox-tools dropdown\" uib-dropdown=\"\"><a ng-click=\"showhide()\" type=\"button\" class=\"btn btn-link\" style=\"color: white !important;\"><i class=\"far fa-chevron-up\"></i></a></div></div></div><div class=\"ibox-content\"><div class=\"row\" ng-repeat=\"x in vm.formdata.ErrorList\"><div class=\"col-sm-12\"><details class=\"m-b-sm\"><summary><small>Error on {{x.ErrorDateTime | date:\'medium\'}}</small></summary><div class=\"panel panel-default\"><div class=\"panel-body p-xxs\"><dl class=\"dl-horizontal m-b-none\"><div><dt>Type :</dt><dd>{{x.ErrorType}}</dd></div><div><dt>Code :</dt><dd>{{x.ErrorCode}}</dd></div><div><dt>Message:</dt><dd>{{x.ErrorMessage}}</dd></div><div><dt>Other Information :</dt><dd>{{x.InfoDtls}}</dd></div><div><dt>Message from Master :</dt><dd>{{x.ErrorMessageFromMaster}}</dd></div><div><dt>Reason :</dt><dd>{{x.ReasonForErro}}</dd></div><div><dt>Resolution :</dt><dd>{{x.Resolution}}</dd></div></dl></div></div></details></div></div></div></div></div><div class=\"row m-t-md\" ng-show=\"vm.formdata.QRImg && qrcodeString\"><div class=\"col-md-offset-4 col-md-4\"><div class=\"panel panel-default\"><div class=\"panel-heading\"><div class=\"row\"><div class=\"col-md-8\"><h5>Signed QR Code</h5></div><div class=\"col-md-4\"><button ng-click=\"qrcodeString=null\" type=\"button\" class=\"btn btn-link pull-right\" style=\"padding-top: 0%;\"><i class=\"far fa-times\"></i> Close</button></div></div></div><div class=\"panel-body\"><textarea type=\"text\" id=\"text\" class=\"textarea\" ng-model=\"qrcodeString\" placeholder=\"YOUR TEXT TO ENCODE\" ng-hide=\"true\"></textarea><qr size=\"250\" text=\"qrcodeString\" input-mode=\"inputMode\" image=\"true\"></qr></div></div></div></div><div><div class=\"row m-t-md\"><div class=\"col-sm-3\"><h4>Document Details</h4><div class=\"panel panel-default\"><div class=\"panel-body p-md\"><dl class=\"m-b-none\"><dt>Type</dt><dd>{{vm.formdata.docType}}</dd><dt>No</dt><dd>{{vm.formdata.docNo}}</dd><dt>Date</dt><dd>{{vm.formdata.docDate}}</dd></dl></div></div></div><div class=\"col-sm-3\"><h4>Transaction Details</h4><div class=\"panel panel-default\"><div class=\"panel-body p-md\"><dl class=\"m-b-none\"><div><dt>Supply Type</dt><dd>{{vm.formdata.supplyType}}</dd></div><div><dt>Sub Supply Type</dt><dd>{{vm.formdata.subSupplyType}}</dd></div><div><dt>Transaction Type</dt><dd>{{vm.formdata.transactionType}}</dd></div></dl></div></div></div><div class=\"col-sm-3\"><h4>EWB Details</h4><div class=\"panel panel-default\"><div class=\"panel-body p-md\"><dl class=\"m-b-none\"><dt>EWB Number</dt><dd style=\"overflow-x:clip;\">{{vm.formdata.ewayBillNo}}</dd><dt>Date</dt><dd>{{vm.formdata.ewayBillDate}}</dd><dt>Valid UpTo</dt><dd>{{vm.formdata.validUpto}}</dd><dt>Old EWB Number</dt></dl></div></div></div><div class=\"col-sm-3\"><h4>Close/Cancellation Details</h4><div class=\"panel panel-default\"><div class=\"panel-body p-md\"><dl class=\"m-b-none\"><dt>Reason</dt><dd>{{vm.formdata.CancelReasonCode}}</dd><dt>Remarks</dt><dd>{{vm.formdata.CancelRemark}}</dd><dt>Date</dt><dd>{{vm.formdata.CancelDate}}</dd><hr><dt>Close Date</dt><dd>{{vm.formdata.CloseDate}}</dd></dl></div></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><table class=\"table table-responsive table-condensed table-bordered\" style=\"background-color: white;\"><thead><tr><th width=\"10%\"></th><th width=\"45%\">Bill From</th><th width=\"45%\">Bill To</th></tr></thead><tbody><tr><td>Name</td><td>{{vm.formdata.fromTrdName}}</td><td>{{vm.formdata.toTrdName}}</td></tr><tr><td>GSTIN</td><td>{{vm.formdata.fromGstin}}</td><td>{{vm.formdata.toGstin}}</td></tr><tr><td>State</td><td>{{vm.formdata.actFromStateCode}}</td><td>{{vm.formdata.actToStateCode}}</td></tr></tbody></table></div><div class=\"col-sm-12\"><table class=\"table table-responsive table-condensed table-bordered\" style=\"background-color: white;\"><thead><tr><th width=\"10%\"></th><th width=\"45%\">Dispatch From</th><th width=\"45%\">Ship To</th></tr></thead><tbody><tr><td>GSTIN</td><td>-</td><td>{{vm.formdata.shipToGstin}}</td></tr><tr><td>TradeName</td><td>-</td><td>{{vm.formdata.shipToTrdName}}</td></tr><tr><td>Address 1</td><td>{{vm.formdata.fromAddr1}}</td><td>{{vm.formdata.toAddr1}}</td></tr><tr><td>Address 2</td><td>{{vm.formdata.fromAddr2}}</td><td>{{vm.formdata.toAddr2}}</td></tr><tr><td>Place</td><td>{{vm.formdata.fromPlace}}</td><td>{{vm.formdata.toPlace}}</td></tr><tr><td>Pin</td><td>{{vm.formdata.fromPincode}}</td><td>{{vm.formdata.toPincode}}</td></tr><tr><td>State</td><td>{{vm.formdata.fromStateCode}}</td><td>{{vm.formdata.toStateCode}}</td></tr></tbody></table></div></div><div class=\"\"><table class=\"table table-bordered table-responsive\" style=\"background-color: white;\"><caption><h4>Goods Details</h4></caption><thead><tr><th>SlNo</th><th>Prod Desc.</th><th>Prod Name</th><th>HSN Code</th><th>Quantity</th><th>Unit</th><th>Taxable Amount(Rs)</th><th>Tax Rate (CGST,SGST,IGST)</th><th>Cess, CessNon.Advol Rate</th></tr></thead><tbody><tr ng-repeat=\"x in vm.formdata.itemList\"><td>{{x.SlNo}}</td><td>{{x.productDesc}}</td><td>{{x.productName}}</td><td>{{x.hsnCode}}</td><td>{{x.quantity}}</td><td>{{x.qtyUnit}}</td><td>{{x.taxableAmount}}</td><td>{{x.cgstRate}}, {{x.sgstRate}}, {{x.igstRate}}</td><td>{{x.cessRate}}, {{x.cessNonadvol}}</td></tr></tbody></table></div><div class=\"row\"><div class=\"col-md-4\"><table class=\"table table-bordered table-responsive\" style=\"background-color: white;\"><thead><tr><th colspan=\"2\">Transportation Details</th></tr></thead><tbody><tr><td width=\"40%\">Transporter Id</td><td width=\"60%\">{{vm.formdata.transporterId}}</td></tr><tr><td width=\"40%\">Transporter Name</td><td width=\"60%\">{{vm.formdata.transporterName}}</td></tr><tr><td width=\"40%\">Distance</td><td width=\"60%\">{{vm.formdata.transDistance}}</td></tr></tbody></table></div><div class=\"col-md-4\"><table class=\"table table-bordered table-responsive\" style=\"background-color: white;\"><thead><tr><th colspan=\"2\">Part-B</th></tr></thead><tbody><tr><td width=\"40%\">TransMode</td><td width=\"60%\">{{vm.formdata.transMode}}</td></tr><tr><td width=\"40%\">Vehicle Type</td><td width=\"60%\">{{vm.formdata.vehicleType}}</td></tr><tr><td width=\"40%\">Vehicle No</td><td width=\"60%\">{{vm.formdata.vehicleNo}}</td></tr><tr><td width=\"40%\">TransDocNo</td><td width=\"60%\">{{vm.formdata.transDocNo}}</td></tr><tr><td width=\"40%\">TransDocDt</td><td width=\"60%\">{{vm.formdata.transDocDate}}</td></tr></tbody></table></div><div class=\"col-md-4\"><table class=\"table table-bordered table-responsive invoice-table\" style=\"background-color: white;\"><thead><tr><th colspan=\"2\">Tax Details</th></tr></thead><tbody><tr><th>OtherCharges</th><td>{{vm.formdata.otherValue}}</td></tr><tr><th>Total Amt</th><td>{{vm.formdata.totalValue}}</td></tr><tr><th>CGST Amt</th><td>{{vm.formdata.cgstValue}}</td></tr><tr><th>SGST Amt</th><td>{{vm.formdata.sgstValue}}</td></tr><tr><th>IGST Amt</th><td>{{vm.formdata.igstValue}}</td></tr><tr><th>CESS Amt</th><td>{{vm.formdata.cessValue}}</td></tr><tr><th>CESS Non Ad Vol Amt</th><td>{{vm.formdata.cessNonAdvolValue}}</td></tr><tr><th>Total Inv.Amt</th><td>{{vm.formdata.totInvValue}}</td></tr></tbody></table></div></div><div class=\"row\" ng-show=\"vm.formdata.ewayBillNo && !vm.formdate.IsClosed\"><div class=\"ibox collapsed\"><div class=\"ibox-title bg-info\"><h5>Eway Bill Closing</h5><div ibox-tools=\"\"><div class=\"ibox-tools dropdown\" uib-dropdown=\"\"><a ng-click=\"showhide()\" type=\"button\" class=\"btn btn-link\"><i class=\"far fa-chevron-up\"></i></a></div></div></div><div class=\"ibox-content\"><div class=\"row m-b-sm\"><div class=\"form-group col-md-4\"><label class=\"control-label\" for=\"CloseDate\">Close Date</label> <input type=\"date\" class=\"form-control\" ng-model=\"vm.formdata.CloseDate\" min=\"{{ vm.minCloseDate | date:\'yyyy-MM-dd\' }}\"></div><div class=\"form-group col-md-4\"><label class=\"control-label\" for=\"CloseRemark\">Remarks</label> <input class=\"form-control\" value=\"Order Delivered.\" readonly=\"\"></div><div class=\"col-sm-2\"><button class=\"btn btn-info btn-outline dim m-t-md\" name=\"optradio\" mwl-confirm=\"\" title=\"Are you sure ?\" message=\"\" placement=\"top\" on-confirm=\"vm.CloseInvoiceConfirm()\" on-cancel=\"vm.CloseInvoiceCancelled()\" confirm-button-type=\"danger\" cancel-button-type=\"default\"><i class=\"far fa-trash\"></i> Close</button></div></div></div></div></div><div class=\"row\" ng-show=\"vm.formdata.ewayBillNo && !vm.formdata.CancelDate\"><div class=\"ibox collapsed\"><div class=\"ibox-title bg-danger\"><h5>Invoice Cancellation</h5><div ibox-tools=\"\"><div class=\"ibox-tools dropdown\" uib-dropdown=\"\"><a ng-click=\"showhide()\" type=\"button\" class=\"btn btn-link\"><i class=\"far fa-chevron-up\"></i></a></div></div></div><div class=\"ibox-content\"><div class=\"row m-b-sm\"><div class=\"form-group col-md-4\"><label class=\"control-label\" for=\"CancelReasonCode\">Reason</label><select name=\"CancelReasonCode\" ng-model=\"vm.formdata.CancelReasonCode\" class=\"form-control\"><option value=\"\" selected=\"\"></option><option value=\"1\">Duplicate</option><option value=\"2\">Order Cancelled</option><option value=\"3\">Data Entry Mistake</option><option value=\"4\">Others</option></select></div><div class=\"form-group col-md-4\"><label class=\"control-label\" for=\"CancelRemark\">Remarks</label><select name=\"CancelRemark\" ng-model=\"vm.formdata.CancelRemark\" class=\"form-control\"><option value=\"\" selected=\"\"></option><option value=\"1\">Duplicate</option><option value=\"2\">Order Cancelled</option><option value=\"3\">Data Entry Mistake</option><option value=\"4\">Others</option></select></div><div class=\"col-sm-2\"><button class=\"btn btn-danger btn-outline dim m-t-md\" name=\"optradio\" mwl-confirm=\"\" title=\"Are you sure ?\" message=\"\" placement=\"top\" on-confirm=\"vm.CancelInvoiceConfirm()\" on-cancel=\"vm.CancelInvoiceCancelled()\" confirm-button-type=\"danger\" cancel-button-type=\"default\"><i class=\"far fa-trash\"></i> Cancel</button></div></div></div></div></div><div class=\"row\"><button class=\"btn btn-success btn-outline dim pull-right\" ng-click=\"vm.GetEwbForInvoice()\" name=\"optradio\" ng-hide=\"vm.formdata.ewayBillNo\" ng-disabled=\"isShowSpinner\"><i class=\"far fa-arrow-down\" ng-hide=\"isShowSpinner\"></i> <i ng-show=\"isShowSpinner\" class=\"far fa-spinner-third fa-spin fa-fw\"></i> Get Eway Bill No</button></div></div></div>");
$templateCache.put("app/eway/master/master.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-sm-6\"><h2>{{vm.MasterName}} Master</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"home.main\">Home</a></li><li class=\"active\"><strong>EwayBill</strong></li></ol></div></div><div class=\"row\" ng-hide=\"vm.Section[4] === \'ValidVehicleNumber\' || vm.Section[4] === \'TaxRates\' ||vm.Section[4] === \'SupplyDocType\'\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content\"><div ag-grid=\"vm.gridOptions\" class=\"ag-theme-balham\" style=\"height: 400px;\"></div></div></div></div><div class=\"row\" ng-show=\"vm.Section[4] === \'ValidVehicleNumber\'\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"table-responsive\"><table class=\"table table-condensed table-bordered\"><thead><th>Valid Formats of Vehicle Numbers</th></thead><tbody><tr><td>AB121234 (First 2 char are State Code)</td></tr><tr><td>AB12A1234 (First 2 char are State Code)</td></tr><tr><td>AB12AB1234 (First 2 char are State Code)</td></tr><tr><td>ABC1234</td></tr><tr><td>AB123A1234 (First 2 char are State Code)</td></tr><tr><td>AB12ABC1234 (First 2 char are State Code)</td></tr><tr><td>DFXXXXXX (Defence Vehicle)</td></tr><tr><td>TMXXXXXXXXXXXXX (Temp RC) At least 7 characters</td></tr><tr><td>BPXXXXXXXXXXXXX (Bhutan Vehicle) At least 7 characters</td></tr><tr><td>NPXXXXXXXXXXXXX (Nepal Vehicle) At least 7 characters</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-show=\"vm.Section[4] === \'TaxRates\'\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"table-responsive\"><table class=\"table table-condensed table-bordered\"><thead><tr><th>CGST (%)</th><th>SGST (%)</th><th>IGST (%)</th><th>CESS – Advol (%)</th><th>CESS - NonAdvol. (Rs.)</th></tr></thead><tbody><tr><td>0</td><td>0</td><td>0</td><td rowspan=\"8\">0 or 1 or 3 or 5 or 11 or<br>12 or 12.5 or 15 or 17 or 20 or<br>21 or 22 or 36 or 49 or 60 or<br>61 or65 or 71 or 72 or 89 or 96 or<br>142 or 160 or 204 or 290</td><td rowspan=\"8\">0 or 400 or 2076 or 2747 or<br>3668 or 4006 or 4170</td></tr><tr><td>0.05</td><td>0.05</td><td>0.1</td></tr><tr><td>0.125</td><td>0.125</td><td>0.25</td></tr><tr><td>1.5</td><td>1.5</td><td>3</td></tr><tr><td>2.5</td><td>2.5</td><td>5</td></tr><tr><td>6</td><td>6</td><td>12</td></tr><tr><td>9</td><td>9</td><td>18</td></tr><tr><td>14</td><td>14</td><td>28</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-show=\"vm.Section[4] === \'SupplyDocType\'\"><div class=\"col-lg-12\"><div class=\"wrapper wrapper-content\"><div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"table-responsive\"><table class=\"table table-condensed table-bordered\"><thead><tr><th>Transaction Type</th><th>Transaction Sub-Type</th><th>Document Type</th><th>From GSTIN (Supplier)</th><th>To GSTIN (Buyer)</th></tr></thead><tbody><tr><td rowspan=\"15\">Outward</td><td>Supply</td><td>Tax Invoice</td><td>Self</td><td>Other GSTIN/URP</td></tr><tr><td></td><td>Bill of Supply</td><td>Self</td><td>Other GSTIN/URP</td></tr><tr><td rowspan=\"2\">Export</td><td>Tax Invoice</td><td>Self</td><td>Other GSTIN/URP</td></tr><tr><td>Bill of Supply</td><td>Self</td><td>Other GSTIN/URP</td></tr><tr><td>Job Work</td><td>Delivery Challan</td><td>Self</td><td>Other GSTIN/URP</td></tr><tr><td rowspan=\"3\">SKD/CKD/Lots</td><td>Tax Invoice</td><td>Self</td><td>Other GSTIN/URP</td></tr><tr><td>Bill of Supply</td><td>Self</td><td>Other GSTIN/URP</td></tr><tr><td>Delivery Challan</td><td>Self</td><td>Other GSTIN/URP</td></tr><tr><td rowspan=\"2\">Recipient not known</td><td>Delivery Challan</td><td>Self</td><td>Self</td></tr><tr><td>Others</td><td>Self</td><td>Self</td></tr><tr><td>For own Use</td><td>Delivery Challan</td><td>Self</td><td>Self</td></tr><tr><td>Exhibition or fairs</td><td>Delivery Challan</td><td>Self</td><td>Self</td></tr><tr><td>Line Sales</td><td>Delivery Challan</td><td>Self</td><td>Self</td></tr><tr><td rowspan=\"2\">Others</td><td>Delivery Challan</td><td>Self</td><td>Self/Other/URP</td></tr><tr><td>Others</td><td>Self</td><td>Self/Other/URP</td></tr><tr><td rowspan=\"13\">Inward</td><td rowspan=\"2\">Supply</td><td>Tax Invoice</td><td>Other GSTIN/URP</td><td>Self</td></tr><tr><td>Bill of Supply</td><td>Other GSTIN/URP</td><td>Self</td></tr><tr><td>Import</td><td>Bill of Entry</td><td>Other GSTIN/URP</td><td>Self</td></tr><tr><td rowspan=\"4\">SKD/CKD/Lots</td><td>Bill of Entry</td><td>URP</td><td>Self</td></tr><tr><td>Tax Invoice</td><td>Other GSTIN/URP</td><td>Self</td></tr><tr><td>Bill of Supply</td><td>Other GSTIN/URP</td><td>Self</td></tr><tr><td>Delivery Challan</td><td>Other GSTIN/URP</td><td>Self</td></tr><tr><td>Job Work Returns</td><td>Delivery Challan</td><td>Other GSTIN/URP</td><td>Self</td></tr><tr><td>Sales Return</td><td>Delivery Challan</td><td>Other GSTIN/URP</td><td>Self</td></tr><tr><td>Exhibition or fairs</td><td>Delivery Challan</td><td>Self</td><td>Self</td></tr><tr><td>For own Use</td><td>Delivery Challan</td><td>Self</td><td>Self</td></tr><tr><td rowspan=\"2\">Others</td><td>Delivery Challan</td><td>Self/Other/URP</td><td>Self</td></tr><tr><td>Others</td><td>Self/Other/URP</td><td>Self</td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/user/profile/userprofile.html","<style>\n  /* Profile Layout */\n  .profile-section {\n    margin-bottom: 40px;\n  }\n\n  .profile-header {\n    display: flex;\n    align-items: center;\n    margin-bottom: 24px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #e7eaec;\n    gap: 12px;\n  }\n\n  .profile-header h2 {\n    margin: 0;\n    font-size: 24px;\n    font-weight: 600;\n    color: #1f2937;\n  }\n\n  .profile-header i {\n    font-size: 24px;\n  }\n\n  /* Profile Card */\n  .profile-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 32px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n  }\n\n  /* Profile Image */\n  .profile-image-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n  }\n\n  .profile-image-container img {\n    width: 130px;\n    height: 130px;\n    object-fit: cover;\n    border-radius: 50%;\n    border: 4px solid #f8fafc;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n    background: #e2e8f0;\n  }\n\n  /* Forms & Inputs */\n  .profile-card .form-group label {\n    font-weight: 600;\n    color: #475569;\n    margin-bottom: 8px;\n    font-size: 13px;\n  }\n\n  .profile-card .form-control {\n    border-radius: 6px;\n    border: 1px solid #cbd5e1;\n    box-shadow: none;\n    padding: 10px 14px;\n    height: auto;\n    transition: all 0.2s;\n  }\n\n  .profile-card .form-control:focus {\n    border-color: #0ea5e9;\n    box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.1);\n  }\n\n  /* Actions */\n  .action-buttons {\n    display: flex;\n    gap: 12px;\n    justify-content: flex-end;\n    margin-top: 24px;\n    padding-top: 24px;\n    border-top: 1px solid #f1f5f9;\n  }\n\n  @media (min-width: 992px) {\n    .profile-col-left {\n      border-right: 1px solid #f1f5f9;\n      padding-right: 24px;\n    }\n\n    .profile-col-right {\n      padding-left: 24px;\n    }\n  }\n</style><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-10 col-md-12\"><div class=\"profile-section\"><div class=\"profile-header\"><i class=\"far fa-user-circle\" style=\"color: #006cb2;\"></i><h2>My Profile</h2></div><div class=\"profile-card\"><div class=\"row\"><div class=\"col-md-4 profile-col-left\"><div class=\"profile-image-container\"><img ng-src=\"{{showProfilPic}}\" alt=\"Profile Image\" fallback-src=\"assets/images/default-avatar.png\"><div class=\"btn btn-primary btn-outline btn-sm\" ng-model=\"vm.newFile1\" ngf-select=\"\" ngf-max-size=\"1MB\" ng-change=\"vm.temp()\"><i class=\"far fa-camera m-r-xs\"></i> Change Photo</div><small class=\"text-muted\">Max file size: 1MB</small></div></div><div class=\"col-md-8 profile-col-right\"><div class=\"row m-b-md\"><div class=\"form-group col-sm-6\"><label>Full Name</label> <input class=\"form-control\" name=\"FullName\" ng-model=\"vm.formdata.FullName\" type=\"text\" maxlength=\"255\"></div><div class=\"form-group col-sm-6\"><label>Email Address</label> <input class=\"form-control\" name=\"EmailId\" ng-model=\"vm.formdata.EmailId\" type=\"text\" maxlength=\"255\"></div></div><div class=\"row m-b-md\"><div class=\"form-group col-sm-6\"><label>Phone Number</label> <input class=\"form-control\" name=\"PhoneNo\" ng-model=\"vm.formdata.PhoneNo\" type=\"number\" maxlength=\"10\"></div><div class=\"form-group col-sm-6\"><label>Designation</label> <input class=\"form-control\" name=\"Designation\" ng-model=\"vm.formdata.UserDesignation\" type=\"text\" maxlength=\"255\"></div></div><div class=\"action-buttons\"><button class=\"btn btn-primary\" tooltip-placement=\"top\" ng-click=\"vm.submitRecord()\"><i class=\"far fa-check m-r-xs\"></i> Save Profile</button></div></div></div></div></div><div class=\"profile-section\"><div class=\"profile-header\"><i class=\"far fa-shield-alt\" style=\"color: #0d9488;\"></i><h2>Security</h2></div><div class=\"profile-card\"><div class=\"row m-b-md\"><div class=\"form-group col-sm-4\"><label>Old Password</label> <input class=\"form-control\" name=\"oldPwd\" ng-model=\"vm.formdata.oldPwd\" type=\"password\"></div><div class=\"form-group col-sm-4\"><label>New Password</label> <input class=\"form-control\" name=\"newPwd\" ng-model=\"vm.formdata.newPwd\" type=\"password\"></div><div class=\"form-group col-sm-4\"><label>Confirm Password</label><input class=\"form-control\" name=\"confirmPwd\" ng-model=\"vm.formdata.newPwd\" type=\"password\"></div></div><div class=\"action-buttons\"><button class=\"btn btn-default btn-outline\" tooltip-placement=\"top\" ng-click=\"vm.cancelForm()\">Cancel</button> <button class=\"btn btn-primary\" tooltip-placement=\"top\" ng-click=\"vm.submitRecord()\"><i class=\"far fa-check m-r-xs\"></i> Update Password</button></div></div></div></div></div></div>");}]);